import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Select from "react-select";
import {
  formatDate,
  formatDateDDMMYYYY,
  formattedDate,
  formattedDateLong,
  formatDateTime,
} from "../Date";
import {
  BASE_URL,
  FRONTEND_URL,
  TESTING_URL,
  IMAGE_URL,
} from "../../config/axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { ToastContainer, toast } from "react-toastify";
import { customSortByKey, downloadAsExcel, formatCurrencyIndian, formatRoundoff2D, formatRoundoffComplete, getMonthNameFromDate, getMonthYearNameFromDate, handleAllError, handleErrorToast } from "../CustomFunctions";
import { Active, Calender, CircularGrid, DownloadIcon, Employee, Eye, Office, Search, SearchBig, Sort, UpdatePencil, Filter, DocumentIcon, InfoIcon, Tripledot, Refresh, CalenderEdit, ChartIcon } from "../AllSvg";
import { BulkUpdateSalaryDataWithLog, RunPayRollWithLog, PayrunOperationResultModal, MultipleBulkApiResultSummaryModal } from "../UserDetails/userDetails-comp/SalaryStructureComponents";
import usePermission from "../../config/permissions";
import {
  EditIncrementData,
  TdsCalculationModal,
  UploadIncrementDataBulk,
  TdsCalculationModalForTDS,
} from "./PayrollComponent";
import Loader from "../Loader";
import {
  CSSForDropdownFilter2,
  CSSForFilterDropdown,
} from "../CustomUtilities";
import {
  DateRangePicker,
  CustomImageModal,
  CustomTooltip,
  getMonthName,
} from "../CustomFunctions";
import UserDefaultLogo from "../UserDetails/UserDefaultLogo";

const PayRollTable = () => {
  const [departmentname, setDepartmentname] = useState([]);
  // const [designationname, setDesignationname] = useState([]);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const filterState = location.state;

  const [detailsView, setDetailsView] = useState(true);
  const [empDetailsView, setEmpDetailsView] = useState(true);
  const [standardView, setStandardView] = useState(false);
  const [roundOffAmount, setRoundOffAmount] = useState(true);

  const [buffer, setBuffering] = useState(false);
  const [buffer1, setBuffering1] = useState(false);
  const [payrollData, setPayrollData] = useState([]);
  const [payrollDatafiltered, setPayrollDatafiltered] = useState([]);
  const [salaryHeadings, setSalaryHeadings] = useState([]);
  const [toggleSubCompany, setToggleSubCompany] = useState(
    filterState?.filter_subCompany || sessionStorage.getItem("company_id"),
  );

  const [showViewOptions, setShowViewOptions] = useState(false);
  const [subCompanyFromPayroll, setSubCompanyFromPayroll] = useState();
  const [payrollTotalDays, setPayrollTotalDays] = useState(null);
  const today = new Date();
  // today.setDate(today.getDate() - 1);

  const currentMonth = (today.getMonth() + 1).toString();
  const currentYear = today.getFullYear().toString();
  const incomingMonth =
    location.state?.toggleincomingmonth !== undefined &&
    location.state?.toggleincomingmonth !== null
      ? location.state.toggleincomingmonth.toString()
      : currentMonth;

  const incomingYear =
    location.state?.toggleincomingyear !== undefined &&
    location.state?.toggleincomingyear !== null
      ? location.state.toggleincomingyear.toString()
      : currentYear;

  const [selectedName, setName] = useState(filterState?.filter_Name || "");
  const [selectedDep, setDep] = useState(filterState?.filter_Department || "");
  const [selectedDesi, setDesi] = useState(
    filterState?.filter_Designation || "",
  );
  const [selectedCostCenter, setCostCenter] = useState(
    filterState?.filter_CostCenter || "",
  );
  const [active, setActive] = useState(filterState?.filter_status || "active");
  const [selectedDataType, setSelectedDataType] = useState(filterState?.filter_DataType || "not_saved");
  const [startMonth, setStartMonth] = useState(filterState?.filter_Month || currentMonth);
  const [startYear, setStartYear] = useState(filterState?.filter_Year || currentYear);
  // const [payrollPeriodLabel, setPayrollPeriodLabel] = useState("");
  // const [active, setActive] = useState('active');
  const [payrollDates, setPayrollDates] = useState({
    startDate: "",
    endDate: "",
  });


  const getDepartmentAndDesignation = async () => {
    setBuffering1(true);
    try {
      const dep = await axios.get(`${BASE_URL}/wfm/department/`);
      setDepartmentname(dep.data);
      // const des = await axios.get(`${BASE_URL}/wfm/designation/`);
      // setDesignationname(des.data);
    } catch (err) {
      console.error("Error fetching departments/designations", err);
    } finally {
      setBuffering1(false);
    }
  };

  const getSalarylist = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(`${BASE_URL}/wfm/optimized-upcoming-and-saved-salaryslips-filtered-v3/${toggleSubCompany}/${active}/${startMonth}/${startYear}/`);
      const sortedList = customSortByKey(res?.data?.payroll_data, "emp_code");
      setPayrollData(sortedList);
      setSubCompanyFromPayroll(res?.data?.sub_company);

      // if (sortedList.length > 0) {
      //   setSalaryHeadings(sortedList[0].deduction_details?.sort((a, b) => a.sorting_var - b.sorting_var).map(d => d.name));
      // }

      if (sortedList.length > 0) {
        // Collect all unique salary headings with their sorting_vars
        const headingMap = new Map(); // Use Map to store name -> sorting_var

        sortedList.forEach((emp) => {
          // Add headings from current salary calculation
          if (emp.current_salary_calculation?.deduction_details) {
            emp.current_salary_calculation.deduction_details.forEach((item) => {
              // if (item.name && item.salaryslip && item.sorting_var !== undefined) {
              if (item.name && item.sorting_var !== undefined) {
                // Store the lowest sorting_var for each heading
                if (
                  !headingMap.has(item.name) ||
                  parseInt(item.sorting_var) <
                    parseInt(headingMap.get(item.name))
                ) {
                  headingMap.set(item.name, parseInt(item.sorting_var));
                }
              }
            });
          }

          // Add headings from saved salary data
          if (emp.saved_salary_data?.salary_data?.deduction_details) {
            emp.saved_salary_data.salary_data.deduction_details.forEach(item => {
              // if (item.name && item.salaryslip && item.sorting_var !== undefined) {
              if (item.name && item.sorting_var !== undefined) {
                // Store the lowest sorting_var for each heading
                if (!headingMap.has(item.name) || parseInt(item.sorting_var) < parseInt(headingMap.get(item.name))) {
                  headingMap.set(item.name, parseInt(item.sorting_var));
                }
              }
            });
          }
        });
        setPayrollDates({
          startDate: res.data.payroll_start_date,
          endDate: res.data.payroll_end_date,
        });
        setPayrollTotalDays(res.data.payroll_total_days);
        // Convert to array and sort by sorting_var
        const headingsArray = Array.from(headingMap.entries()); // [['Basic Salary', 1], ['HRA', 2], ...]
        // Sort by sorting_var, then by name if sorting_var is same
        const sortedHeadings = headingsArray
          .sort((a, b) => {
            // First sort by sorting_var
            const sortDiff = a[1] - b[1];
            if (sortDiff !== 0) return sortDiff;
            // If same sorting_var, sort by name
            return a[0].localeCompare(b[0]);
          })
          .map((entry) => entry[0]); // Extract just the names

        setSalaryHeadings(sortedHeadings);
      }
    } catch (err) {
      handleAllError(err);
    } finally {
      setBuffering(false);
    }
  };

  // const [startMonth, setStartMonth] = useState(incomingMonth);
  // const [startYear, setStartYear] = useState(incomingYear);

  const [endMonth, setEndMonth] = useState(currentMonth);
  const [endYear, setEndYear] = useState(currentYear);

  const startDateValue = `${startYear}-${startMonth.padStart(2, "0")}`;
  const endDateValue = `${endYear}-${endMonth.padStart(2, "0")}`;

  // const [selectedName, setName] = useState("");
  // const [selectedDep, setDep] = useState("");
  // const [selectedDesi, setDesi] = useState("");
  // const [selectedCostCenter, setCostCenter] = useState("");
  const [selectedDivision, setSelectedDivision] = useState(
    sessionStorage.getItem("company"),
  );
  // const [selectedDataType, setSelectedDataType] = useState("summary");
  // const [selectedDataType, setSelectedDataType] = useState("not_saved");

  const applyFilters = () => {
    let filteredData = payrollData;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();
      filteredData = filteredData.filter((emp_payroll) => {
        const nameMatch = emp_payroll?.employee_details?.emp_name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const codeMatch = emp_payroll?.employee_details?.emp_code
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return nameMatch || codeMatch;
      });
    }

    if (selectedDep) {
      filteredData = filteredData.filter(
        (emp_payroll) =>
          emp_payroll?.employee_details?.department_name === selectedDep,
      );
    }

    if (selectedDesi) {
      const lowercaseSelectedName = selectedDesi.toLowerCase();

      filteredData = filteredData.filter((emp_payroll) => {
        const desiMatch = emp_payroll?.employee_details?.designation_name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return desiMatch;
      });
    }

    if (selectedCostCenter) {
      filteredData = filteredData.filter(
        (emp_payroll) =>
          emp_payroll?.employee_details?.cost_center_assets ===
          selectedCostCenter,
      );
    }

    setPayrollDatafiltered(filteredData);
  };

  useEffect(() => {
    getDepartmentAndDesignation();
    getSalarylist();
  }, [toggleSubCompany, active, startMonth, startYear]);

  useEffect(() => {
    applyFilters();
  }, [
    selectedName,
    selectedDep,
    selectedDesi,
    payrollData,
    selectedCostCenter,
  ]);

  const refreshdata = async () => {
    setBuffering(true);
    await getSalarylist();
    setBuffering(false);
  };

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const baseUrl = "/" + urlParts[3] + "/salarySlip";

  const currentSlipUrl = "/" + urlParts[3] + "/upcomingSalarySlip";
  const savedSlipUrl = "/" + urlParts[3] + "/dynamicSalarySlip";
  let slip_opener = "monthlyslip";

  // const ViewCurrentSalarySlip = (i, monthh, yearr) => {
  //   navigate(currentSlipUrl, { state: { i, monthh, yearr } });
  // };

  const filters = {
    selectedName,
    selectedDep,
    selectedDesi,
    selectedCostCenter,
    active,
    selectedDataType,
    startMonth,
    startYear,
    subCompany: toggleSubCompany,
  };

  const ViewCurrentSalarySlip = (i, monthh, yearr) => {
    navigate(currentSlipUrl, {
      //   i,
      state: {
        i: {
          ...i,
          sub_company_id: subCompanyFromPayroll,
        },
        monthh,
        yearr,
        filters,
      },
    });
  };

  // const ViewSavedSalarySlip = (i, monthh, yearr) => {
  //   navigate(savedSlipUrl, { state: { i, monthh, yearr, slip_opener } });
  // };
  const ViewSavedSalarySlip = (i, monthh, yearr) => {
    navigate(savedSlipUrl, {
      //   i,
      state: {
        i: {
          ...i,
          sub_company_id: subCompanyFromPayroll, // map it explicitly
        },
        monthh,
        yearr,
        slip_opener,
        filters,
      },
    });
  };

  const tableRef = useRef(null);
  const handleDownloadPayRunSheet = () => {
    downloadAsExcel(
      tableRef,
      "users",
      // `PayRollSheet - ${startMonth} - ${startYear}`,
      `PayRollSheet - ${payrollDates.startDate} - ${payrollDates.endDate}`,
      // selectedDivision === "" ? `PayRunSheet - ${monthh} - ${yearr}` : `${selectedDivision} - PayRunSheet - ${monthh} - ${yearr}`,
      {
        applyRowStyles: true,
        // styleCondition: (row) => row.getAttribute('data-status') === 'inactive',
        styleCondition: (emp_payroll) =>
          emp_payroll?.employee_details?.employee_status === "inactive",
        styleProps: { font: { color: { rgb: "FF0000" } } },
      },
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowViewOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500    font-size-heading"></div>
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              {/* <Calender /> */}

              <input
                type="month"
                className="attendance-input-field calender-input width-10vw"
                value={startDateValue}
                max={endDateValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    const [year, month] = value.split("-");
                    setStartYear(year);
                    setStartMonth(month.replace(/^0+/, ""));
                  }
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div gap-3px">
              <Office />
              <select
                className="attendance-input-field width-15vw date-field"
                type="text"
                onChange={(e) => setToggleSubCompany(e.target.value)}
                value={toggleSubCompany}
              >
                <option value="null">Select Sub Company</option>
                {SUB_COMPANIES.map((company) => (
                  <option value={company.id}>{company.title}</option>
                ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-15vw"
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All Employees</option>
                <option value="active">Active Employees</option>
                <option value="inactive">Inactive Employees</option>
              </select>
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              {buffer1 ? (
                <div className="spinner-vsmall"></div>
              ) : (
                <CircularGrid />
              )}

              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={selectedDep}
                onChange={(e) => setDep(e.target.value)}
              >
                <option value=""> All Department</option>
                {departmentname
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.title}>{i.title}</option>
                  ))}
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-15vw  "
                placeholder="Designation"
                type="text"
                value={selectedDesi}
                onChange={(e) => setDesi(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-15vw"
                placeholder="Code / Name"
                type="text"
                value={selectedName}
                onChange={(e) => setName(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            {detailsView && (
              <div className="field-cont-div">
                <Employee />
                <select
                  className="attendance-input-field width-10vw"
                  type="text"
                  value={selectedCostCenter}
                  onChange={(e) => setCostCenter(e.target.value)}
                >
                  <option value="">All Cost Center</option>
                  <option value="employee">Employee</option>
                  <option value="currentasset">Current Asset</option>
                  <option value="fixedasset">Fixed Asset</option>
                </select>
                <hr className="field-cont-hr" />
              </div>
            )}

            <div className="field-cont-div">
              <Filter />

              <select
                className="attendance-input-field width-10vw"
                type="text"
                value={selectedDataType}
                onChange={(e) => setSelectedDataType(e.target.value)}
              >
                {/* <option value="summary">Summary</option> */}
                <option value="not_saved">Not Saved (live)</option>
                <option value="saved">Saved</option>
                {/* <option value="both">Both</option> */}
              </select>
              <hr className="field-cont-hr" />
            </div>
          </div>
          <div className="btn-cont">
            {/* // Run Payroll for the month */}
            <RunPayRollWithLog
              getPayrunlist={getSalarylist}
              year={startYear}
              month={startMonth}
            />
            {/* // Bulk upload salary structure for the month */}
            <BulkUpdateSalaryDataWithLog getPayrunlist={getSalarylist} />
            <button
              className=" model-button-print"
              title="Download in Excel Format"
              onClick={handleDownloadPayRunSheet}
            >
              <DownloadIcon />
            </button>
          </div>
        </div>
      </div>

      <div className="custom-table-width">
        <div className="table-heading-flex">
          {/* <div className="repo-heading font-weight500 mb-0 font-size-heading">
            Employee Payrolls {" "}<span>(<span>
              {formatDate(payrollDates.startDate)} - {formatDate(payrollDates.endDate)}
            </span>)</span>
          </div> */}
          <div className="flex-column gap-1">
            <div className="repo-heading font-weight500 mb-0 font-size-heading">
              Employee Payrolls{" "}

            </div>

            {/* Three info pills */}
            <div className="flex-row gap-2" style={{ flexWrap: "wrap" }}>
              <span className="color-badge-white" style={{ padding: "3px 10px", borderRadius: "12px", fontSize: "14px" }}>
                <CalenderEdit /> <b>Payroll Month:</b>{" "}
                {new Date(startYear, startMonth - 1).toLocaleString("default", { month: "long" })}{" "}{startYear}
              </span>

              <span className="color-badge-white" style={{ padding: "3px 10px", borderRadius: "12px", fontSize: "14px" }}>
                <Calender /> <b>Payroll Period:</b>{" "}
                {formatDate(payrollDates.startDate)} - {formatDate(payrollDates.endDate)}
              </span>

              <span className="color-badge-white" style={{ padding: "3px 10px", borderRadius: "12px", fontSize: "14px" }}>
                <ChartIcon /> <b>Base Days:</b> {payrollTotalDays ?? "—"}
              </span>
            </div>
          </div>


          <div className="flex-row gap-2 relative" ref={dropdownRef}>
            <button
              type="button"
              onClick={() => setShowViewOptions(!showViewOptions)}
              className="flex-row color-badge-white "
              style={{ padding: "5px" }}
            >
              <span className="font-weight500" style={{ marginRight: "5px" }}>
                Display Options
              </span>
              <Filter />
            </button>

            {buffer ? (
              <div className="spinner-vsmall"></div>
            ) : (
              <div
                className="refresh-button"
                onClick={refreshdata}
                disabled={buffer}
              >
                <Refresh />
              </div>
            )}

            {showViewOptions && (
              <div
                className="absolute mt-2  color-badge-white border  shadow-lg p-3 z-index-1000 "
                style={{ minWidth: "15vw", top: "26px", right: "43px" }}
              >
                <div className="items mb-3">
                  <label className="form-labels font-weight500">
                    Employee Details
                  </label>
                  <div className="checkbox-toggle">
                    <input
                      type="checkbox"
                      id="empToggle"
                      checked={empDetailsView}
                      onChange={() => setEmpDetailsView(!empDetailsView)}
                    />
                    <label htmlFor="empToggle"></label>
                  </div>
                </div>

                {/* Bank Details Toggle */}
                <div className="items mb-3">
                  <label className="form-labels font-weight500">
                    Bank Details
                  </label>
                  <div className="checkbox-toggle">
                    <input
                      type="checkbox"
                      id="toggle2"
                      checked={detailsView}
                      onChange={() => setDetailsView(!detailsView)}
                    />
                    <label htmlFor="toggle2"></label>
                  </div>
                </div>

                {/* Round Off Toggle */}
                <div className="items mb-3">
                  <label
                    className="form-labels font-weight500"
                    title={
                      roundOffAmount
                        ? "Rounded Off (0.5+) to next"
                        : "Actual till 2 Decimal Places"
                    }
                  >
                    Amount Rounded Off
                  </label>
                  <div className="checkbox-toggle">
                    <input
                      type="checkbox"
                      id="toggle-roundoff"
                      checked={roundOffAmount}
                      onChange={() => setRoundOffAmount(!roundOffAmount)}
                    />
                    <label htmlFor="toggle-roundoff"></label>
                  </div>
                </div>

                {/* Standard Values Toggle */}
                <div className="items">
                  <label className="form-labels font-weight500">
                    Standard Values
                  </label>
                  <div className="checkbox-toggle">
                    <input
                      type="checkbox"
                      id="toggle1"
                      checked={standardView}
                      onChange={() => setStandardView(!standardView)}
                    />
                    <label htmlFor="toggle1"></label>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* <div className="global-whitebg-table"> */}
        <div className="scrollfix-wrapper table-css-white-background scroll-container-table bank-details">
          <table
            ref={tableRef}
            className="scrollfix-table-css table-css table-column-seperator "
          >
            <thead style={{ top: "-11px" }}>
              <tr className="custom-table-head-tr">
                <th className="align-left">Payroll Status</th>
                <th className="align-left">Emp Code</th>
                <th className="align-center">Name</th>
                {empDetailsView && (
                  <>
                    <th className="align-center">Department</th>
                    <th className="align-center">Designation</th>
                    <th className="align-center">Reporting Head</th>
                    <th className="align-center">Employee Status</th>
                    <th className="align-center">Joining Date</th>
                    <th className="align-center">Cost Center</th>
                  </>
                )}
                {detailsView && (
                  <>
                    <th className="align-center">Account No.</th>
                    <th className="align-center">IFSC</th>
                    <th className="align-center width-10vw">Bank</th>
                  </>
                )}

                {/* {standardView ? salaryHeadings?.sort((a, b) => a.sorting_var - b.sorting_var)
                  .map((heading, idx) => (
                    <th key={idx} className="align-center width-5vw">Standard {heading}</th>
                  )) : null} */}
                {standardView
                  ? salaryHeadings.map((heading, idx) => (
                      <th key={idx} className="align-center width-5vw">
                        Standard {heading}
                      </th>
                    ))
                  : null}

                <th className="align-center">Pay Days</th>

                {/* {salaryHeadings?.sort((a, b) => a.sorting_var - b.sorting_var)
                  .map((heading, idx) => (
                    <th key={idx} className="align-center width-5vw">{heading}</th>
                  ))} */}
                {salaryHeadings.map((heading, idx) => (
                  <th key={idx} className="align-center width-5vw">
                    {heading}
                  </th>
                ))}

                <th className="align-center">
                  Final Monthly Salary (without TDS)
                </th>
                <th className="align-center">Arrear amount</th>
                <th className="align-center">Monthly TDS amount</th>

                <th className="align-center">View Slip</th>
              </tr>
            </thead>
            {buffer ? (
              <Loader container={true} />
            ) : (
              // <div className="spinner"></div>
              <tbody>
                {payrollDatafiltered.map((emp_payroll, index) => {
                  const safeNumber = (val) => Number(val) || 0;

                  const savedArrearRaw =
                    emp_payroll?.saved_tax_info?.calculation_tax_details
                      ?.current_arrear_details || {};

                  const savedArrear = {
                    totalDays: safeNumber(savedArrearRaw?.arrear_approved_days),
                    approvedAmount: safeNumber(
                      savedArrearRaw?.arrear_approved_amount,
                    ),
                    calculatedAmount: safeNumber(
                      savedArrearRaw?.total_arrear_amount,
                    ),
                    nature: null,
                    status: null,
                    perDaySalary: null,
                  };

                  const currentArrearRaw =
                    emp_payroll?.current_salary_calculation?.arrear_details ||
                    {};
                  const CurrenttotalArrearAmount =
                    currentArrearRaw?.total_arrear_amount || 0;

                  const totalArrearAmount =
                    savedArrearRaw?.total_arrear_amount || 0;

                  const arrearInfo = currentArrearRaw?.arrear_info || {};
                  const calcDetails =
                    arrearInfo?.arrear_details?.arrear_request_details
                      ?.calculation_details || [];

                  const firstCalc =
                    calcDetails[0] ||
                    arrearInfo?.arrear_details?.arrear_request_details
                      ?.request_details;

                  const perDaySalary =
                    firstCalc?.ef_salary_final_amount &&
                    firstCalc?.total_days_of_month
                      ? safeNumber(firstCalc.ef_salary_final_amount) /
                        safeNumber(firstCalc.total_days_of_month)
                      : 0;

                  const Row = ({ label, value }) => (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>{label}</span>
                      <strong className="text-capitalize">{value}</strong>
                    </div>
                  );

                  const currentArrear = {
                    totalDays: safeNumber(arrearInfo?.arrear_approved_days),
                    approvedAmount: safeNumber(
                      arrearInfo?.arrear_approved_amount,
                    ),
                    calculatedAmount: safeNumber(
                      currentArrearRaw?.total_arrear_amount,
                    ),
                    nature:
                      arrearInfo?.arrear_details?.arrear_request_details
                        ?.request_details?.nature_name || null,
                    status:
                      arrearInfo?.arrear_details?.arrear_request_details
                        ?.request_details?.status || null,
                    perDaySalary,
                  };

                  const ArrearTooltip = ({ data }) => {
                    console.log(data, "data");

                    if (!data) return null;

                    return (
                      <div
                        style={{
                          padding: "12px 14px",
                          fontSize: "13px",
                          lineHeight: "1.6",
                          minWidth: "280px",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: 600,
                            marginBottom: 8,
                            borderBottom: "1px solid #eee",
                            paddingBottom: 6,
                          }}
                        >
                          Arrear Calculation
                        </div>

                        {data.nature && (
                          <Row label="Nature" value={data.nature} />
                        )}

                        {data.totalDays > 0 && (
                          <Row
                            label="Approved Days"
                            value={`${data.totalDays.toLocaleString("en-IN")} days`}
                          />
                        )}

                        {data.approvedAmount > 0 && (
                          <Row
                            label="Approved Amount"
                            value={`₹${data.approvedAmount.toLocaleString("en-IN")}`}
                          />
                        )}

                        {/* {data.perDaySalary > 0 && (
                          <Row
                            label="Per Day Salary"
                            value={`₹${data.perDaySalary.toLocaleString("en-IN")}`}
                          />
                        )} */}

                        {data.calculatedAmount > 0 && (
                          <Row
                            label="Calculated Amount"
                            value={`₹${data.calculatedAmount.toLocaleString("en-IN")}`}
                          />
                        )}

                        {data.status && (
                          <Row label="Status" value={data.status} />
                        )}
                      </div>
                    );
                  };

                  // ----------------------arrear details for current tax data(not saved)
                  // const Currentarrear_details = emp_payroll?.current_salary_calculation?.arrear_details;

                  // const CurrenttotalDays = Currentarrear_details?.arrear_info?.arrear_approved_days || 0;
                  // const CurrenttotalAmount = Currentarrear_details?.arrear_info?.arrear_approved_amount || 0;
                  // const CurrenttotalArrearAmount =
                  //   Currentarrear_details?.total_arrear_amount || 0;

                  // const calculationDetails =
                  //   Currentarrear_details?.arrear_info
                  //     ?.arrear_details
                  //     ?.arrear_request_details
                  //     ?.calculation_details || [];

                  // // take first month safely
                  // const firstCalc = calculationDetails[0] || null;

                  // const finalAmount = firstCalc?.ef_salary_final_amount || 0;
                  // const totalDaysOfMonth = firstCalc?.total_days_of_month || 0;

                  // const perDaySalary =
                  //   finalAmount && totalDaysOfMonth
                  //     ? finalAmount / totalDaysOfMonth
                  //     : 0;

                  // const monthYearLabel =
                  //   calculationDetails.length > 1
                  //     ? `${calculationDetails[0].month}/${calculationDetails[0].year} - ${calculationDetails.at(-1).month
                  //     }/${calculationDetails.at(-1).year}`
                  //     : firstCalc
                  //       ? `${firstCalc.month}/${firstCalc.year}`
                  //       : "";

                  // const CurrentArreartooltipContent = (
                  //   <div
                  //     style={{
                  //       padding: "12px 14px",
                  //       fontSize: "13px",
                  //       lineHeight: "1.6",
                  //       minWidth: "280px",
                  //     }}
                  //   >
                  //     {/* Header */}
                  //     {monthYearLabel && (
                  //       <div
                  //         style={{
                  //           fontWeight: 600,
                  //           marginBottom: 8,
                  //           borderBottom: "1px solid #eee",
                  //           paddingBottom: 6,
                  //         }}
                  //       >
                  //         Arrear Calculation {monthYearLabel}
                  //       </div>
                  //     )}

                  //     {/* Nature */}
                  //     <div style={{ display: "flex", justifyContent: "space-between" }}>
                  //       <span>Nature</span>
                  //       <strong className="text-capitalize">
                  //         {Currentarrear_details?.arrear_info?.arrear_details
                  //           ?.arrear_request_details?.request_details
                  //           ?.nature_name || "-"}
                  //       </strong>
                  //     </div>

                  //     {/* Approved Days */}
                  //     {CurrenttotalDays > 0 && (
                  //       <div style={{ display: "flex", justifyContent: "space-between" }}>
                  //         <span>Approved Days</span>
                  //         <strong>{CurrenttotalDays} days</strong>
                  //       </div>
                  //     )}

                  //     {/* Approved Amount */}
                  //     {CurrenttotalAmount > 0 && (
                  //       <div style={{ display: "flex", justifyContent: "space-between" }}>
                  //         <span>Approved Amount</span>
                  //         <strong>₹{CurrenttotalAmount.toLocaleString("en-IN")}</strong>
                  //       </div>
                  //     )}

                  //     {/* Per Day Salary */}
                  //     {perDaySalary > 0 && (
                  //       <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
                  //         <span>Per Day Salary</span>
                  //         <strong>₹{perDaySalary.toLocaleString("en-IN")}</strong>
                  //       </div>
                  //     )}

                  //     {/* Calculated Amount */}
                  //     {CurrenttotalArrearAmount > 0 && (
                  //       <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
                  //         <span>Calculated Amount</span>
                  //         <strong>₹{CurrenttotalArrearAmount.toLocaleString("en-IN")}</strong>
                  //       </div>
                  //     )}

                  //     {/* Status */}
                  //     <div
                  //       style={{
                  //         marginTop: 8,
                  //         display: "flex",
                  //         justifyContent: "space-between",
                  //       }}
                  //     >
                  //       <span>Status</span>
                  //       <strong className="text-capitalize">
                  //         {Currentarrear_details?.arrear_info?.arrear_details
                  //           ?.arrear_request_details?.request_details
                  //           ?.status || "-"}
                  //       </strong>
                  //     </div>
                  //   </div>
                  // );

                  // monthly tds detail for saved data (saved)
                  const SavedMonthlyTds_details = emp_payroll?.saved_tax_info?.calculation_tax_details;
                  const CurrentMonthlyTds_details = emp_payroll?.current_salary_calculation?.tax_details;

                  // ----------------------arrear details for saved tax data(saved)
                  // const arrear_details = emp_payroll?.saved_tax_info?.calculation_tax_details?.current_arrear_details;

                  // const totalDays = arrear_details?.arrear_approved_days || 0;
                  // const totalAmount = arrear_details?.arrear_approved_amount || 0;
                  // const totalArrearAmount =
                  //   arrear_details?.total_arrear_amount || 0;

                  // const hasDays = totalDays > 0;
                  // const hasAmount = totalAmount > 0;
                  // //tooltip content for arrear
                  // const ArreartooltipContent = (
                  //   <div
                  //     style={{
                  //       padding: "12px",
                  //       fontSize: "13px",
                  //       lineHeight: "1.8",
                  //       minWidth: "260px",
                  //     }}
                  //   >
                  //     {hasDays && (
                  //       <div style={{ display: "flex", justifyContent: "space-between" }}>
                  //         <span>Total Days:</span>
                  //         <strong>{totalDays.toLocaleString("en-IN")} days</strong>
                  //       </div>
                  //     )}

                  //     {hasAmount && (
                  //       <div style={{ display: "flex", justifyContent: "space-between" }}>
                  //         <span>Total Amount:</span>
                  //         <strong>
                  //           ₹{totalAmount.toLocaleString("en-IN")}
                  //         </strong>
                  //       </div>
                  //     )}

                  //   </div>
                  // );

                  return (
                    <>
                      {/* // Current/Live Calculation Payrolls >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */}
                      {selectedDataType === "both" ||
                      selectedDataType === "not_saved" ||
                      (selectedDataType === "summary" &&
                        !emp_payroll?.has_salary_saved) ? (
                        <tr
                          key={index}
                          style={{
                            color:
                              emp_payroll?.employee_details?.employee_status ===
                              "inactive"
                                ? "#ff1212"
                                : "black",
                          }}
                          data-status={
                            emp_payroll?.employee_details?.employee_status
                          }
                          className={
                            emp_payroll?.employee_details?.employee_status ===
                            "inactive"
                              ? "notapproved-exceeded-row"
                              : ""
                          }
                        >
                          <td className="align-left">
                            {/* <span className={`status-badge ${selectedDataType === "saved" ? "color-badge-success" : "color-badge-warning"} `}> Saved </span> */}
                            <span
                              className={`status-badge color-badge-warning `}
                            >
                              Not Saved
                            </span>
                          </td>
                          <td
                            rowSpan={selectedDataType === "both" ? 2 : 1}
                            className="align-left"
                          >
                            {emp_payroll.emp_code}
                          </td>
                          <td
                            rowSpan={selectedDataType === "both" ? 2 : 1}
                            className="align-center"
                          >
                            {emp_payroll?.employee_details?.emp_name || "-"}
                          </td>
                          {empDetailsView ? (
                            <>
                              <td
                                rowSpan={selectedDataType === "both" ? 2 : 1}
                                className="align-center"
                              >
                                {emp_payroll?.employee_details
                                  ?.department_name || "-"}
                              </td>
                              <td
                                rowSpan={selectedDataType === "both" ? 2 : 1}
                                className="align-center"
                              >
                                {emp_payroll?.employee_details
                                  ?.designation_name || "-"}
                              </td>
                              <td
                                rowSpan={selectedDataType === "both" ? 2 : 1}
                                className="align-center"
                              >
                                <>
                                  {/* <CustomImageModal customStyle>
                                  {emp_payroll?.employee_details?.reporting_head_profile_pic ? (
                                    <img
                                      src={`${`${IMAGE_URL}${emp_payroll?.employee_details?.reporting_head_profile_pic}`}`}
                                      alt="profile" className="profile-img"
                                    />
                                  ) : (
                                    <UserDefaultLogo user={{ name: emp_payroll?.employee_details?.reporting_head_name, profilepic: emp_payroll?.employee_details?.reporting_head_profile_pic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                  )}
                                </CustomImageModal> */}
                                  <p>
                                    {
                                      emp_payroll?.employee_details
                                        ?.reporting_head_name
                                    }
                                  </p>
                                </>
                              </td>
                              <td
                                rowSpan={selectedDataType === "both" ? 2 : 1}
                                className="align-center text-capitalize"
                              >
                                {emp_payroll?.employee_details
                                  .employee_status || "-"}
                              </td>
                              <td
                                rowSpan={selectedDataType === "both" ? 2 : 1}
                                className="align-center"
                              >
                                {emp_payroll?.employee_details?.joining_date
                                  ? formattedDateLong(
                                      emp_payroll?.employee_details
                                        ?.joining_date,
                                    )
                                  : "-"}
                              </td>
                              <td
                                rowSpan={selectedDataType === "both" ? 2 : 1}
                                className="align-center text-capitalize"
                              >
                                {emp_payroll?.employee_details
                                  ?.cost_center_assets || "-"}
                              </td>
                            </>
                          ) : null}
                          {detailsView ? (
                            <>
                              <td
                                rowSpan={selectedDataType === "both" ? 2 : 1}
                                className="align-center"
                              >
                                {emp_payroll?.bank_details?.account_number ||
                                  "-"}
                              </td>
                              <td
                                rowSpan={selectedDataType === "both" ? 2 : 1}
                                className="align-center"
                              >
                                {emp_payroll?.bank_details?.ifsc_code || "-"}
                              </td>
                              <td
                                rowSpan={selectedDataType === "both" ? 2 : 1}
                                className="align-center width-10vw"
                              >
                                {emp_payroll?.bank_details?.bank_name} -
                                <span className="width-10vw">
                                  {emp_payroll?.bank_details?.branch_address}
                                </span>
                              </td>
                            </>
                          ) : null}

                          {!emp_payroll?.current_salary_calculation
                            ?.has_salary_calculation ? (
                            <td
                              colSpan={
                                standardView
                                  ? salaryHeadings.length * 2 + 3
                                  : salaryHeadings.length + 3
                              }
                              className="align-center error-message"
                            >
                              <div className="flex-row justify-center align-center">
                                {/* <span className="error-icon"></span> */}
                                <span>
                                  {
                                    emp_payroll?.current_salary_calculation
                                      ?.error
                                  }
                                </span>
                              </div>
                            </td>
                          ) : (
                            <>
                              {standardView
                                ? salaryHeadings.map((heading, idx) => {
                                    // Get deduction details from saved data
                                    const deductionDetails =
                                      emp_payroll?.current_salary_calculation
                                        ?.deduction_details || [];
                                    const sortedDeductions =
                                      deductionDetails.sort((a, b) => {
                                        const sortA =
                                          a.sorting_var !== undefined
                                            ? parseInt(a.sorting_var)
                                            : 999;
                                        const sortB =
                                          b.sorting_var !== undefined
                                            ? parseInt(b.sorting_var)
                                            : 999;
                                        return sortA - sortB;
                                      });
                                    // Find the specific heading
                                    const deduction = sortedDeductions.find(
                                      (d) => d.name === heading,
                                    );
                                    return (
                                      <td
                                        key={idx}
                                        className="align-center width-5vw"
                                      >
                                        {deduction &&
                                        deduction.standard_amount !==
                                          undefined &&
                                        deduction.standard_amount !== "---"
                                          ? roundOffAmount
                                            ? formatRoundoffComplete(
                                                parseFloat(
                                                  deduction.standard_amount,
                                                ) || 0,
                                              )
                                            : formatRoundoff2D(
                                                parseFloat(
                                                  deduction.standard_amount,
                                                ) || 0,
                                              )
                                          : "-"}
                                      </td>
                                    );
                                  })
                                : null}
                              <td
                                className="align-center"
                                title={`${emp_payroll?.current_salary_calculation?.total_paid_days ?? "-"}/${emp_payroll?.current_salary_calculation?.total_days ?? "-"}`}
                              >
                                {emp_payroll?.current_salary_calculation
                                  ?.total_paid_days ?? "-"}
                              </td>

                              {salaryHeadings.map((heading, idx) => {
                                // Get deduction details from saved data
                                const deductionDetails =
                                  emp_payroll?.current_salary_calculation
                                    ?.deduction_details || [];
                                const sortedDeductions = deductionDetails.sort(
                                  (a, b) => {
                                    const sortA =
                                      a.sorting_var !== undefined
                                        ? parseInt(a.sorting_var)
                                        : 999;
                                    const sortB =
                                      b.sorting_var !== undefined
                                        ? parseInt(b.sorting_var)
                                        : 999;
                                    return sortA - sortB;
                                  },
                                );

                                // Find the specific heading
                                const deduction = sortedDeductions.find(
                                  (d) => d.name === heading,
                                );

                                return (
                                  <td
                                    key={idx}
                                    className="align-center width-5vw"
                                  >
                                    {deduction &&
                                    deduction.actual_amount !== undefined &&
                                    deduction.actual_amount !== "---"
                                      ? roundOffAmount
                                        ? formatRoundoffComplete(
                                            parseFloat(
                                              deduction.actual_amount,
                                            ) || 0,
                                          )
                                        : formatRoundoff2D(
                                            parseFloat(
                                              deduction.actual_amount,
                                            ) || 0,
                                          )
                                      : "-"}
                                  </td>
                                );
                              })}

                              {(() => {
                                const deductionDetails =
                                  emp_payroll?.current_salary_calculation
                                    ?.deduction_details || [];
                                const deduction = deductionDetails.find(
                                  (d) => d.final_salary === true,
                                );

                                if (
                                  !deduction ||
                                  deduction.actual_amount === undefined ||
                                  deduction.actual_amount === "---"
                                ) {
                                  return (
                                    <td className="align-center width-5vw">
                                      -
                                    </td>
                                  );
                                }

                                const amount = parseFloat(
                                  deduction.actual_amount,
                                );
                                return (
                                  <td className="align-center width-5vw">
                                    {isNaN(amount)
                                      ? "-"
                                      : roundOffAmount
                                        ? formatRoundoffComplete(amount || 0)
                                        : formatRoundoff2D(amount || 0)}
                                  </td>
                                );
                              })()}

                              <td className="align-center">
                                {CurrenttotalArrearAmount > 0 ? (
                                  <CustomTooltip
                                    tooltipContent={
                                      <ArrearTooltip data={currentArrear} />
                                    }
                                  >
                                    <div>
                                      {roundOffAmount
                                        ? formatRoundoffComplete(
                                            parseFloat(
                                              CurrenttotalArrearAmount,
                                            ) || 0,
                                          )
                                        : formatRoundoff2D(
                                            parseFloat(
                                              CurrenttotalArrearAmount,
                                            ) || 0,
                                          )}
                                    </div>
                                  </CustomTooltip>
                                ) : (
                                  <div title="No Arrear">0</div>
                                )}
                              </td>

                              <td className="align-center">
                                <CustomTooltip
                                  position="top"
                                  tooltipContent={
                                    <div className="tds-tooltip">
                                      <div>
                                        <strong>Annual Tax (Declared):</strong>{" "}
                                        {formatRoundoff2D(
                                          CurrentMonthlyTds_details?.annual_tax_declared ??
                                            0,
                                        )}
                                      </div>
                                      <div>
                                        <strong>
                                          Annual Tax (After Proof):
                                        </strong>{" "}
                                        {formatRoundoff2D(
                                          CurrentMonthlyTds_details?.annual_tax_proof ??
                                            0,
                                        )}
                                      </div>
                                      <div>
                                        <strong>Tax Difference:</strong>{" "}
                                        {formatRoundoff2D(
                                          CurrentMonthlyTds_details?.annual_tax_difference ??
                                            0,
                                        )}
                                      </div>
                                      <hr />
                                      <div>
                                        <strong>Normal Monthly TDS:</strong>{" "}
                                        {formatRoundoff2D(
                                          CurrentMonthlyTds_details
                                            ?.final_tax_summary?.normal_months
                                            ?.monthly_tds_actual ?? 0,
                                        )}
                                      </div>
                                      <div>
                                        <strong>Adjustment Months:</strong>{" "}
                                        {getMonthYearNameFromDate(
                                          CurrentMonthlyTds_details?.adjustment_month_start,
                                        )}
                                        -
                                        {getMonthYearNameFromDate(
                                          CurrentMonthlyTds_details?.adjustment_month_end,
                                        )}
                                      </div>
                                      <div>
                                        <strong>Adjustment Per Month:</strong>{" "}
                                        {formatRoundoff2D(
                                          CurrentMonthlyTds_details?.monthly_adjustment ??
                                            0,
                                        )}
                                      </div>
                                      <div>
                                        <strong>
                                          Final Monthly TDS (Adjustment):
                                        </strong>
                                        {formatRoundoff2D(
                                          CurrentMonthlyTds_details?.final_monthly_tds_after_adjustment_from_proof ??
                                            0,
                                        )}
                                      </div>
                                    </div>
                                  }
                                >
                                  <span className="cursor-pointer">
                                    {typeof CurrentMonthlyTds_details
                                      ?.final_tax_summary?.final_monthly_tds ===
                                    "number"
                                      ? roundOffAmount
                                        ? formatRoundoffComplete(
                                            CurrentMonthlyTds_details
                                              ?.final_tax_summary
                                              ?.final_monthly_tds,
                                          )
                                        : formatRoundoff2D(
                                            CurrentMonthlyTds_details
                                              ?.final_tax_summary
                                              ?.final_monthly_tds,
                                          )
                                      : "-"}
                                  </span>
                                </CustomTooltip>
                              </td>

                              <td className="align-center">
                                <button
                                  className="allproject-dashboard"
                                  title="View Current/Live Payroll Slip"
                                  onClick={(e) =>
                                    ViewCurrentSalarySlip(
                                      emp_payroll,
                                      startMonth,
                                      startYear,
                                    )
                                  }
                                >
                                  <Eye />
                                </button>
                              </td>
                            </>
                          )}
                        </tr>
                      ) : null}

                      {/* // Saved Payrolls  >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/}
                      {selectedDataType === "both" ||
                      selectedDataType === "saved" ||
                      (selectedDataType === "summary" &&
                        emp_payroll?.has_salary_saved) ? (
                        <tr
                          key={`saved-${index}`}
                          style={{
                            color:
                              emp_payroll?.employee_details?.employee_status ===
                              "inactive"
                                ? "#ff1212"
                                : "black",
                          }}
                          data-status={
                            emp_payroll?.employee_details?.employee_status
                          }
                          className={
                            emp_payroll?.employee_details?.employee_status ===
                            "inactive"
                              ? "notapproved-exceeded-row"
                              : ""
                          }
                        >
                          <td className="align-left">
                            {/* <span className={`status-badge ${selectedDataType === "saved" ? "color-badge-success" : "color-badge-warning"}  fontWeight: '500' `}>{selectedDataType === "saved" ? "Saved" : "Not Saved"}</span> */}
                            <span
                              className={`status-badge color-badge-success `}
                            >
                              Saved
                            </span>
                          </td>
                          {selectedDataType !== "both" && (
                            <td className="align-left">
                              {emp_payroll.emp_code}
                            </td>
                          )}
                          {selectedDataType !== "both" && (
                            <td className="align-center">
                              {emp_payroll.employee_details?.emp_name || "-"}
                            </td>
                          )}

                          {empDetailsView ? (
                            <>
                              {selectedDataType !== "both" && (
                                <td className="align-center">
                                  {emp_payroll?.employee_details
                                    ?.department_name || "-"}
                                </td>
                              )}
                              {selectedDataType !== "both" && (
                                <td className="align-center">
                                  {emp_payroll?.employee_details
                                    ?.designation_name || "-"}
                                </td>
                              )}
                              {selectedDataType !== "both" && (
                                <td className="align-center">
                                  <>
                                    {/* <CustomImageModal customStyle>
                                    {emp_payroll?.employee_details?.reporting_head_profile_pic ? (
                                      <img
                                        src={`${`${IMAGE_URL}${emp_payroll?.employee_details?.reporting_head_profile_pic}`}`}
                                        alt="profile" className="profile-img"
                                      />
                                    ) : (
                                      <UserDefaultLogo user={{ name: emp_payroll?.employee_details?.reporting_head_name, profilepic: emp_payroll?.employee_details?.reporting_head_profile_pic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                    )}
                                  </CustomImageModal> */}
                                    <p>
                                      {
                                        emp_payroll?.employee_details
                                          ?.reporting_head_name
                                      }
                                    </p>
                                  </>
                                </td>
                              )}
                              {selectedDataType !== "both" && (
                                <td className="align-center text-capitalize">
                                  {emp_payroll?.employee_details
                                    .employee_status || "-"}
                                </td>
                              )}
                              {selectedDataType !== "both" && (
                                <td className="align-center">
                                  {emp_payroll?.employee_details?.joining_date
                                    ? formattedDateLong(
                                        emp_payroll?.employee_details
                                          ?.joining_date,
                                      )
                                    : "-"}
                                </td>
                              )}
                              {selectedDataType !== "both" && (
                                <td className="align-center text-capitalize">
                                  {emp_payroll?.employee_details
                                    ?.cost_center_assets || "-"}
                                </td>
                              )}
                            </>
                          ) : null}
                          {detailsView ? (
                            <>
                              {selectedDataType !== "both" && (
                                <td className="align-center">
                                  {emp_payroll?.bank_details?.account_number ||
                                    "-"}
                                </td>
                              )}
                              {selectedDataType !== "both" && (
                                <td className="align-center">
                                  {emp_payroll?.bank_details?.ifsc_code || "-"}
                                </td>
                              )}
                              {selectedDataType !== "both" && (
                                <td className="align-center width-10vw">
                                  {emp_payroll?.bank_details?.bank_name || "-"}{" "}
                                  -
                                  <span className="width-10vw">
                                    {emp_payroll?.bank_details
                                      ?.branch_address || "-"}
                                  </span>
                                </td>
                              )}
                            </>
                          ) : null}
                          {!emp_payroll?.saved_salary_data?.has_salary_saved ? (
                            <td
                              colSpan={
                                standardView
                                  ? salaryHeadings.length * 2 + 3
                                  : salaryHeadings.length + 3
                              }
                              className="align-center error-message"
                            >
                              <div className="flex-row justify-center align-center">
                                {/* <span className="error-icon"></span> */}
                                <span>
                                  {emp_payroll?.saved_salary_data?.message}
                                </span>
                              </div>
                            </td>
                          ) : (
                            <>
                              {standardView ? salaryHeadings
                                // .sort((a, b) => a.sorting_var - b.sorting_var)
                                // .filter((heading) => heading !== "Monthly In-hand")
                                .map((heading, idx) => {
                                  const deduction = emp_payroll?.saved_salary_data?.salary_data?.deduction_details.find(d => d.name === heading);
                                  return (
                                    <td key={idx} className="align-center width-5vw">
                                      {deduction && typeof deduction.standard_amount === 'number'
                                        ? roundOffAmount ? formatRoundoffComplete(deduction.standard_amount)
                                          : formatRoundoff2D(deduction.standard_amount)
                                        : '-'}
                                    </td>
                                  );
                                })
                                : null}


                              <td className="align-center" title={`${emp_payroll?.saved_salary_data?.salary_data?.total_paid_days ?? '-'}/${emp_payroll?.saved_salary_data?.salary_data?.total_days ?? '-'}`}>
                                {emp_payroll?.saved_salary_data?.salary_data?.total_paid_days ?? '-'}
                              </td>

                              {salaryHeadings
                                ?.sort((a, b) => a.sorting_var - b.sorting_var)
                                // .filter((heading) => heading !== "Monthly In-hand")
                                .map((heading, idx) => {
                                  const deduction = emp_payroll?.saved_salary_data?.salary_data?.deduction_details.find(d => d.name === heading);
                                  return (
                                    <td
                                      key={idx}
                                      className="align-center width-5vw"
                                    >
                                      {deduction &&
                                      typeof deduction.actual_amount ===
                                        "number"
                                        ? roundOffAmount
                                          ? formatRoundoffComplete(
                                              deduction.actual_amount,
                                            )
                                          : formatRoundoff2D(
                                              deduction.actual_amount,
                                            )
                                        : "-"}
                                    </td>
                                  );
                                })}

                              {(() => {
                                const deductionDetails = emp_payroll?.saved_salary_data?.salary_data?.deduction_details || [];
                                const deduction = deductionDetails.find(d => d.final_salary === true);

                                if (
                                  !deduction ||
                                  deduction.actual_amount === undefined ||
                                  deduction.actual_amount === "---"
                                ) {
                                  return (
                                    <td className="align-center width-5vw">
                                      -
                                    </td>
                                  );
                                }

                                const amount = parseFloat(
                                  deduction.actual_amount,
                                );
                                return (
                                  <td className="align-center width-5vw">
                                    {isNaN(amount)
                                      ? "-"
                                      : roundOffAmount
                                        ? formatRoundoffComplete(amount || 0)
                                        : formatRoundoff2D(amount || 0)}
                                  </td>
                                );
                              })()}

                              <td className="align-center">
                                {totalArrearAmount > 0 ? (
                                  <CustomTooltip
                                    position="top"
                                    tooltipContent={
                                      <ArrearTooltip data={savedArrear} />
                                    }
                                  >
                                    <div>
                                      {roundOffAmount
                                        ? formatRoundoffComplete(
                                            parseFloat(totalArrearAmount) || 0,
                                          )
                                        : formatRoundoff2D(
                                            parseFloat(totalArrearAmount) || 0,
                                          )}{" "}
                                    </div>
                                  </CustomTooltip>
                                ) : (
                                  <div title="No Arrear">0</div>
                                )}
                              </td>

                              <td className="align-center">
                                <CustomTooltip
                                  position="top"
                                  tooltipContent={
                                    <div className="tds-tooltip">
                                      <div><strong>Annual Tax (Declared):</strong> {formatRoundoff2D(SavedMonthlyTds_details?.annual_tax_declared ?? 0)}</div>
                                      <div><strong>Annual Tax (After Proof):</strong> {formatRoundoff2D(SavedMonthlyTds_details?.annual_tax_proof ?? 0)}</div>
                                      <div><strong>Tax Difference:</strong> {formatRoundoff2D(SavedMonthlyTds_details?.annual_tax_difference ?? 0)}</div>
                                      <hr />
                                      <div><strong>Normal Monthly TDS:</strong> {formatRoundoff2D(SavedMonthlyTds_details?.final_tax_summary?.normal_months?.monthly_tds_actual ?? 0)}</div>
                                      <div><strong>Adjustment Months:</strong> {getMonthYearNameFromDate(SavedMonthlyTds_details?.adjustment_month_start)}-{getMonthYearNameFromDate(CurrentMonthlyTds_details?.adjustment_month_end)}</div>
                                      <div>
                                        <strong>Adjustment Per Month:</strong>{" "}
                                        {formatRoundoff2D(SavedMonthlyTds_details?.monthly_adjustment ?? 0)}
                                      </div>
                                      <div>
                                        <strong>Final Monthly TDS (Adjustment):</strong>
                                        {formatRoundoff2D(SavedMonthlyTds_details?.final_monthly_tds_after_adjustment_from_proof ?? 0)}
                                      </div>
                                    </div>
                                  }
                                >
                                  <span className="cursor-pointer">
                                    {typeof SavedMonthlyTds_details?.final_tax_summary?.final_monthly_tds === 'number'
                                      ? roundOffAmount
                                        ? formatRoundoffComplete(SavedMonthlyTds_details?.final_tax_summary?.final_monthly_tds)
                                        : formatRoundoff2D(SavedMonthlyTds_details?.final_tax_summary?.final_monthly_tds)
                                      : '-'}
                                  </span>
                                </CustomTooltip>
                              </td>

                              <td className="align-center">
                                {emp_payroll?.saved_salary_data
                                  ?.has_salary_saved ? (
                                  <button
                                    className="allproject-dashboard"
                                    title="View Saved Payroll Slip"
                                    onClick={(e) =>
                                      ViewSavedSalarySlip(
                                        emp_payroll,
                                        startMonth,
                                        startYear,
                                      )
                                    }
                                  >
                                    <Eye />
                                  </button>
                                ) : (
                                  <span className="text-muted">Not Saved</span>
                                )}
                              </td>
                            </>
                          )}
                        </tr>
                      ) : null}
                    </>
                  );
                })}
              </tbody>
            )}
          </table>
        </div>
        {/* </div> */}
      </div>
      <ToastContainer
        position="top-center"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

const TaxCalculationTable = () => {
  const [departmentname, setDepartmentname] = useState([]);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY, PORTAL_SETTINGS } =
    usePermission();
  const [buffering3, setBuffering3] = useState(true);
  const [detailsView, setDetailsView] = useState(true);
  const [payrunList, setPayrunList] = useState([]);
  const [roundOffAmount, setRoundOffAmount] = useState(true);
  const [saveCalculation, setSaveCalculation] = useState(false);
  const [buffer, setBuffering] = useState(false);
  const [buffer1, setBuffering1] = useState(false);
  const [taxCalculations, setTaxCaclculations] = useState([]);
  const [taxCalculationsFiltered, setTaxCaclculationsFiltered] = useState([]);
  const [toggleSubCompany, setToggleSubCompany] = useState(
    sessionStorage.getItem("company_id"),
  );
  const [active, setActive] = useState("active");
  const [selectedDataType, setSelectedDataType] = useState("summary");
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [empDetailsView, setEmpDetailsView] = useState(true);
  // For checkbox selection
  const [checkboxes, setCheckboxes] = useState({});

  const getDepartmentAndDesignation = async () => {
    setBuffering1(true);
    try {
      const dep = await axios.get(`${BASE_URL}/wfm/department/`);
      setDepartmentname(dep.data);
    } catch (err) {
      console.error("Error fetching departments/designations", err);
    } finally {
      setBuffering1(false);
    }
  };

  const getTaxCalculations = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/calculate-fetch-monthly-tds-bysubcompany-bymonth/${toggleSubCompany}/${active}/${selectedCostCenter}/${startYear}/${startMonth}/`,
      );

      setTaxCaclculations(res.data.employees || []);
      // Reset checkboxes when data changes
      setCheckboxes({});
      setSelectedEmployees([]);
    } catch (err) {
      handleAllError(err);
    } finally {
      setBuffering(false);
    }
  };

  const refreshdata = async () => {
    setBuffering(true);
    await getTaxCalculations();
    setBuffering(false);
  };

  const location = useLocation();
  const today = new Date();
  // today.setDate(today.getDate() - 1);

  const currentMonth = (today.getMonth() + 1).toString();
  const currentYear = today.getFullYear().toString();
  const incomingMonth =
    location.state?.toggleincomingmonth !== undefined &&
    location.state?.toggleincomingmonth !== null
      ? location.state.toggleincomingmonth.toString()
      : currentMonth;

  const incomingYear =
    location.state?.toggleincomingyear !== undefined &&
    location.state?.toggleincomingyear !== null
      ? location.state.toggleincomingyear.toString()
      : currentYear;

  const [startMonth, setStartMonth] = useState(incomingMonth);
  const [startYear, setStartYear] = useState(incomingYear);
  const [endMonth, setEndMonth] = useState(currentMonth);
  const [endYear, setEndYear] = useState(currentYear);

  const startDateValue = `${startYear}-${startMonth.padStart(2, "0")}`;
  const endDateValue = `${endYear}-${endMonth.padStart(2, "0")}`;
  const [payrunStatus, setPayrunStatus] = useState({});

  const [selectedName, setName] = useState("");
  const [selectedDep, setDep] = useState("");
  const [selectedDesi, setDesi] = useState("");
  const [selectedCostCenter, setCostCenter] = useState("null");
  const [selectedDivision, setSelectedDivision] = useState(
    sessionStorage.getItem("company"),
  );
  const [showViewOptions, setShowViewOptions] = useState(false);

  const applyFilters = () => {
    let filteredData = taxCalculations;

    // Apply filters
    if (selectedName) {
      const search = selectedName.toLowerCase();
      filteredData = filteredData.filter(
        (emp) =>
          emp.employee_details?.emp_name?.toLowerCase().includes(search) ||
          emp.employee_details?.emp_code?.toLowerCase().includes(search),
      );
    }

    if (selectedDep) {
      filteredData = filteredData.filter(
        (emp) => emp.employee_details?.department_name === selectedDep,
      );
    }

    if (selectedDesi) {
      const search = selectedDesi.toLowerCase();
      filteredData = filteredData.filter((emp) =>
        emp.employee_details?.designation_name?.toLowerCase().includes(search),
      );
    }

    // Group employees by emp_code for rendering
    const groupedEmployees = {};

    filteredData.forEach((emp) => {
      const empCode = emp.employee_details?.emp_code;
      if (!empCode) return;

      if (!groupedEmployees[empCode]) {
        groupedEmployees[empCode] = {
          employee_details: emp.employee_details,
          current_tax_calculation: emp.current_tax_calculation,
          saved_tax_data: emp.saved_tax_data,
          comparison: emp.comparison,
        };
      }
    });

    // Convert to array and sort
    const finalRows = Object.values(groupedEmployees).sort((a, b) => {
      const codeA = String(a.employee_details?.emp_code || "");
      const codeB = String(b.employee_details?.emp_code || "");
      return codeA.localeCompare(codeB, undefined, { numeric: true });
    });

    setTaxCaclculationsFiltered(finalRows);
  };

  useEffect(() => {
    getDepartmentAndDesignation();
    getTaxCalculations();
  }, [startMonth, startYear, toggleSubCompany, active, selectedCostCenter]);

  useEffect(() => {
    applyFilters();
  }, [
    selectedName,
    selectedDep,
    selectedDesi,
    taxCalculations,
    selectedDataType,
  ]);

  const handleCheckboxChange = async (empCode, isChecked) => {
    setCheckboxes((prev) => ({
      ...prev,
      [empCode]: isChecked,
    }));

    if (isChecked) {
      const employee = taxCalculationsFiltered.find(
        (emp) =>
          emp.employee_details?.emp_code === empCode &&
          emp.current_tax_calculation?.has_tax_calculation,
      );
      if (employee) {
        console.log(employee, "emp");

        setSelectedEmployees((prev) => [...prev, employee]);
        await getPayrunlist(empCode);
      }
    } else {
      setSelectedEmployees((prev) =>
        prev.filter((emp) => emp.employee_details?.emp_code !== empCode),
      );
    }
  };

  // Select all checkboxes for current calculations
  // const handleSelectAll = () => {
  //   const eligibleEmployees = taxCalculationsFiltered.filter(emp =>
  //     emp.current_tax_calculation?.has_tax_calculation
  //   );

  //   const newCheckboxes = {};
  //   const newSelectedEmployees = [];

  //   eligibleEmployees.forEach(emp => {
  //     const empCode = emp.employee_details?.emp_code;
  //     newCheckboxes[empCode] = true;
  //     newSelectedEmployees.push(emp);
  //   });

  //   setCheckboxes(newCheckboxes);
  //   setSelectedEmployees(newSelectedEmployees);
  //   console.log(eligibleEmployees, "eligibkle");

  // };

  const handleSelectAll = async () => {
    const eligibleEmployees = taxCalculationsFiltered.filter((employee) => {
      const hasCurrent = employee.current_tax_calculation?.has_tax_calculation;
      const hasSaved = employee.saved_tax_data?.has_tax_saved;

      if (selectedDataType === "summary") {
        return hasCurrent && !hasSaved;
      }

      if (selectedDataType === "not_saved") {
        return hasCurrent;
      }

      if (selectedDataType === "both") {
        return hasCurrent;
      }

      return false;
    });

    const newCheckboxes = {};
    const newSelectedEmployees = [];

    const apiCalls = eligibleEmployees.map((emp) => {
      const empCode = emp.employee_details?.emp_code;
      if (!empCode) return null;

      newCheckboxes[empCode] = true;
      newSelectedEmployees.push(emp);

      return getPayrunlist(empCode);
    });

    setCheckboxes(newCheckboxes);
    setSelectedEmployees(newSelectedEmployees);

    await Promise.all(apiCalls.filter(Boolean));
  };

  // Clear all selections
  const handleClearAll = () => {
    setCheckboxes({});
    setSelectedEmployees([]);
  };

  // Handle submit success
  const handleSubmitSuccess = () => {
    getTaxCalculations(); // Refresh data
    setSelectedEmployees([]);
    setCheckboxes({});
  };

  const tableRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleDownloadPayRunSheet = () => {
    downloadAsExcel(
      tableRef,
      "users",
      `TaxCalculationSheet - ${startMonth} - ${startYear}`,
      {
        applyRowStyles: true,
        styleCondition: (employee) =>
          employee.employee_details?.employee_status === "inactive",
        styleProps: { font: { color: { rgb: "FF0000" } } },
      },
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowViewOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const getPayrunlist = async (empcode) => {
  //   setBuffering3(true);
  //   try {
  //     const res = await axios.get(`${BASE_URL}/wfm/employee-latest-timeline/${empcode}/`);
  //     setPayrunList(res.data);
  //   } catch (err) {
  //   } finally {
  //     setBuffering3(false);
  //   }
  // }

  const getPayrunlist = async (empcode) => {
    setBuffering3(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employee-latest-timeline/${empcode}/`,
      );

      const slip = res.data?.last_salary_slip;

      const formattedMonth = slip
        ? `${slip.year}-${String(slip.month).padStart(2, "0")}`
        : null;

      setPayrunStatus((prev) => ({
        ...prev,
        [empcode]: formattedMonth,
      }));
    } catch (err) {
    } finally {
      setBuffering3(false);
    }
  };

  const selectedMonth = `${startYear}-${String(startMonth).padStart(2, "0")}`;

  const isAnyInvalid = selectedEmployees.some((emp) => {
    const empCode = emp.employee_details?.emp_code;
    const lastPayrunMonth = payrunStatus[empCode]; // e.g. "2025-12"

    if (!lastPayrunMonth) return true;

    const [lastYear, lastMonth] = lastPayrunMonth.split("-").map(Number);

    // Next allowed month only
    const nextAllowedDate = new Date(lastYear, lastMonth, 1);

    const selectedDate = new Date(startYear, startMonth - 1, 1);

    return selectedDate.getTime() !== nextAllowedDate.getTime();
  });

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500 font-size-heading"></div>
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <input
                type="month"
                className="attendance-input-field calender-input width-10vw"
                value={startDateValue}
                max={endDateValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    const [year, month] = value.split("-");
                    setStartYear(year);
                    setStartMonth(month.replace(/^0+/, ""));
                  }
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div gap-3px">
              <Office />
              <select
                className="attendance-input-field width-15vw date-field"
                type="text"
                onChange={(e) => setToggleSubCompany(e.target.value)}
                value={toggleSubCompany}
              >
                <option value="null">Select Sub Company</option>
                {SUB_COMPANIES.map((company) => (
                  <option value={company.id}>{company.title}</option>
                ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-15vw"
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All Employees</option>
                <option value="active">Active Employees</option>
                <option value="inactive">Inactive Employees</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div gap-3px">
              {buffer1 ? (
                <div className="spinner-vsmall"></div>
              ) : (
                <CircularGrid />
              )}
              <select
                className="attendance-input-field width-15vw date-field"
                type="text"
                value={selectedDep}
                onChange={(e) => setDep(e.target.value)}
              >
                <option value=""> All Department</option>
                {departmentname
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.title}>{i.title}</option>
                  ))}
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-10vw"
                placeholder="Designation"
                type="text"
                value={selectedDesi}
                onChange={(e) => setDesi(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-10vw"
                placeholder="Code / Name"
                type="text"
                value={selectedName}
                onChange={(e) => setName(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            {detailsView && (
              <div className="field-cont-div">
                <Employee />
                <select
                  className="attendance-input-field width-10vw"
                  type="text"
                  value={selectedCostCenter}
                  onChange={(e) => setCostCenter(e.target.value)}
                >
                  <option value="null">All Cost Center</option>
                  <option value="employee">Employee</option>
                  <option value="currentasset">Current Asset</option>
                  <option value="fixedasset">Fixed Asset</option>
                </select>
                <hr className="field-cont-hr" />
              </div>
            )}

            <div className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw"
                type="text"
                value={selectedDataType}
                onChange={(e) => setSelectedDataType(e.target.value)}
              >
                <option value="summary">Summary</option>
                <option value="saved">Saved</option>
                <option value="not_saved">Not Saved</option>
                <option value="both">Both</option>
              </select>
              <hr className="field-cont-hr" />
            </div>
          </div>

          <div className="btn-cont">
            {/* <button className="model-button-print" title="Download in Excel Format" onClick={handleDownloadPayRunSheet}>
              <DownloadIcon />
            </button> */}
            <DownloadTableExcel
              // filename={`Expense Data ${fromdate === todate ? `${fromdate}` : `${fromdate} to ${todate}`} ${datetimefield}`}
              filename={`Download in Excel Format`}
              sheet="Details"
              currentTableRef={tableRef.current}
            >
              <button className="model-button   font-weight500   model-button-print">
                <DownloadIcon />
              </button>
            </DownloadTableExcel>
          </div>
        </div>
      </div>

      {/* Checkbox Controls */}
      {saveCalculation && (
        <div className="checkbox-controls mb-3">
          <div className="flex-row gap-3">
            <button
              // className="btn btn-sm btn-outline-primary"
              className="priority-button text-primary-color color-border-blue"
              onClick={handleSelectAll}
            >
              Select All Current
            </button>
            <button
              // className="btn btn-sm btn-outline-secondary"
              className="priority-button text-secondary-color color-border-grey"
              onClick={handleClearAll}
            >
              Clear All
            </button>
            <span className="text-muted">
              {selectedEmployees.length} employee(s) selected
            </span>
          </div>
        </div>
      )}

      <div className="custom-table-width">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500 mb-0 font-size-heading">
            TDS Calculation{" "}
            <CustomTooltip
              position="top"
              tooltipContent="Calculation based on attendance for the month."
            >
              <span>
                <InfoIcon />
              </span>
            </CustomTooltip>
          </div>
          <div className="flex-row">
            <div className="flex-row gap-2 relative" ref={dropdownRef}>
              <button
                type="button"
                onClick={() => setShowViewOptions(!showViewOptions)}
                className="flex-row color-badge-white "
                style={{ padding: "5px" }}
              >
                <span className="font-weight500" style={{ marginRight: "5px" }}>
                  Display Options
                </span>
                <Filter />
              </button>

              {buffer ? (
                <div className="spinner-vsmall"></div>
              ) : (
                <div
                  className="refresh-button"
                  onClick={refreshdata}
                  disabled={buffer}
                >
                  <Refresh />
                </div>
              )}

              {showViewOptions && (
                <div
                  className="absolute mt-2  color-badge-white border  shadow-lg p-3 z-index-1000 "
                  style={{ minWidth: "15vw", top: "26px", right: "43px" }}
                >
                  <div className="items mb-3">
                    <label className="form-labels font-weight500">
                      Employee Details
                    </label>
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        id="toggle-emp-details"
                        checked={empDetailsView}
                        onChange={() => setEmpDetailsView(!empDetailsView)}
                      />
                      <label htmlFor="toggle-emp-details"></label>
                    </div>
                  </div>

                  {/* Bank Details Toggle */}
                  <div className="items mb-3">
                    <label className="form-labels font-weight500">
                      TDS Details
                    </label>
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        id="toggle2"
                        checked={detailsView}
                        onChange={() => setDetailsView(!detailsView)}
                      />
                      <label htmlFor="toggle2"></label>
                    </div>
                  </div>

                  {/* Round Off Toggle */}
                  <div className="items mb-3">
                    <label
                      className="form-labels font-weight500"
                      title={
                        roundOffAmount
                          ? "Rounded Off (0.5+) to next"
                          : "Actual till 2 Decimal Places"
                      }
                    >
                      Amount Rounded Off
                    </label>
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        id="toggle-roundoff"
                        checked={roundOffAmount}
                        onChange={() => setRoundOffAmount(!roundOffAmount)}
                      />
                      <label htmlFor="toggle-roundoff"></label>
                    </div>
                  </div>

                  {/* Standard Values Toggle */}
                  <div className="items">
                    <label className="form-labels font-weight500">
                      {saveCalculation ? "Save" : "Show"} Calculation :{" "}
                    </label>
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        id="toggle-calculation"
                        checked={saveCalculation}
                        // onChange={() => setSaveCalculation(!saveCalculation)}
                        onChange={() => {
                          setSaveCalculation(!saveCalculation);
                          handleClearAll();
                        }}
                      />
                      <label htmlFor="toggle-calculation"></label>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="btn-cont">
              {saveCalculation && selectedEmployees.length > 0 && (
                <>
                  <hr className="field-cont-hr" />
                  <SubmitTaxCalculationModal
                    buffer={buffering3}
                    isAnyInvalid={isAnyInvalid}
                    payrunStatus={payrunStatus}
                    selectedEmployees={selectedEmployees}
                    month={startMonth}
                    year={startYear}
                    onSuccess={handleSubmitSuccess}
                    permissions={PORTAL_SETTINGS}
                  />
                </>
              )}
            </div>
          </div>
        </div>

        <div
          className="scrollfix-wrapper table-css-white-background scroll-container-table bank-details outer-scroll-table"
          style={{ padding: "0px" }}
        >
          <table
            ref={tableRef}
            className="scrollfix-table-css table-css table-column-seperator"
          >
            <thead>
              <tr className="custom-table-head-tr">
                {saveCalculation && <th className="align-center">Select</th>}
                <th className="align-left">Tax Status</th>
                <th className="align-left">Emp Code</th>
                <th className="align-left">Employee Name</th>
                {empDetailsView && (
                  <>
                    <th className="align-center">Department</th>
                    <th className="align-center">Designation</th>
                    <th className="align-center">Age</th>
                    <th className="align-center">Joining Date</th>
                  </>
                )}

                <th className="align-center">Gross Monthly Salary</th>
                <th className="align-center">Gross Annual Salary</th>
                <th className="align-center">Less: Standard Deduction</th>
                <th className="align-center">Gross Total Income from Salary</th>
                {detailsView && <th className="align-center">Other Incomes</th>}
                <th className="align-center">Total Income</th>
                {detailsView && (
                  <th className="align-center">Other Investment</th>
                )}
                <th className="align-center">Total Investment</th>
                <th className="align-center">Taxable Income</th>
                {detailsView && <th className="align-center">Tax Slabs</th>}
                <th className="align-center">Tax Before Rebate & Cess</th>
                <th className="align-center">Rebate</th>
                <th className="align-center">Surcharge</th>
                <th className="align-center">Cess(%)</th>
                <th className="align-center">Cess(in amount)</th>
                <th className="align-center">Total Annual Tax</th>
                <th className="align-center">Arrear amount</th>
                <th className="align-center">Final TDS amount</th>
                <th className="align-center">Monthly TDS (Remaining Months)</th>
                <th className="align-center">View Details</th>
              </tr>
            </thead>

            {buffer ? (
              <Loader container={true} />
            ) : (
              <tbody>
                {taxCalculationsFiltered.map((employee, index) => {
                  const empCode = employee.employee_details?.emp_code || "-";
                  const empName = employee.employee_details?.emp_name || "-";
                  const department =
                    employee.employee_details?.department_name || "-";
                  const designation =
                    employee.employee_details?.designation_name || "-";
                  const joiningDate =
                    employee.employee_details?.joining_date || "-";
                  const employeeStatus =
                    employee.employee_details?.employee_status || "active";

                  const hasCurrent =
                    employee.current_tax_calculation?.has_tax_calculation;
                  const hasSaved = employee.saved_tax_data?.has_tax_saved;

                  const currentError = employee.current_tax_calculation?.error;
                  const savedError = employee.saved_tax_data?.message;

                  // Determine which rows to show based on selectedDataType
                  const showCurrent =
                    selectedDataType === "both" ||
                    selectedDataType === "not_saved" ||
                    (selectedDataType === "summary" && !hasSaved && hasCurrent);

                  const showSaved =
                    selectedDataType === "both" ||
                    selectedDataType === "saved" ||
                    (selectedDataType === "summary" && hasSaved);

                  const showBoth = selectedDataType === "both";

                  // Get age for current calculation
                  const currentAge =
                    employee.current_tax_calculation?.declared_tax_details
                      ?.age ?? "-";
                  const savedAge =
                    employee.saved_tax_data?.declared_tax_details?.age ?? "-";
                  // Calculate colspan for error rows
                  const errorColspan = detailsView ? 30 : 22;

                  // SUMMARY LOGIC: Priority = Saved > Current > Error
                  if (selectedDataType === "summary") {
                    const showSavedData = hasSaved;
                    const showCurrentData = !hasSaved && hasCurrent;
                    const showError = !hasSaved && !hasCurrent;

                    return (
                      <tr
                        key={empCode}
                        style={{
                          color:
                            employeeStatus === "inactive" ? "#ff1212" : "black",
                        }}
                        className={
                          employeeStatus === "inactive"
                            ? "notapproved-exceeded-row"
                            : ""
                        }
                      >
                        {saveCalculation && (
                          <td className="align-center">
                            {showCurrentData ? (
                              <label
                                className="align-center checkbox-click"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <input
                                  type="checkbox"
                                  // checked={selectedEmployees.some(
                                  //     e => e.emp_code === emp.emp_code
                                  // )}
                                  checked={checkboxes[empCode] || false}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      empCode,
                                      e.target.checked,
                                    )
                                  }
                                  className="form-checkbox-nm"
                                  disabled={!hasCurrent}
                                />
                                <div className="checkmark-medium"></div>
                              </label>
                            ) : (
                              // <input
                              //   type="checkbox"
                              //   checked={checkboxes[empCode] || false}
                              //   onChange={(e) => handleCheckboxChange(empCode, e.target.checked)}
                              //   disabled={!hasCurrent}
                              // />
                              <span className="text-muted">-</span>
                            )}
                          </td>
                        )}
                        <td className="align-left">
                          {showSavedData ? (
                            <span className="status-badge color-badge-success">
                              Saved
                            </span>
                          ) : (
                            <span className="status-badge color-badge-warning">
                              Not Saved
                            </span>
                          )}
                        </td>

                        <td className="align-left">{empCode}</td>
                        <td className="align-left">{empName}</td>
                        {empDetailsView && (
                          <>
                            <td className="align-center">{department}</td>
                            <td className="align-center">{designation}</td>
                            <td className="align-center">{currentAge}</td>
                            <td className="align-center">
                              {joiningDate
                                ? formattedDateLong(joiningDate)
                                : "-"}
                            </td>
                          </>
                        )}

                        {showError ? (
                          <td
                            colSpan={errorColspan}
                            className="align-center error-message"
                          >
                            <div className="flex-row justify-center align-center">
                              <span>{savedError || "No saved data"}</span>
                            </div>
                          </td>
                        ) : showSavedData ? (
                          <>
                            <SavedTaxRow
                              taxData={employee.saved_tax_data}
                              roundOffAmount={roundOffAmount}
                              detailsView={detailsView}
                              selectedDataType={selectedDataType}
                              showBoth={false}
                            />
                            <td className="align-center">
                              <TdsCalculationModalForTDS
                                employeeDetails={employee?.employee_details}
                                taxData={employee?.saved_tax_data}
                              />
                            </td>
                          </>
                        ) : (
                          <>
                            <CurrentTaxRow
                              taxData={employee.current_tax_calculation}
                              calculationDetails={
                                employee.current_tax_calculation
                                  ?.calculation_tax_details
                              }
                              otherData={employee.current_tax_calculation}
                              roundOffAmount={roundOffAmount}
                              detailsView={detailsView}
                              selectedDataType={selectedDataType}
                              showBoth={false}
                            />
                            <td className="align-center">
                              <TdsCalculationModalForTDS
                                employeeDetails={employee?.employee_details}
                                taxData={employee?.current_tax_calculation}
                              />
                            </td>
                          </>
                        )}
                      </tr>
                    );
                  }

                  return (
                    <React.Fragment key={empCode}>
                      {/* Current/Live Calculation Payrolls */}
                      {showCurrent && (
                        <tr
                          style={{
                            color:
                              employeeStatus === "inactive"
                                ? "#ff1212"
                                : "black",
                          }}
                          className={
                            employeeStatus === "inactive"
                              ? "notapproved-exceeded-row"
                              : ""
                          }
                        >
                          {saveCalculation && (
                            <td className="align-center">
                              {hasCurrent ? (
                                <label
                                  className="align-center checkbox-click"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <input
                                    type="checkbox"
                                    checked={checkboxes[empCode] || false}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        empCode,
                                        e.target.checked,
                                      )
                                    }
                                    className="form-checkbox-nm"
                                    disabled={!hasCurrent}
                                  />
                                  <div className="checkmark-medium"></div>
                                </label>
                              ) : (
                                // <input
                                //   type="checkbox"
                                //   checked={checkboxes[empCode] || false}
                                //   onChange={(e) => handleCheckboxChange(empCode, e.target.checked)}
                                //   disabled={!hasCurrent}
                                // />
                                <span className="text-muted">-</span>
                              )}
                            </td>
                          )}
                          <td className="align-left">
                            <span className="status-badge color-badge-warning">
                              Not Saved
                            </span>
                          </td>
                          {showBoth ? (
                            <>
                              <td rowSpan={2} className="align-left">
                                {empCode}
                              </td>
                              <td rowSpan={2} className="align-left">
                                {empName}
                              </td>
                              {detailsView && (
                                <>
                                  <td rowSpan={2} className="align-center">
                                    {department}
                                  </td>
                                  <td rowSpan={2} className="align-center">
                                    {designation}
                                  </td>
                                  <td rowSpan={2} className="align-center">
                                    {currentAge}
                                  </td>
                                  <td rowSpan={2} className="align-center">
                                    {joiningDate
                                      ? formattedDateLong(joiningDate)
                                      : "-"}
                                  </td>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <td className="align-left">{empCode}</td>
                              <td className="align-left">{empName}</td>
                              {detailsView && (
                                <>
                                  <td className="align-center">{department}</td>
                                  <td className="align-center">
                                    {designation}
                                  </td>
                                  <td className="align-center">{currentAge}</td>
                                  <td className="align-center">
                                    {joiningDate
                                      ? formattedDateLong(joiningDate)
                                      : "-"}
                                  </td>
                                </>
                              )}
                            </>
                          )}

                          {!hasCurrent ? (
                            <td
                              colSpan={
                                showBoth ? errorColspan - 8 : errorColspan
                              }
                              className="align-center error-message"
                            >
                              <div className="flex-row justify-center align-center">
                                <span>
                                  {currentError || "Calculation failed"}
                                </span>
                              </div>
                            </td>
                          ) : (
                            <>
                              {/* Tax calculation columns for current calculation */}
                              <CurrentTaxRow
                                taxData={employee.current_tax_calculation}
                                calculationDetails={
                                  employee.current_tax_calculation
                                    ?.calculation_tax_details
                                }
                                otherData={employee.current_tax_calculation}
                                roundOffAmount={roundOffAmount}
                                detailsView={detailsView}
                                selectedDataType={selectedDataType}
                                showBoth={showBoth}
                              />
                              <td className="align-center">
                                <TdsCalculationModalForTDS
                                  employeeDetails={employee?.employee_details}
                                  taxData={employee?.current_tax_calculation}
                                />
                              </td>
                            </>
                          )}
                        </tr>
                      )}

                      {/* Saved Payrolls */}
                      {showSaved && (
                        <tr
                          style={{
                            color:
                              employeeStatus === "inactive"
                                ? "#ff1212"
                                : "black",
                          }}
                          className={
                            employeeStatus === "inactive"
                              ? "notapproved-exceeded-row"
                              : ""
                          }
                        >
                          {saveCalculation && (
                            <td className="align-center">
                              <span className="text-muted">-</span>
                            </td>
                          )}
                          <td className="align-left">
                            <span className="status-badge color-badge-success">
                              Saved
                            </span>
                          </td>
                          {!showBoth && (
                            <>
                              <td className="align-left">{empCode}</td>
                              <td className="align-left">{empName}</td>
                              {detailsView && (
                                <>
                                  <td className="align-center">{department}</td>
                                  <td className="align-center">
                                    {designation}
                                  </td>
                                  <td className="align-center">{currentAge}</td>
                                  <td className="align-center">
                                    {joiningDate
                                      ? formattedDateLong(joiningDate)
                                      : "-"}
                                  </td>
                                </>
                              )}
                            </>
                          )}

                          {/* //display saved data */}
                          {!hasSaved ? (
                            <td
                              colSpan={
                                showBoth ? errorColspan - 8 : errorColspan
                              }
                              className="align-center error-message"
                            >
                              <div className="flex-row justify-center align-center">
                                <span>{savedError || "No saved data"}</span>
                              </div>
                            </td>
                          ) : (
                            <>
                              {/* Tax calculation columns for saved data */}
                              <SavedTaxRow
                                taxData={employee.saved_tax_data}
                                roundOffAmount={roundOffAmount}
                                detailsView={detailsView}
                                selectedDataType={selectedDataType}
                                showBoth={showBoth}
                              />
                              <td className="align-center">
                                <TdsCalculationModalForTDS
                                  employeeDetails={employee?.employee_details}
                                  taxData={employee?.saved_tax_data}
                                />
                              </td>
                            </>
                          )}
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            )}
          </table>
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

// Helper component for current tax row
const CurrentTaxRow = ({
  taxData,
  calculationDetails,
  otherData,
  roundOffAmount,
  detailsView,
  selectedDataType,
  showBoth,
}) => {
  const declaredTax = taxData?.declared_tax_details;
  const shouldSpan = selectedDataType === "both";

  if (!taxData?.has_tax_calculation) {
    return (
      <td
        colSpan={detailsView ? 25 : 18}
        // rowSpan={selectedDataType === 'both' ? 2 : 1}
        className="align-center error-message"
      >
        <div className="flex-row justify-center align-center">
          <span>{taxData?.error || "No tax data available"}</span>
        </div>
      </td>
    );
  }

  if (!declaredTax) return null;

  const other_income_details =
    otherData?.other_income_summary?.other_income_details || [];
  const other_investment_details =
    otherData?.other_investment_summary?.other_investment_details || [];

  const totalIncomeDeclaredAmount = other_income_details?.reduce(
    (sum, item) => sum + (Number(item?.declared_amount) || 0),
    0,
  );

  const totalInvDeclaredAmount = other_investment_details?.reduce(
    (sum, item) => sum + (Number(item?.declared_amount) || 0),
    0,
  );

  const totalArrearAmount =
    calculationDetails?.current_arrear_details?.total_arrear_amount || 0;

  const getArrearCalculation = (arrearDetails) => {
    const request = arrearDetails?.arrear_details?.arrear_request_details;

    const nature = request?.request_details?.nature_type;
    const calculationDetails = request?.calculation_details || [];

    const approvedDays = arrearDetails?.arrear_approved_days ?? 0;
    const approvedAmount = arrearDetails?.arrear_approved_amount ?? 0;
    const monthsArray = arrearDetails?.arrear_details_for_months || [];

    // default values
    let perUnitSalary = 0;
    let calculatedAmount = 0;
    let unitLabel = "";

    // base salary source (safe)
    const baseMonth = calculationDetails[0];
    const monthlySalary = baseMonth?.ef_salary_final_amount ?? 0;
    const daysInMonth = baseMonth?.total_days_of_month ?? 0;

    switch (nature) {
      // case "days":
      //   unitLabel = "Per Day Salary";
      //   perUnitSalary =
      //     daysInMonth > 0 ? monthlySalary / daysInMonth : 0;
      //   calculatedAmount = perUnitSalary;
      //   break;

      case "days": {
        const month = calculationDetails[0];
        const monthlySalary = month?.ef_salary_final_amount ?? 0;
        const daysInMonth = month?.total_days_of_month ?? 0;

        unitLabel = "Per Day Salary";
        perUnitSalary = daysInMonth > 0 ? monthlySalary / daysInMonth : 0;

        calculatedAmount = perUnitSalary;
        break;
      }

      case "months": {
        unitLabel = "Per Month Salary";

        calculatedAmount = calculationDetails.reduce((sum, m) => {
          return sum + (m?.ef_salary_final_amount ?? 0);
        }, 0);

        break;
      }

      case "amount":
        unitLabel = "Approved Amount";
        calculatedAmount = approvedAmount;
        break;

      default:
        calculatedAmount = arrearDetails?.total_arrear_amount ?? 0;
    }

    return {
      nature,
      unitLabel,
      perUnitSalary,
      approvedDays,
      approvedAmount,
      approvedMonths: calculationDetails.length,
      calculatedAmount,
    };
  };

  const arrearCalc = getArrearCalculation(
    calculationDetails?.current_arrear_details,
  );

  const arrearTooltip = (
    <div className="arrear-tooltip">
      {/* Header */}
      <div style={{ marginBottom: "8px" }}>
        <strong>
          Total Arrears: ₹{totalArrearAmount.toLocaleString("en-IN")}
        </strong>
      </div>
      <hr className="field-cont-hr" />

      {/* Arrear Items */}

      <div style={{ marginBottom: "10px" }}>
        {/* Month */}
        <div className="font-weight600">
          {getMonthName(
            calculationDetails?.current_arrear_details?.arrear_details
              ?.arrear_request_details?.request_details?.applicable_month,
          )}{" "}
          {
            calculationDetails?.current_arrear_details?.arrear_details
              ?.arrear_request_details?.request_details?.applicable_year
          }
        </div>

        {/* Bullet Details */}
        <div style={{ paddingLeft: "10px" }}>
          <div className="text-capitalize">
            • Nature:{" "}
            {
              calculationDetails?.current_arrear_details?.arrear_details
                ?.arrear_request_details?.request_details?.nature_type
            }
          </div>

          {/* Days / Months */}
          {(calculationDetails?.current_arrear_details?.arrear_details
            ?.arrear_request_details?.request_details?.nature_type === "days" ||
            calculationDetails?.current_arrear_details?.arrear_details
              ?.arrear_request_details?.request_details?.nature_type ===
              "months") && (
            <div>
              • Approved Days:{" "}
              {
                calculationDetails?.current_arrear_details?.arrear_details
                  ?.arrear_request_details?.request_details?.approved_days
              }
            </div>
          )}

          {/* Amount */}
          <div>
            • Amount: {arrearCalc.calculatedAmount.toLocaleString("en-IN")}
          </div>
        </div>
      </div>
    </div>
  );

  //tooltip content for previous salary and tax amount
  const PreviousSalaryTaxtooltipContent = (
    <div
      style={{
        padding: "12px",
        fontSize: "13px",
        lineHeight: "1.8",
        minWidth: "260px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>Previous Company Salary Amount:</span>
        <strong>
          {calculationDetails?.previous_employment_details?.prev_company_salary?.toLocaleString(
            "en-IN",
          )}
        </strong>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>Previous Company Tax Amount:</span>
        <strong>
          {calculationDetails?.previous_employment_details?.prev_company_tax?.toLocaleString(
            "en-IN",
          )}
        </strong>
      </div>
    </div>
  );

  return (
    <>
      <td className="align-center">
        {typeof declaredTax.monthly_gross_salary === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.monthly_gross_salary)
            : formatRoundoff2D(declaredTax.monthly_gross_salary)
          : "-"}
      </td>

      {/* <td className="align-center">
        {typeof declaredTax.annual_gross_salary === 'number'
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.annual_gross_salary)
            : formatRoundoff2D(declaredTax.annual_gross_salary)
          : '-'}
      </td> */}
      <td className="align-center">
        <CustomTooltip
          position="top"
          tooltipContent={
            // <div>
            //   {
            //     typeof calculationDetails?.previous_employment_details?.prev_company_salary === 'number'
            //       ? roundOffAmount
            //         ? formatRoundoffComplete(calculationDetails?.previous_employment_details?.prev_company_salary)
            //         : formatRoundoff2D(calculationDetails?.previous_employment_details?.prev_company_salary)
            //       : '-'
            //   }
            // </div>
            <div
              style={{
                padding: "12px",
                fontSize: "13px",
                lineHeight: "1.8",
                minWidth: "260px",
              }}
            >
              {declaredTax.is_part_year_employee && (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Previous Company Salary Amount : </span>
                  &nbsp; &nbsp;
                  <strong>
                    {" "}
                    {calculationDetails?.annual_income_summary?.components?.prev_company_salary.toLocaleString(
                      "en-IN",
                    ) || "0"}
                  </strong>
                </div>
              )}

              {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Curre : </span>
              <strong>
                ₹{" "}
                {calculationDetails?.annual_income_summary?.components?.current_company_actual.toLocaleString("en-IN") || "0"}
              </strong>
            </div> */}

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>Annual Arrear: </span>
                <strong>
                  {" "}
                  {/* {calculationDetails?.annual_income_summary?.components?.arrears.toLocaleString("en-IN") || "0"} */}
                  {totalArrearAmount}
                </strong>
              </div>
            </div>
          }
        >
          <div>
            {typeof declaredTax.annual_gross_salary === "number"
              ? roundOffAmount
                ? formatRoundoffComplete(declaredTax.annual_gross_salary)
                : formatRoundoff2D(declaredTax.annual_gross_salary)
              : "-"}
          </div>
        </CustomTooltip>
      </td>

      <td className="align-center">
        {typeof declaredTax.standard_deduction === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.standard_deduction)
            : formatRoundoff2D(declaredTax.standard_deduction)
          : "-"}
      </td>

      <td className="align-center">
        {typeof declaredTax.income_after_standard_deduction === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(
                declaredTax.income_after_standard_deduction,
              )
            : formatRoundoff2D(declaredTax.income_after_standard_deduction)
          : "-"}
      </td>

      {detailsView && (
        <td className="align-center">
          {other_income_details && other_income_details.length > 0 ? (
            <table
              className="table-css custom-table width-40vw"
              style={{ border: "0.5px solid #e8e8e8", borderRadius: "0px" }}
            >
              <thead>
                <tr className="custom-table-head-tr">
                  <th className="text-center font-size-subheading font-weight600">
                    Section
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Declared Amount
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Declaration Status
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Proof Amount
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Proof Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {other_income_details.map((income, incomeIndex) => (
                  <tr key={incomeIndex}>
                    <td
                      className="text-center"
                      title={income.section_desc}
                      style={{ cursor: "pointer" }}
                    >
                      {income?.section_code || "-"}
                    </td>
                    <td className="text-center">
                      {typeof income.declared_amount === "number"
                        ? roundOffAmount
                          ? formatRoundoffComplete(income.declared_amount)
                          : formatRoundoff2D(income.declared_amount)
                        : "-"}
                    </td>
                    <td
                      className="align-center request-status text-capitalize word-wrap-20vw"
                      request-status={income?.declaration_status}
                    >
                      {income?.declaration_status || "-"}
                    </td>
                    <td className="text-center">
                      {typeof income?.proof_amount === "number"
                        ? roundOffAmount
                          ? formatRoundoffComplete(income?.proof_amount)
                          : formatRoundoff2D(income?.proof_amount)
                        : "-"}
                    </td>
                    <td
                      className="align-center request-status text-capitalize word-wrap-20vw"
                      request-status={income?.proof_status}
                    >
                      {income?.proof_status || "-"}
                    </td>
                  </tr>
                ))}
                <tr className="font-weight600 bg-gray-100">
                  <td className="text-center">Total</td>
                  <td className="text-center">
                    {typeof totalIncomeDeclaredAmount === "number"
                      ? roundOffAmount
                        ? formatRoundoffComplete(totalIncomeDeclaredAmount)
                        : formatRoundoff2D(totalIncomeDeclaredAmount)
                      : "-"}
                  </td>
                  <td></td>
                  <td className="text-center">-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          ) : (
            <table
              className="table-css custom-table width-40vw"
              style={{ border: "0.5px solid #e8e8e8" }}
            >
              <tbody>
                <tr>
                  <td
                    colSpan={5}
                    className="text-center text-gray-500"
                    style={{ padding: "20px" }}
                  >
                    No data available
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </td>
      )}

      <td className="align-center">
        {typeof declaredTax.total_income === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.total_income)
            : formatRoundoff2D(declaredTax.total_income)
          : "-"}
      </td>

      {detailsView && (
        <td className="align-center">
          {other_investment_details && other_investment_details.length > 0 ? (
            <table
              className="table-css custom-table width-40vw"
              style={{ border: "0.5px solid #e8e8e8", borderRadius: "0px" }}
            >
              <thead>
                <tr className="custom-table-head-tr">
                  <th className="text-center font-size-subheading font-weight600">
                    Section
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Declared Amount
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Max Limit
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Declaration Status
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Proof Amount
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Proof Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {other_investment_details.map((investment, investmentIndex) => (
                  <tr key={investmentIndex}>
                    <td
                      className="text-center"
                      title={investment.section_desc}
                      style={{ cursor: "pointer" }}
                    >
                      {investment.section_code || "-"}
                    </td>
                    <td className="text-center">
                      {typeof investment?.declared_amount === "number"
                        ? roundOffAmount
                          ? formatRoundoffComplete(investment?.declared_amount)
                          : formatRoundoff2D(investment?.declared_amount)
                        : "-"}
                    </td>
                    <td className="text-center">
                      {typeof investment?.max_limit === "number"
                        ? roundOffAmount
                          ? formatRoundoffComplete(investment?.max_limit)
                          : formatRoundoff2D(investment?.max_limit)
                        : "-"}
                    </td>
                    <td
                      request-status={investment?.declaration_status}
                      className="align-center request-status text-capitalize word-wrap-20vw"
                    >
                      {investment?.declaration_status || "-"}
                    </td>
                    <td className="text-center">
                      {typeof investment?.proof_amount === "number"
                        ? roundOffAmount
                          ? formatRoundoffComplete(investment?.proof_amount)
                          : formatRoundoff2D(investment?.proof_amount)
                        : "-"}
                    </td>
                    <td
                      className="align-center request-status text-capitalize word-wrap-20vw"
                      request-status={investment?.proof_status}
                    >
                      {investment?.proof_status || "-"}
                    </td>
                  </tr>
                ))}
                <tr className="font-weight600 bg-gray-100">
                  <td className="text-center">Total</td>
                  <td className="text-center">
                    {typeof totalInvDeclaredAmount === "number"
                      ? roundOffAmount
                        ? formatRoundoffComplete(totalInvDeclaredAmount)
                        : formatRoundoff2D(totalInvDeclaredAmount)
                      : "-"}
                  </td>
                  <td></td>
                  <td></td>
                  <td className="text-center">-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          ) : (
            <table
              className="table-css custom-table width-40vw"
              style={{ border: "0.5px solid #e8e8e8" }}
            >
              <tbody>
                <tr>
                  <td
                    colSpan={6}
                    className="text-center text-gray-500"
                    style={{ padding: "20px" }}
                  >
                    No data available
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </td>
      )}

      <td className="align-center">
        {typeof declaredTax.total_investment === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.total_investment)
            : formatRoundoff2D(declaredTax.total_investment)
          : "-"}
      </td>

      <td className="align-center">
        {typeof declaredTax.taxable_amount === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.taxable_amount)
            : formatRoundoff2D(declaredTax.taxable_amount)
          : "-"}
      </td>

      {detailsView && (
        <td className="align-center">
          <table
            className="table-css custom-table width-40vw"
            style={{ border: "0.5px solid #e8e8e8", borderRadius: "0px" }}
          >
            <thead>
              <tr className="custom-table-head-tr">
                <th className="text-center font-size-subheading font-weight600">
                  Rate (%)
                </th>
                <th className="text-center font-size-subheading font-weight600">
                  Range (Min - Max)
                </th>
                <th className="text-center font-size-subheading font-weight600">
                  Slab Income
                </th>
                <th className="text-center font-size-subheading font-weight600">
                  Slab Tax
                </th>
              </tr>
            </thead>
            <tbody>
              {declaredTax.slab_breakdown &&
              declaredTax.slab_breakdown.length > 0 ? (
                <>
                  {declaredTax.slab_breakdown.map((slab, slabIndex) => {
                    const min = slab.min_income
                      ? slab.min_income.toLocaleString("en-IN")
                      : "0";
                    const max = slab.max_income
                      ? slab.max_income.toLocaleString("en-IN")
                      : "∞";
                    const range = `${min} - ${max}`;

                    return (
                      <tr key={slabIndex}>
                        <td className="text-center">
                          {slab.rate_percent ? `${slab.rate_percent}%` : "0%"}
                        </td>
                        <td className="text-center">{range}</td>
                        <td className="text-center">
                          {typeof slab.taxable_amount === "number"
                            ? roundOffAmount
                              ? formatRoundoffComplete(slab.taxable_amount)
                              : formatRoundoff2D(slab.taxable_amount)
                            : "-"}
                        </td>
                        <td className="text-center">
                          {typeof slab.tax === "number"
                            ? roundOffAmount
                              ? formatRoundoffComplete(slab.tax)
                              : formatRoundoff2D(slab.tax)
                            : "-"}
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="font-weight600 bg-gray-100">
                    <td className="text-start" colSpan={2}>
                      Total
                    </td>
                    <td className="text-center">
                      {declaredTax.slab_breakdown
                        .reduce(
                          (sum, slab) => sum + (slab.taxable_amount || 0),
                          0,
                        )
                        .toLocaleString("en-IN")}
                    </td>
                    <td className="text-center">
                      {declaredTax.slab_breakdown
                        .reduce((sum, slab) => sum + (slab.tax || 0), 0)
                        .toLocaleString("en-IN")}
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan={4} className="text-center text-gray-500">
                    No slab data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </td>
      )}

      <td className="align-center">
        {typeof declaredTax.slab_tax_raw === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.slab_tax_raw)
            : formatRoundoff2D(declaredTax.slab_tax_raw)
          : "-"}
      </td>

      <td className="align-center">
        {typeof declaredTax.rebate_applied === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.rebate_applied)
            : formatRoundoff2D(declaredTax.rebate_applied)
          : "-"}
      </td>

      <td className="align-center">
        {typeof declaredTax.surcharge_amount === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.surcharge_amount)
            : formatRoundoff2D(declaredTax.surcharge_amount)
          : "-"}
      </td>

      <td className="align-center">{declaredTax.cess_percent || "0"}%</td>

      <td className="align-center">
        {typeof declaredTax.cess_amount === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.cess_amount)
            : formatRoundoff2D(declaredTax.cess_amount)
          : "-"}
      </td>

      <td className="align-center">
        {typeof declaredTax.annual_tax === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.annual_tax)
            : formatRoundoff2D(declaredTax.annual_tax)
          : "-"}
      </td>

      <td className="align-center">
        {totalArrearAmount > 0 ? (
          <CustomTooltip position="top" tooltipContent={arrearTooltip}>
            <span
              style={{
                cursor: "help",
              }}
            >
              {totalArrearAmount.toLocaleString("en-IN")}
            </span>
          </CustomTooltip>
        ) : (
          "-"
        )}
      </td>

      {/* <td className="align-center">
        {typeof declaredTax.monthly_tds_final === 'number'
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.monthly_tds_final)
            : formatRoundoff2D(declaredTax.monthly_tds_final)
          : '-'}
      </td> */}
      <td className="align-center">
        <CustomTooltip
          position="top"
          tooltipContent={
            <div className="tds-tooltip">
              <div>
                <strong>Annual Tax (Declared):</strong> ₹
                {formatRoundoff2D(calculationDetails?.annual_tax_declared ?? 0)}
              </div>
              <div>
                <strong>Annual Tax (After Proof):</strong> ₹
                {formatRoundoff2D(calculationDetails.annual_tax_proof ?? 0)}
              </div>
              <div>
                <strong>Tax Difference:</strong> ₹
                {formatRoundoff2D(
                  calculationDetails.annual_tax_difference ?? 0,
                )}
              </div>

              <hr />

              <div>
                <strong>Normal Monthly TDS:</strong> ₹
                {formatRoundoff2D(
                  calculationDetails?.final_tax_summary?.normal_months
                    ?.monthly_tds_actual,
                )}
              </div>
              <div>
                <strong>Adjustment Months:</strong>{" "}
                {getMonthYearNameFromDate(
                  calculationDetails?.adjustment_month_start,
                )}
                -
                {getMonthYearNameFromDate(
                  calculationDetails?.adjustment_month_end,
                )}
              </div>
              <div>
                <strong>Per Month Amount:</strong>{" "}
                {/* {Math.abs(
                  (calculationDetails?.annual_tax_difference || 0) /
                  (calculationDetails?.adjustment_months_remaining || 1)
                )} */}
                ₹{formatRoundoff2D(calculationDetails?.monthly_adjustment ?? 0)}
              </div>

              <div>
                <strong>Final Monthly TDS (Adjustment):</strong>₹
                {formatRoundoff2D(
                  calculationDetails.final_monthly_tds_after_adjustment_from_proof ??
                    0,
                )}
              </div>
            </div>
          }
        >
          <span className="cursor-pointer">
            {typeof calculationDetails?.final_tax_summary?.final_monthly_tds ===
            "number"
              ? roundOffAmount
                ? formatRoundoffComplete(
                    calculationDetails?.final_tax_summary?.final_monthly_tds,
                  )
                : formatRoundoff2D(
                    calculationDetails?.final_tax_summary?.final_monthly_tds,
                  )
              : "-"}
          </span>
        </CustomTooltip>
      </td>

      <td className="align-center">
        {typeof declaredTax.monthly_tds_remaining === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(declaredTax.monthly_tds_remaining)
            : formatRoundoff2D(declaredTax.monthly_tds_remaining)
          : "-"}
      </td>
    </>
  );
};

// Helper component for saved tax row
const SavedTaxRow = ({
  taxData,
  roundOffAmount,
  detailsView,
  selectedDataType,
  showBoth,
}) => {
  // Access saved tax data directly from taxData, not from taxData.data
  const savedTax = taxData?.declared_tax_details;
  const savedCalculationDetails = taxData?.calculation_tax_details;
  const otherIncomeDetails =
    taxData?.other_income_summary?.other_income_details || [];
  const otherInvestmentDetails =
    taxData?.other_investment_summary?.other_investment_details || [];

  // handle error state (no current + no saved)
  if (!taxData?.has_tax_saved) {
    // Calculate correct colspan based on whether we're showing both rows
    const baseColspan = detailsView ? 25 : 18;
    const errorColspan = showBoth ? baseColspan : baseColspan + 8; // Add 8 for basic info columns

    return (
      <td colSpan={errorColspan} className="align-center error-message">
        <div className="flex-row justify-center align-center">
          <span>{taxData?.message || "No tax data available"}</span>
        </div>
      </td>
    );
  }
  if (!savedTax) return null;

  const totalIncomeDeclaredAmount = otherIncomeDetails?.reduce(
    (sum, item) => sum + (Number(item?.declared_amount) || 0),
    0,
  );

  const totalInvDeclaredAmount = otherInvestmentDetails?.reduce(
    (sum, item) => sum + (Number(item?.declared_amount) || 0),
    0,
  );

  const totalArrearAmount =
    savedCalculationDetails?.current_arrear_details?.total_arrear_amount || 0;

  const getArrearCalculation = (arrearDetails) => {
    const request = arrearDetails?.arrear_details?.arrear_request_details;

    const nature = request?.request_details?.nature_type;
    const calculationDetails = request?.calculation_details || [];

    const approvedDays = arrearDetails?.arrear_approved_days ?? 0;
    const approvedAmount = arrearDetails?.arrear_approved_amount ?? 0;
    const monthsArray = arrearDetails?.arrear_details_for_months || [];

    // default values
    let perUnitSalary = 0;
    let calculatedAmount = 0;
    let unitLabel = "";

    // base salary source (safe)
    const baseMonth = calculationDetails[0];
    const monthlySalary = baseMonth?.ef_salary_final_amount ?? 0;
    const daysInMonth = baseMonth?.total_days_of_month ?? 0;

    switch (nature) {
      // case "days":
      //   unitLabel = "Per Day Salary";
      //   perUnitSalary =
      //     daysInMonth > 0 ? monthlySalary / daysInMonth : 0;
      //   calculatedAmount = perUnitSalary;
      //   break;

      case "days": {
        const month = calculationDetails[0];
        const monthlySalary = month?.ef_salary_final_amount ?? 0;
        const daysInMonth = month?.total_days_of_month ?? 0;

        unitLabel = "Per Day Salary";
        perUnitSalary = daysInMonth > 0 ? monthlySalary / daysInMonth : 0;

        calculatedAmount = perUnitSalary;
        break;
      }

      case "months": {
        unitLabel = "Per Month Salary";

        calculatedAmount = calculationDetails.reduce((sum, m) => {
          return sum + (m?.ef_salary_final_amount ?? 0);
        }, 0);

        break;
      }

      case "amount":
        unitLabel = "Approved Amount";
        calculatedAmount = approvedAmount;
        break;

      default:
        calculatedAmount = arrearDetails?.total_arrear_amount ?? 0;
    }

    return {
      nature,
      unitLabel,
      perUnitSalary,
      approvedDays,
      approvedAmount,
      approvedMonths: calculationDetails.length,
      calculatedAmount,
    };
  };

  const arrearCalc = getArrearCalculation(
    savedCalculationDetails?.current_arrear_details,
  );

  const arrearTooltip = (
    <div className="arrear-tooltip">
      {/* Header */}
      <div style={{ marginBottom: "8px" }}>
        <strong>
          Total Arrears: ₹{totalArrearAmount.toLocaleString("en-IN")}
        </strong>
      </div>
      <hr className="field-cont-hr" />
      {/* Arrear Items */}

      <div style={{ marginBottom: "10px" }}>
        {/* Month */}
        <div className="font-weight600">
          {getMonthName(
            savedCalculationDetails?.current_arrear_details?.arrear_details
              ?.arrear_request_details?.request_details?.applicable_month,
          )}{" "}
          {
            savedCalculationDetails?.current_arrear_details?.arrear_details
              ?.arrear_request_details?.request_details?.applicable_year
          }
        </div>

        {/* Bullet Details */}
        <div style={{ paddingLeft: "10px" }}>
          <div className="text-capitalize">
            • Nature:{" "}
            {
              savedCalculationDetails?.current_arrear_details?.arrear_details
                ?.arrear_request_details?.request_details?.nature_type
            }
          </div>

          {/* Days / Months */}
          {(savedCalculationDetails?.current_arrear_details?.arrear_details
            ?.arrear_request_details?.request_details?.nature_type === "days" ||
            savedCalculationDetails?.current_arrear_details?.arrear_details
              ?.arrear_request_details?.request_details?.nature_type ===
              "months") && (
            <div>
              • Approved Days:{" "}
              {
                savedCalculationDetails?.current_arrear_details?.arrear_details
                  ?.arrear_request_details?.request_details?.approved_days
              }
            </div>
          )}

          {/* Amount */}
          <div>
            • Amount: {arrearCalc.calculatedAmount.toLocaleString("en-IN")}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <td className="align-center">
        {typeof savedTax.monthly_gross_salary === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.monthly_gross_salary)
            : formatRoundoff2D(savedTax.monthly_gross_salary)
          : "-"}
      </td>

      <td className="align-center">
        <CustomTooltip
          position="top"
          tooltipContent={
            <div
              style={{
                padding: "12px",
                fontSize: "13px",
                lineHeight: "1.8",
                minWidth: "260px",
              }}
            >
              {savedTax.is_part_year_employee && (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Previous Company Salary Amount : </span>
                  &nbsp; &nbsp;
                  <strong>
                    {" "}
                    {savedCalculationDetails?.annual_income_summary?.components?.prev_company_salary?.toLocaleString(
                      "en-IN",
                    ) || "0"}
                  </strong>
                </div>
              )}

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>Current Company Salary : </span>
                <strong>
                  {" "}
                  {savedCalculationDetails?.annual_income_summary?.components?.current_company_actual?.toLocaleString(
                    "en-IN",
                  ) || "0"}
                </strong>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>Annual Arrear: </span>
                <strong>
                  {" "}
                  {savedCalculationDetails?.arrear_details_summary?.total_arrear_amount?.toLocaleString(
                    "en-IN",
                  ) || "0"}
                  {/* {savedCalculationDetails?.annual_income_summary?.components?.arrears?.toLocaleString("en-IN") || "0"} */}
                </strong>
              </div>
            </div>
          }
        >
          <div>
            {typeof savedTax.annual_gross_salary === "number"
              ? roundOffAmount
                ? formatRoundoffComplete(savedTax.annual_gross_salary)
                : formatRoundoff2D(savedTax.annual_gross_salary)
              : "-"}
          </div>
        </CustomTooltip>
      </td>

      <td className="align-center">
        {typeof savedTax.standard_deduction === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.standard_deduction)
            : formatRoundoff2D(savedTax.standard_deduction)
          : "-"}
      </td>

      <td className="align-center">
        {typeof savedTax.income_after_standard_deduction === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.income_after_standard_deduction)
            : formatRoundoff2D(savedTax.income_after_standard_deduction)
          : "-"}
      </td>

      {detailsView && (
        <td className="align-center">
          {otherIncomeDetails && otherIncomeDetails.length > 0 ? (
            <table
              className="table-css custom-table width-40vw"
              style={{ border: "0.5px solid #e8e8e8", borderRadius: "0px" }}
            >
              <thead>
                <tr className="custom-table-head-tr">
                  <th className="text-center font-size-subheading font-weight600">
                    Section
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Declared Amount
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Declaration Status
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Proof Amount
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Proof Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {otherIncomeDetails.map((income, incomeIndex) => (
                  <tr key={incomeIndex}>
                    <td
                      className="text-center"
                      title={income.section_desc}
                      style={{ cursor: "pointer" }}
                    >
                      {income?.section_code || "-"}
                    </td>
                    <td className="text-center">
                      {typeof income.declared_amount === "number"
                        ? roundOffAmount
                          ? formatRoundoffComplete(income.declared_amount)
                          : formatRoundoff2D(income.declared_amount)
                        : "-"}
                    </td>
                    <td
                      className="align-center request-status text-capitalize word-wrap-20vw"
                      request-status={income?.declaration_status}
                    >
                      {income?.declaration_status || "-"}
                    </td>
                    <td className="text-center">
                      {typeof income?.proof_amount === "number"
                        ? roundOffAmount
                          ? formatRoundoffComplete(income?.proof_amount)
                          : formatRoundoff2D(income?.proof_amount)
                        : "-"}
                    </td>
                    <td
                      className="align-center request-status text-capitalize word-wrap-20vw"
                      request-status={income?.proof_status}
                    >
                      {income?.proof_status || "-"}
                    </td>
                  </tr>
                ))}
                <tr className="font-weight600 bg-gray-100">
                  <td className="text-center">Total</td>
                  <td className="text-center">
                    {typeof totalIncomeDeclaredAmount === "number"
                      ? roundOffAmount
                        ? formatRoundoffComplete(totalIncomeDeclaredAmount)
                        : formatRoundoff2D(totalIncomeDeclaredAmount)
                      : "-"}
                  </td>
                  <td></td>
                  <td className="text-center">-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          ) : (
            <table
              className="table-css custom-table width-40vw"
              style={{ border: "0.5px solid #e8e8e8" }}
            >
              <tbody>
                <tr>
                  <td
                    colSpan={5}
                    className="text-center text-gray-500"
                    style={{ padding: "20px" }}
                  >
                    No data available
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </td>
      )}

      <td className="align-center">
        {typeof savedTax.total_income === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.total_income)
            : formatRoundoff2D(savedTax.total_income)
          : "-"}
      </td>

      {detailsView && (
        <td className="align-center">
          {otherInvestmentDetails && otherInvestmentDetails.length > 0 ? (
            <table
              className="table-css custom-table width-40vw"
              style={{ border: "0.5px solid #e8e8e8", borderRadius: "0px" }}
            >
              <thead>
                <tr className="custom-table-head-tr">
                  <th className="text-center font-size-subheading font-weight600">
                    Section
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Declared Amount
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Max Limit
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Declaration Status
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Proof Amount
                  </th>
                  <th className="text-center font-size-subheading font-weight600">
                    Proof Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {otherInvestmentDetails.map((investment, investmentIndex) => (
                  <tr key={investmentIndex}>
                    <td
                      className="text-center"
                      title={investment.section_desc}
                      style={{ cursor: "pointer" }}
                    >
                      {investment.section_code || "-"}
                    </td>
                    <td className="text-center">
                      {typeof investment?.declared_amount === "number"
                        ? roundOffAmount
                          ? formatRoundoffComplete(investment?.declared_amount)
                          : formatRoundoff2D(investment?.declared_amount)
                        : "-"}
                    </td>
                    <td className="text-center">
                      {typeof investment?.max_limit === "number"
                        ? roundOffAmount
                          ? formatRoundoffComplete(investment?.max_limit)
                          : formatRoundoff2D(investment?.max_limit)
                        : "-"}
                    </td>
                    <td
                      request-status={investment?.declaration_status}
                      className="align-center request-status text-capitalize word-wrap-20vw"
                    >
                      {investment?.declaration_status || "-"}
                    </td>
                    <td className="text-center">
                      {typeof investment?.proof_amount === "number"
                        ? roundOffAmount
                          ? formatRoundoffComplete(investment?.proof_amount)
                          : formatRoundoff2D(investment?.proof_amount)
                        : "-"}
                    </td>
                    <td
                      className="align-center request-status text-capitalize word-wrap-20vw"
                      request-status={investment?.proof_status}
                    >
                      {investment?.proof_status || "-"}
                    </td>
                  </tr>
                ))}
                <tr className="font-weight600 bg-gray-100">
                  <td className="text-center">Total</td>
                  <td className="text-center">
                    {typeof totalInvDeclaredAmount === "number"
                      ? roundOffAmount
                        ? formatRoundoffComplete(totalInvDeclaredAmount)
                        : formatRoundoff2D(totalInvDeclaredAmount)
                      : "-"}
                  </td>
                  <td></td>
                  <td></td>
                  <td className="text-center">-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          ) : (
            <table
              className="table-css custom-table width-40vw"
              style={{ border: "0.5px solid #e8e8e8" }}
            >
              <tbody>
                <tr>
                  <td
                    colSpan={6}
                    className="text-center text-gray-500"
                    style={{ padding: "20px" }}
                  >
                    No data available
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </td>
      )}

      <td className="align-center">
        {typeof savedTax.total_investment === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.total_investment)
            : formatRoundoff2D(savedTax.total_investment)
          : "-"}
      </td>

      <td className="align-center">
        {typeof savedTax.taxable_amount === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.taxable_amount)
            : formatRoundoff2D(savedTax.taxable_amount)
          : "-"}
      </td>

      {detailsView && (
        <td className="align-center">
          <table
            className="table-css custom-table width-40vw"
            style={{ border: "0.5px solid #e8e8e8", borderRadius: "0px" }}
          >
            <thead>
              <tr className="custom-table-head-tr">
                <th className="text-center font-size-subheading font-weight600">
                  Rate (%)
                </th>
                <th className="text-center font-size-subheading font-weight600">
                  Range (Min - Max)
                </th>
                <th className="text-center font-size-subheading font-weight600">
                  Slab Income
                </th>
                <th className="text-center font-size-subheading font-weight600">
                  Slab Tax
                </th>
              </tr>
            </thead>
            <tbody>
              {savedTax.slab_breakdown && savedTax.slab_breakdown.length > 0 ? (
                <>
                  {savedTax.slab_breakdown.map((slab, slabIndex) => {
                    const min = slab.min_income
                      ? slab.min_income.toLocaleString("en-IN")
                      : "0";
                    const max = slab.max_income
                      ? slab.max_income.toLocaleString("en-IN")
                      : "∞";
                    const range = `${min} - ${max}`;

                    return (
                      <tr key={slabIndex}>
                        <td className="text-center">
                          {slab.rate_percent ? `${slab.rate_percent}%` : "0%"}
                        </td>
                        <td className="text-center">{range}</td>
                        <td className="text-center">
                          {typeof slab.taxable_amount === "number"
                            ? roundOffAmount
                              ? formatRoundoffComplete(slab.taxable_amount)
                              : formatRoundoff2D(slab.taxable_amount)
                            : "-"}
                        </td>
                        <td className="text-center">
                          {typeof slab.tax === "number"
                            ? roundOffAmount
                              ? formatRoundoffComplete(slab.tax)
                              : formatRoundoff2D(slab.tax)
                            : "-"}
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="font-weight600 bg-gray-100">
                    <td className="text-start" colSpan={2}>
                      Total
                    </td>
                    <td className="text-center">
                      {savedTax.slab_breakdown
                        .reduce(
                          (sum, slab) => sum + (slab.taxable_amount || 0),
                          0,
                        )
                        .toLocaleString("en-IN")}
                    </td>
                    <td className="text-center">
                      {savedTax.slab_breakdown
                        .reduce((sum, slab) => sum + (slab.tax || 0), 0)
                        .toLocaleString("en-IN")}
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan={4} className="text-center text-gray-500">
                    No slab data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </td>
      )}

      <td className="align-center">
        {typeof savedTax.slab_tax_raw === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.slab_tax_raw)
            : formatRoundoff2D(savedTax.slab_tax_raw)
          : "-"}
      </td>

      <td className="align-center">
        {typeof savedTax.rebate_applied === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.rebate_applied)
            : formatRoundoff2D(savedTax.rebate_applied)
          : "-"}
      </td>

      <td className="align-center">
        {typeof savedTax.surcharge_amount === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.surcharge_amount)
            : formatRoundoff2D(savedTax.surcharge_amount)
          : "-"}
      </td>

      <td className="align-center">{savedTax.cess_percent || "0"}%</td>

      <td className="align-center">
        {typeof savedTax.cess_amount === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.cess_amount)
            : formatRoundoff2D(savedTax.cess_amount)
          : "-"}
      </td>

      <td className="align-center">
        {typeof savedTax.annual_tax === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.annual_tax)
            : formatRoundoff2D(savedTax.annual_tax)
          : "-"}
      </td>

      <td className="align-center">
        {totalArrearAmount > 0 ? (
          <CustomTooltip position="top" tooltipContent={arrearTooltip}>
            <span
              style={{
                cursor: "help",
              }}
            >
              {totalArrearAmount.toLocaleString("en-IN")}
            </span>
          </CustomTooltip>
        ) : (
          "-"
        )}
      </td>

      {/* <td className="align-center">
        {typeof savedTax.monthly_tds_final === 'number'
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.monthly_tds_final)
            : formatRoundoff2D(savedTax.monthly_tds_final)
          : '-'}
      </td> */}
      <td className="align-center">
        <CustomTooltip
          position="top"
          tooltipContent={
            <div className="tds-tooltip">
              <div>
                <strong>Annual Tax (Declared):</strong> ₹
                {formatRoundoff2D(
                  savedCalculationDetails.annual_tax_declared ?? 0,
                )}
              </div>
              <div>
                <strong>Annual Tax (After Proof):</strong> ₹
                {formatRoundoff2D(
                  savedCalculationDetails.annual_tax_proof ?? 0,
                )}
              </div>
              <div>
                <strong>Tax Difference:</strong> ₹
                {formatRoundoff2D(
                  savedCalculationDetails.annual_tax_difference ?? 0,
                )}
              </div>

              <hr />

              <div>
                <strong>Normal Monthly TDS:</strong> ₹
                {formatRoundoff2D(
                  savedCalculationDetails?.final_tax_summary?.normal_months
                    ?.monthly_tds_actual,
                )}
              </div>
              <div>
                <strong>Adjustment Months:</strong>{" "}
                {getMonthYearNameFromDate(
                  savedCalculationDetails?.adjustment_month_start,
                )}
                -
                {getMonthYearNameFromDate(
                  savedCalculationDetails?.adjustment_month_end,
                )}
              </div>
              <div>
                <strong>Per Month Amount:</strong>{" "}
                {/* {Math.abs(
                  (savedCalculationDetails?.annual_tax_difference || 0) /
                  (savedCalculationDetails?.adjustment_months_remaining || 1)
                )} */}
                ₹
                {formatRoundoff2D(
                  savedCalculationDetails?.monthly_adjustment ?? 0,
                )}
              </div>

              <div>
                <strong>Final Monthly TDS (Adjustment):</strong>₹
                {formatRoundoff2D(
                  savedCalculationDetails.final_monthly_tds_after_adjustment_from_proof ??
                    0,
                )}
              </div>
            </div>
          }
        >
          <span className="cursor-pointer">
            {typeof savedCalculationDetails?.final_tax_summary
              ?.final_monthly_tds === "number"
              ? roundOffAmount
                ? formatRoundoffComplete(
                    savedCalculationDetails?.final_tax_summary
                      ?.final_monthly_tds,
                  )
                : formatRoundoff2D(
                    savedCalculationDetails?.final_tax_summary
                      ?.final_monthly_tds,
                  )
              : "-"}
          </span>
        </CustomTooltip>
      </td>

      <td className="align-center">
        {typeof savedTax.monthly_tds_remaining === "number"
          ? roundOffAmount
            ? formatRoundoffComplete(savedTax.monthly_tds_remaining)
            : formatRoundoff2D(savedTax.monthly_tds_remaining)
          : "-"}
      </td>
    </>
  );
};

const SubmitTaxCalculationModal = ({
  save_data = true,
  selectedEmployees,
  month,
  year,
  onSuccess,
  onClose,
  isAnyInvalid,
  payrunStatus,
  permissions,
}) => {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const { SUPER_ADMIN } = usePermission();

  const [toggleCompany, setToggleCompany] = useState(
    sessionStorage.getItem("company_id"),
  );
  const [showResults, setShowResults] = useState(false);
  const [results, setResults] = useState(null);

  // Initialize state with prop data
  const [data, setData] = useState({
    dry_run: false,
    updated_by: sessionStorage.getItem("emp_code"),
    emp_list: selectedEmployees || [],
  });
  console.log(permissions, "permissions");

  // const handleShow = () => {
  //   if (selectedEmployees) {
  //     setData(prev => ({
  //       ...prev,
  //       emp_list: selectedEmployees
  //     }));
  //   }
  //   setShow(true);
  // };

  const getValidationError = () => {
    for (const emp of selectedEmployees) {
      const empCode = emp.employee_details?.emp_code;
      const lastPayrunMonth = payrunStatus?.[empCode]; // e.g. "2025-12"
      console.log(lastPayrunMonth, "last");

      if (!lastPayrunMonth) {
        continue;
        // return `Payroll data not found for employee ${empCode}`;
      }

      const [lastYear, lastMonth] = lastPayrunMonth.split("-").map(Number);

      const nextAllowedDate = new Date(lastYear, lastMonth, 1);
      const selectedDate = new Date(year, month - 1, 1);

      if (
        !permissions?.allow_tds_save_if_salary_slip_exists &&
        selectedDate.getTime() !== nextAllowedDate.getTime()
      ) {
        const lastLabel = new Date(lastYear, lastMonth - 1).toLocaleString(
          "en-IN",
          {
            month: "short",
            year: "numeric",
          },
        );

        const nextLabel = nextAllowedDate.toLocaleString("en-IN", {
          month: "short",
          year: "numeric",
        });

        return `Employee ${empCode}: Last payroll is ${lastLabel}. Please process ${nextLabel} first.`;
      }
    }

    return null; // all valid
  };

  const handleShow = () => {
    if (!selectedEmployees || selectedEmployees.length === 0) {
      toast.error("Please select employees to submit");
      return;
    }

    // if (isAnyInvalid) {
    //   toast.error("TDS can be run only after the last payroll month for all selected employees.");
    //   return;
    // }
    const errorMessage = getValidationError();

    if (errorMessage) {
      toast.error(errorMessage);
      return;
    }

    setData((prev) => ({
      ...prev,
      emp_list: selectedEmployees,
    }));

    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    onClose?.();
  };

  const selectedMonth = `${year}-${String(month).padStart(2, "0")}`;

  // const isInvalidInsideModal = selectedEmployees.some(emp => {
  //   const empCode = emp.employee_details?.emp_code;
  //   const lastMonth = payrunStatus?.[empCode];
  //   return !lastMonth || lastMonth !== selectedMonth;
  // });

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      emp_list: selectedEmployees || [],
    }));
  }, [selectedEmployees]);

  const handleSubmit = async () => {
    if (!data.emp_list || data.emp_list.length === 0) {
      toast.error("Please select employees to submit");
      return;
    }

    if (!month || !year) {
      toast.error("Month and Year are required");
      return;
    }
    // if (isAnyInvalid) {
    //   toast.error("Please complete payroll for selected month for all selected employees");
    //   return;
    // }

    setLoading(true);
    try {
      // Extract emp_codes from employees in state
      const empCodes = data.emp_list
        .map((emp) => {
          // Handle both nested structure and flat structure
          return emp?.employee_details?.emp_code || emp.emp_code;
        })
        .filter((code) => code); // Remove any null/undefined values

      if (empCodes.length === 0) {
        toast.error("No valid employee codes found");
        return;
      }
      console.log("empCodes-", empCodes);
      // Prepare payload according to the expected API structure
      const payload = {
        ...data,
        dry_run: data.dry_run,
        updated_by: data.updated_by,
        emp_list: empCodes, // Use the array of emp_codes
        month: parseInt(month, 10),
        year: parseInt(year, 10),
        // Add other data from state that should be sent
      };

      console.log("Submitting payload:", payload);

      const response = await axios.post(
        // `${BASE_URL}/wfm/bulk-save-tax-calculation/`,
        `${BASE_URL}/wfm/calculate-save-monthly-tds-bysubcompany-bymonth-bysavedata/${toggleCompany}/null/${year}/${month}/${save_data}/`,
        payload,
      );

      if (response.data) {
        // Directly use the standardized response
        setResults(response.data);
        setShowResults(true);
        setShow(false);

        if (!data.dry_run && response.data.summary.failed_count === 0) {
          toast.success(
            `Successfully saved tax data for ${response.data.summary.successful_count} employee(s)`,
          );
        }
      } else {
        toast.error(response.data.message || "Failed to save tax data");
      }
      // if (response.data.success) {
      //   toast.success(`Successfully saved tax data for ${data.emp_list.length} employee(s)`);
      //   onSuccess?.();
      //   handleClose();
      // } else {
      //   toast.error(response.data.message || 'Failed to save tax data');
      // }
    } catch (error) {
      console.error("Error submitting tax calculation:", error);
      toast.error(error.response?.data?.message || "Failed to save tax data");
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get employee details safely
  const getEmployeeDetail = (emp, key) => {
    return emp.employee_details?.[key] || emp[key] || "N/A";
  };

  return (
    <>
      <button
        className="priority-button model-button-submit"
        title="Save Selected Tax Calculations"
        onClick={handleShow}
      >
        Submit
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="three-fourth-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Submit Tax Calculation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <div className="form-column" style={{ padding: "15px" }}>
              {SUPER_ADMIN && (
                <div className="flex-row justify-between">
                  <div className="flex-row align-end">
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        id="dry_run"
                        checked={data.dry_run}
                        onChange={(e) =>
                          setData((prev) => ({
                            ...prev,
                            dry_run: e.target.checked,
                          }))
                        }
                      />
                      <label htmlFor="dry_run"></label>
                    </div>
                    <hr className="field-cont-hr" />
                    <label
                      htmlFor="dry_run"
                      className="form-labels"
                      style={{ cursor: "pointer" }}
                    >
                      Dry-run Mode (validate only, no database changes)
                    </label>
                  </div>
                </div>
              )}
            </div>

            <p>
              You are about to save tax calculation for the following employees:
            </p>

            {/* Employee list summary */}
            {/* <ul className="list-group">
              {data.emp_list.map((emp, index) => (
                <li key={index} className="list-group-item">
                  {getEmployeeDetail(emp, 'emp_code')} - {getEmployeeDetail(emp, 'emp_name')}
                </li>
              ))}
            </ul> */}

            {/* <p className="mt-3">
              <strong>Month:</strong> {month}, <strong>Year:</strong> {year}
            </p>
            <p className="mt-2">
              <strong>Total Employees:</strong> {data.emp_list.length}
            </p> */}

            {/* Detailed table showing all data from state */}
            <div className="table-container" style={{ marginBottom: "20px" }}>
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="table-heading align-center">Emp Code</th>
                    <th className="table-heading align-center">Emp Name</th>
                    <th className="table-heading align-center">
                      Monthly TDS (Declared)
                    </th>
                    <th className="table-heading align-center">
                      Final Monthly TDS
                    </th>
                    <th className="table-heading align-center">
                      Employee Status
                    </th>
                  </tr>
                </thead>

                <tbody className="align-center">
                  {data.emp_list.map((emp, index) => {
                    const isSelected = selectedEmployees?.some(
                      (e) =>
                        getEmployeeDetail(e, "emp_code") ===
                        getEmployeeDetail(emp, "emp_code"),
                    );

                    return (
                      <tr
                        key={`${getEmployeeDetail(emp, "emp_code")}-${index}`}
                        className={`custom-table-head-td ${isSelected ? "row-selected" : ""}`}
                      >
                        <td>{getEmployeeDetail(emp, "emp_code")}</td>
                        <td>{getEmployeeDetail(emp, "emp_name")}</td>
                        <td>
                          ₹
                          {emp?.current_tax_calculation?.declared_tax_details.monthly_tds_final?.toLocaleString(
                            "en-IN",
                          ) || "0"}
                        </td>
                        <td>
                          ₹
                          {emp?.current_tax_calculation?.calculation_tax_details?.final_tax_summary?.final_monthly_tds?.toLocaleString(
                            "en-IN",
                          ) || "0"}
                        </td>

                        <td
                          className={`text-capitalize align-center ${
                            getEmployeeDetail(emp, "employee_status") ===
                            "active"
                              ? "text-success-color"
                              : "text-warning-color"
                          }`}
                        >
                          {getEmployeeDetail(emp, "employee_status")}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* <div className="p-3 bg-light rounded mb-3">
              <h6>Json Data to be sent in API:</h6>
              <pre className="mb-0" style={{ fontSize: '12px', overflow: 'auto', maxHeight: '150px' }}>
                {JSON.stringify({
                  dry_run: data.dry_run,
                  updated_by: data.updated_by,
                  emp_list: data.emp_list.map(emp => getEmployeeDetail(emp, 'emp_code')),
                  month: parseInt(month, 10),
                  year: parseInt(year, 10),
                  total_employees: data.emp_list.length
                }, null, 2)}
              </pre>
            </div> */}

            <p className="text-warning">
              <small>
                This will overwrite any previously saved tax data for these
                employees.
              </small>
            </p>
          </div>

          <div className="button-models">
            <button
              className="model-button model-button-cancel"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              className="model-button model-button-submit"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : `Confirm & Save (${data.emp_list.length} employees)`}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer position="top-center" autoClose={5000} />

      {/* Bulk Summary */}
      {showResults && results && (
        <MultipleBulkApiResultSummaryModal
          show={showResults}
          handleClose={() => {
            setShowResults(false);
            if (data.dry_run || results.summary?.failed_count > 0) {
              setShow(true);
            } else {
              handleClose();
              onSuccess?.();
            }
          }}
          handleComplete={() => {
            setShowResults(false);
            if (!data.dry_run && results.summary?.failed_count === 0) {
              handleClose();
              onSuccess?.();
            } else {
              setShow(true);
            }
          }}
          handleRetry={(resultData) => {
            if (data.dry_run) {
              setData((prev) => ({ ...prev, dry_run: false }));
              setShowResults(false);
              setShow(true);
            }
          }}
          resultsList={results}
          isDryRun={data.dry_run}
          fileName={`tax-calculation-${month}-${year}`}
          operationType="TAX_CALCULATION"
          restData={{
            updatedBy: data.updated_by,
            message: results.message || "Tax calculation completed",
          }}
          // Optional custom config
          config={{
            fieldMappings: {
              created_count: {
                label: "Created",
                display: true,
                color: "success",
              },
              updated_count: {
                label: "Updated",
                display: true,
                color: "warning",
              },
              total_monthly_tds_amount: {
                label: "Total TDS",
                display: true,
                color: "info",
              },
            },
          }}
        />
      )}
    </>
  );
};

// const EmployeeDetails = () => {
//   const [designationname, setDesignationname] = useState([]);

//   const [departmentname, setDepartmentname] = useState([]);
//   const [selectedRemark, setRemark] = useState("");
//   const [buffer, setBuffering] = useState(false); //buffering logic
//   const [buffer1, setBuffering1] = useState(false); //buffering logic

//   const [emp_codes, setEmp_codes] = useState([]);
//   const getDesignation = async () => {
//     setBuffering1(true); //buffering logic
//     try {
//       const des = await axios.get(`${BASE_URL}/wfm/designation/`);
//       const dep = await axios.get(`${BASE_URL}/wfm/department/`);
//       const emp = await axios.get(`${BASE_URL}/wfm/ourcompanyempdetails/active/${sessionStorage.getItem('company_id')}/`);

//       setDesignationname(des.data);
//       setDepartmentname(dep.data);

//       const getAlphaNumericParts = (code) => {
//         const match = code.match(/^([A-Za-z]+)(\d+)$/); // Match alphabetic and numeric parts
//         if (match) {
//           return { alphaPart: match[1], numericPart: parseInt(match[2], 10) };
//         } else {
//           return { alphaPart: '', numericPart: 0 };
//         }
//       };

//       const sortedList = emp.data.sort((a, b) => {
//         const { alphaPart: alphaA, numericPart: numericA } = getAlphaNumericParts(a.emp_code);
//         const { alphaPart: alphaB, numericPart: numericB } = getAlphaNumericParts(b.emp_code);

//         if (alphaA !== alphaB) {
//           return alphaA.localeCompare(alphaB); // Sort alphabetically
//         } else {
//           return numericA - numericB; // Then sort numerically
//         }
//       });
//       setEmp_codes(sortedList);
//     } catch (err) {
//       //toast Logic
//       // if (err.response) {
//       //   const errorData = err.response.data;

//       //   if (typeof errorData.error === 'string') {
//       //     // Single error message
//       //     toast.error(`Error: ${errorData.error}`);
//       //   } else if (typeof errorData === 'object' && errorData !== null) {
//       //     // Multiple error messages
//       //     Object.entries(errorData).forEach(([field, messages]) => {
//       //       messages.forEach(message => toast.error(`"${field}": ${message}`));
//       //     });
//       //   } else {
//       //     toast.error('Error:- Failed to Process!');
//       //   }
//       // } else {
//       //   toast.error('Error processing your request.');
//       // }
//     } finally {
//       setBuffering1(false);// End Buffering
//     }
//   };

//   useEffect(() => {
//     getDesignation();
//   }, []);

//   const [employeeDetailed, setemployeeDetailed] = useState([]);
//   const [employeeDetailedfilter, setemployeeDetailedfilter] = useState([]);

//   const today = new Date();
//   today.setDate(today.getDate() - 1);
//   const year = today.getFullYear();
//   const month = today.getMonth() + 1;
//   const month1 = today.getMonth() - 6;
//   const month2 = today.getMonth() + 1;
//   const day = today.getDate();

//   const monthNames = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
//     .toString()
//     .padStart(2, "0")}`;
//   var datearray = formattedDate.split("-");

//   var newdate = datearray[0] + "-" + datearray[1] + "-" + datearray[2];
//   console.log(newdate);

//   const [monthStart, setStartMonth] = useState(month1 > 0 ? `${month1}` : `1`);
//   const [monthEnd, setEndMonth] = useState(`${month2}`);
//   const [yearr, setYearr] = useState(`${year}`);
//   const [monthh, setMonthh] = useState(`${month}`);
//   const monthName = monthNames[monthh - 1];

//   const [monthlylist, setMonthlylist] = useState([]);
//   const [monthlylistfilter, setMonthlylistfilter] = useState([]);

//   const [selectedEmpcode, setSelectedEmpcode] = useState(
//     `${sessionStorage.getItem("emp_code")}`
//   );

//   const [toggleState, setToggleState] = useState("pending/");
//   // const [searchQuery, setSearchQuery] = useState("");
//   const [SubCompany, setSubCompany] = useState([]);

//   const getSubCompany = async () => {
//     // setBuffering(true); //buffering logic
//     try {
//       const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
//       setSubCompany(res.data);
//     } catch (err) {
//     } finally {
//       // setBuffering(false);// End Buffering
//     }
//   };

//   const getSalarylist = async () => {
//     setBuffering(true); //buffering logic
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/wfm/employeesalarysliplist/${selectedEmpcode}/`
//       );
//       setemployeeDetailed(res.data);
//     } catch (err) {
//       handleErrorToast(err)
//     } finally {
//       setBuffering(false);// End Buffering
//     }
//   };

//   const [selectedDivision, setDivision] = useState(
//     `${sessionStorage.getItem("company")}`
//   );

//   const applyFilters = () => {
//     let filteredData = employeeDetailed;

//     if (yearr) {
//       const selectedYear = yearr.toString();

//       filteredData = filteredData.filter((employee) => {
//         return employee.year === selectedYear;
//       });
//     }

//     if (monthStart && monthEnd) {
//       const startMonth = monthStart;
//       const endMonth = monthEnd;

//       filteredData = filteredData.filter((employee) => {
//         const empMonth = Number(employee.month);
//         return empMonth >= startMonth && empMonth <= endMonth;
//       });
//     }

//     setemployeeDetailedfilter(filteredData);
//   };

//   useEffect(() => {
//     applyFilters();
//   }, [monthStart, monthEnd, yearr, employeeDetailed]);

//   useEffect(() => {
//     getSubCompany();
//     getSalarylist();
//   }, [selectedEmpcode]);

//   // ?  ************** Navigate Function **************  ! //

//   const navigate = useNavigate();
//   const currentUrl = window.location.href;
//   const urlParts = currentUrl.split("/");
//   const slipUrl = "/" + urlParts[3] + "/dynamicSalarySlip";
//   let slip_opener = "empdetails"

//   const ViewSalarySlip = (i, monthh, yearr) => {
//     navigate(slipUrl, { state: { i, monthh, yearr, slip_opener } });
//   };

//   const monthOptions = [
//     { id: 1, name: "January" },
//     { id: 2, name: "February" },
//     { id: 3, name: "March" },
//     { id: 4, name: "April" },
//     { id: 5, name: "May" },
//     { id: 6, name: "June" },
//     { id: 7, name: "July" },
//     { id: 8, name: "August" },
//     { id: 9, name: "September" },
//     { id: 10, name: "October" },
//     { id: 11, name: "November" },
//     { id: 12, name: "December" },
//   ];
//   const getMonthName = (monthNumber) => {
//     const month = monthOptions.find((m) => m.id === monthNumber);
//     return month ? month.name : "";
//   };

//   return (
//     <>
//       <div className="attendance-history-cont">
//         <div className="attendance-heading font-weight500    font-size-heading"></div>

//         <div className="attendance-subcont">
//           <div className="field-cont">
//             <div title="Year Filter" className="field-cont-div">

//               <input
//                 type="number"
//                 maxLength={4}
//                 value={yearr}
//                 onChange={(e) => setYearr(e.target.value)}
//                 className="attendance-input-field width-5vw   date-field"
//               />

//               <hr className="field-cont-hr" />
//             </div>

//             <div title="Month Start Filter" className="field-cont-div">
//               {/* <Calender /> */}
//               <select
//                 className="attendance-input-field width-10vw   date-field"
//                 value={monthStart}
//                 max={monthEnd}
//                 onChange={(e) => setStartMonth(e.target.value)}
//               >
//                 <option value="1">January</option>
//                 <option value="2">February</option>
//                 <option value="3">March</option>
//                 <option value="4">April</option>
//                 <option value="5">May</option>
//                 <option value="6">June</option>
//                 <option value="7">July</option>
//                 <option value="8">August</option>
//                 <option value="9">September</option>
//                 <option value="10">October</option>
//                 <option value="11">November</option>
//                 <option value="12">December</option>
//               </select>

//               <hr className="field-cont-hr" />
//             </div>

//             <div title="Month End Filter" className="field-cont-div">
//               <Calender />
//               <select
//                 className="attendance-input-field width-10vw   date-field"
//                 type="text"
//                 min={monthStart}
//                 value={monthEnd}
//                 onChange={(e) => setEndMonth(e.target.value)}
//               >
//                 <option value="1">January</option>
//                 <option value="2">February</option>
//                 <option value="3">March</option>
//                 <option value="4">April</option>
//                 <option value="5">May</option>
//                 <option value="6">June</option>
//                 <option value="7">July</option>
//                 <option value="8">August</option>
//                 <option value="9">September</option>
//                 <option value="10">October</option>
//                 <option value="11">November</option>
//                 <option value="12">December</option>
//               </select>

//               <hr className="field-cont-hr" />
//             </div>

//             <div title="Employee Filter" className="field-cont-div">
//               {buffer1 ? <div className="spinner-vsmall"></div> : <Employee />}
//               <select
//                 className="attendance-input-field width-15vw   date-field"
//                 type="text"
//                 value={selectedEmpcode}
//                 onChange={(e) => setSelectedEmpcode(e.target.value)}
//               >
//                 {/* <option value="null">Select Employee Code</option> */}
//                 {emp_codes
//                   .sort((a, b) => a.emp_code - b.emp_code)
//                   .map((i, index) => (
//                     <option value={i.emp_code}>
//                       {i.emp_code} - {i.name}
//                     </option>
//                   ))}
//                 ;
//               </select>

//               <hr className="field-cont-hr" />
//             </div>

//             <div className="field-cont-div">
//               <Office />

//               <select
//                 className="attendance-input-field width-10vw   date-field"
//                 type="text"
//                 value={selectedDivision}
//                 onChange={(e) => setDivision(e.target.value)}
//               >
//                 <option value="">All Sub Companies</option>
//                 {SubCompany.sort((a, b) => a.title - b.title).map((i, index) => (
//                   <option value={i.title}>{i.title}</option>
//                 ))}
//                 ;
//               </select>
//             </div>

//           </div>
//         </div>
//       </div>
//       <div className="table-css-white-background">
//         <div className="table-heading-flex">
//           <div className="repo-heading font-weight500    font-size-heading">Employee Details</div>
//         </div>
//         <table className="table-css">
//           <thead>
//             <tr className="custom-table-head-tr">
//               <th className="align-left">Sr. No.</th>
//               <th className="align-center">Month</th>
//               <th className="align-center">Year</th>
//               <th className="align-center">Total Pay days</th>
//               <th className="align-center">Net Pay</th>
//               <th className="align-center ">Salary Receipt</th>
//             </tr>
//           </thead>
//           {buffer ? <div className="spinner"></div> : //buffering logic
//             <tbody>
//               {employeeDetailed
//                 .sort((a, b) => a.year - b.year)
//                 .sort((a, b) => a.month - b.month)
//                 .map((item, index) => {
//                   return (
//                     <React.Fragment key={index}>
//                       <tr className="tr-border-bottom">
//                         <td colSpan="6"></td>
//                       </tr>
//                       <tr className="custom-table-head-tdd">
//                         <td className="align-left">{index + 1}</td>
//                         <td className="align-center">{getMonthName(item.month)}</td>
//                         <td className="align-center">{item.year}</td>
//                         <td className="align-center">{item.salary_data?.total_paid_days}</td>
//                         <td className="align-center">
//                           {formatCurrencyIndian(
//                             item.salary_data?.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0
//                           )}
//                         </td>
//                         <td className="align-center">
//                           <button
//                             className="allproject-dashboard"
//                             title="View using Navigate"
//                             onClick={(e) => ViewSalarySlip(item, item.month, item.year)}
//                           >
//                             <Eye />
//                           </button>
//                         </td>
//                       </tr>
//                     </React.Fragment>
//                   );
//                 })}
//             </tbody>
//           }
//         </table>
//       </div>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//     </>
//   );
// };

const EmployeeDetails = () => {
  const location = useLocation();
  const restoredFilters = location.state?.filters;
  // const [designationname, setDesignationname] = useState([]);
  // const [departmentname, setDepartmentname] = useState([]);
  const [buffer, setBuffering] = useState(false);
  const [buffer1, setBuffering1] = useState(false);
  const [emp_codes, setEmp_codes] = useState([]);
  const [SubCompany, setSubCompany] = useState([]);
  const [employeeDetailed, setemployeeDetailed] = useState([]);
  const [showEmpDropdown, setShowEmpDropdown] = useState(false);
  // Filter States
  const today = new Date();
  const [yearr, setYearr] = useState(
    restoredFilters?.yearr || `${today.getFullYear()}`,
  );
  const [monthh, setMonthh] = useState(
    restoredFilters?.monthh || `${today.getMonth() + 1}`,
  );
  const [selectedSubCompany, setSelectedSubCompany] = useState(
    restoredFilters?.selectedSubCompany ||
      `${sessionStorage.getItem("company_id")}`,
  );
  const [selectedEmpcode, setSelectedEmpcode] = useState(
    restoredFilters?.selectedEmpcode || `${sessionStorage.getItem("emp_code")}`,
  );
  const [empSearchQuery, setEmpSearchQuery] = useState(
    restoredFilters?.empSearchQuery || "",
  );
  const navigate = useNavigate();

  // ─── Fetch Designation + SubCompany on Mount ───────────────────────
  useEffect(() => {
    // getDesignation();
    getSubCompany();
  }, []);

  // const getDesignation = async () => {
  //   setBuffering1(true);
  //   try {
  //     const des = await axios.get(`${BASE_URL}/wfm/designation/`);
  //     setDesignationname(des.data);
  //   } catch (err) {
  //   } finally {
  //     setBuffering1(false);
  //   }
  // };

  const getSubCompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {}
  };

  // ─── Fetch Department when SubCompany changes ──────────────────────
  // useEffect(() => {
  //   if (selectedSubCompany) {
  //     fetchDepartmentBySubCompany(selectedSubCompany);
  //   } else {
  //     setDepartmentname([]);
  //   }
  // }, [selectedSubCompany]);

  // const fetchDepartmentBySubCompany = async (subCompanyId) => {
  //   try {
  //     const dep = await axios.get(
  //       `${BASE_URL}/wfm/department/?sub_company=${subCompanyId}`
  //     );
  //     setDepartmentname(dep.data);
  //   } catch (err) { }
  // };

  // ─── Fetch Employee List when SubCompany changes ───────────────────
  useEffect(() => {
    fetchEmployeesBySubCompany();
  }, [selectedSubCompany]);

  const fetchEmployeesBySubCompany = async () => {
    setBuffering1(true);
    try {
      const company_id = sessionStorage.getItem("company_id");

      const url = selectedSubCompany
        ? `${BASE_URL}/wfm/ourcompanyempdetails/active/${selectedSubCompany}/`
        : `${BASE_URL}/wfm/ourcompanyempdetails/active/${company_id}/`;

      const emp = await axios.get(url);

      const getAlphaNumericParts = (code) => {
        const match = code.match(/^([A-Za-z]+)(\d+)$/);
        if (match)
          return { alphaPart: match[1], numericPart: parseInt(match[2], 10) };
        return { alphaPart: "", numericPart: 0 };
      };

      const sortedList = emp.data.sort((a, b) => {
        const { alphaPart: alphaA, numericPart: numericA } =
          getAlphaNumericParts(a.emp_code);
        const { alphaPart: alphaB, numericPart: numericB } =
          getAlphaNumericParts(b.emp_code);
        if (alphaA !== alphaB) return alphaA.localeCompare(alphaB);
        return numericA - numericB;
      });

      setEmp_codes(sortedList);

      // Reset selected emp if not in new filtered list
      const exists = sortedList.find((e) => e.emp_code === selectedEmpcode);
      // if (!exists && sortedList.length > 0) {
      //   setSelectedEmpcode(sortedList[0].emp_code);
      //   setEmpSearchQuery("");
      // }
      if (exists) {
        setEmpSearchQuery(`${exists.emp_code} - ${exists.name}`); // ← add this
      } else if (sortedList.length > 0) {
        setSelectedEmpcode(sortedList[0].emp_code);
        setEmpSearchQuery(`${sortedList[0].emp_code} - ${sortedList[0].name}`); // ← add this
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering1(false);
    }
  };

  const buildSalaryUrl = () => {
    if (!selectedEmpcode) return null;

    const params = new URLSearchParams();
    if (monthh) params.append("month", monthh.toString().padStart(2, "0"));
    if (yearr) params.append("year", yearr);
    // if (selectedSubCompany) params.append("sub_company", selectedSubCompany);

    const queryString = params.toString();
    return `${BASE_URL}/wfm/employeesalarysliplist/${selectedEmpcode}/${queryString ? "?" + queryString : ""}`;
  };

  // ─── Fetch Salary List ─────────────────────────────────────────────
  const getSalarylist = async () => {
    const url = buildSalaryUrl();
    if (!url) return;

    setBuffering(true);
    try {
      const res = await axios.get(url);
      // setemployeeDetailed(res.data);
      setemployeeDetailed(res.data.data ?? []);
      // setemployeeDetailed(res.data.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    if (selectedEmpcode) getSalarylist();
  }, [selectedEmpcode, monthh, yearr, selectedSubCompany]);

  // ─── Employee Search/Filter (typing) ──────────────────────────────
  // const filteredEmpCodes = emp_codes.filter((emp) => {
  //   const query = empSearchQuery.toLowerCase();
  //   return (
  //     emp.emp_code.toLowerCase().includes(query) ||
  //     emp.name.toLowerCase().includes(query)
  //   );
  // });
  const options = emp_codes
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  // ─── Navigate to Slip ──────────────────────────────────────────────
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const slipUrl = "/" + urlParts[3] + "/dynamicSalarySlip";
  let slip_opener = "empdetails";

  // const ViewSalarySlip = (i, month, year) => {
  //   navigate(slipUrl, { state: { i, monthh: month, yearr: year, slip_opener } });
  // };

  const ViewSalarySlip = (i, month, year) => {
    navigate(slipUrl, {
      state: {
        i,
        monthh: month,
        yearr: year,
        slip_opener,
        filters: {
          selectedEmpcode,
          selectedSubCompany,
          monthh,
          yearr,
          empSearchQuery,
        },
      },
    });
  };

  const monthOptions = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ];

  const getMonthName = (monthNumber) => {
    const m = monthOptions.find((m) => m.id === Number(monthNumber));
    return m ? m.name : "";
  };
  const nullOption = { value: "null", label: "Select Employee Code" };
  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedEmpcode(selectedOption.value);
    } else {
      setSelectedEmpcode("null");
    }
  };

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500 font-size-heading"></div>

        <div className="attendance-subcont">
          <div className="field-cont">
            {/* ── Year Filter ── */}
            <div title="Year Filter" className="field-cont-div">
              <input
                type="number"
                maxLength={4}
                value={yearr}
                onChange={(e) => setYearr(e.target.value)}
                className="attendance-input-field width-5vw date-field"
                placeholder="Year"
              />
              <hr className="field-cont-hr" />
            </div>

            {/* ── Month Filter ── */}
            <div title="Month Filter" className="field-cont-div">
              <Calender />
              <select
                className="attendance-input-field width-10vw date-field"
                value={monthh}
                onChange={(e) => setMonthh(e.target.value)}
              >
                <option value="">All Months</option>
                {monthOptions.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.name}
                  </option>
                ))}
              </select>
              <hr className="field-cont-hr" />
            </div>

            {/* ── Sub Company Filter ── */}
            <div title="Sub Company Filter" className="field-cont-div">
              <Office />
              <select
                className="attendance-input-field width-12vw date-field"
                value={selectedSubCompany}
                onChange={(e) => {
                  setSelectedSubCompany(e.target.value);
                  setEmpSearchQuery(""); // reset search on company change
                  setSelectedEmpcode(""); // ← add this
                  setShowEmpDropdown(false);
                }}
              >
                <option value="">All Sub Companies</option>
                {SubCompany.sort((a, b) => a.title.localeCompare(b.title)).map(
                  (i) => (
                    <option key={i.id} value={i.id}>
                      {i.title}
                    </option>
                  ),
                )}
              </select>
              <hr className="field-cont-hr" />
            </div>

            {/* <div title="Employee Filter" className="field-cont-div">
  {buffer1 ? <div className="spinner-vsmall"></div> : <Employee />}
  
  <input
    type="text"
    placeholder="Search by Code or Name"
    value={empSearchQuery}
    onChange={(e) => {
      setEmpSearchQuery(e.target.value);
      setSelectedEmpcode(""); // clear selection while typing
    }}
    className="attendance-input-field width-15vw date-field"
  />

  <select
    className="attendance-input-field width-15vw date-field"
    value={selectedEmpcode}
    onChange={(e) => {
      setSelectedEmpcode(e.target.value);
      const emp = emp_codes.find((x) => x.emp_code === e.target.value);
      if (emp) setEmpSearchQuery(`${emp.emp_code} - ${emp.name}`);
    }}
  >
    <option value="">Select Employee</option>
    {filteredEmpCodes.map((i) => (
      <option key={i.emp_code} value={i.emp_code}>
        {i.emp_code} - {i.name}
      </option>
    ))}
  </select>

  <hr className="field-cont-hr" />
</div> */}
            {/* ── Searchable Emp Dropdown (combined) ── */}
            {/* <div title="Employee Filter" className="field-cont-div" style={{ position: "relative" }}>
              {buffer1 ? <div className="spinner-vsmall"></div> : <Employee />}

              <div style={{ position: "relative", display: "flex", alignItems: "center", }}>
                <input
                  type="text"
                  placeholder="Search By Code Or Name"
                  value={empSearchQuery}
                  onChange={(e) => {
                    setEmpSearchQuery(e.target.value);
                    setSelectedEmpcode("");
                    setShowEmpDropdown(true);
                  }}
                  onFocus={() => setShowEmpDropdown(true)}
                  onBlur={() => setTimeout(() => setShowEmpDropdown(false), 200)}
                  className="attendance-input-field width-15vw date-field"
                  style={{ paddingRight: "24px" }} // make room for chevron
                />


                <span
                  onMouseDown={(e) => {
                    e.preventDefault(); // prevent input blur
                    setShowEmpDropdown((prev) => !prev); // toggle
                  }}
                  style={{
                    position: "absolute",
                    right: "2px",
                    top: "2px",
                    cursor: "pointer",
                    color: "#666",
                    fontSize: "16px",
                    userSelect: "none",
                    transition: "transform 0.2s ease",
                  }}
                >
                  &#8964;
                </span>
              </div>

            
              {showEmpDropdown && (
                <div style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  zIndex: 999,
                  background: "white",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  maxHeight: "350px",
                  overflowY: "auto",
                  width: "100%",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.12)"
                }}>
                  {filteredEmpCodes.length > 0 ? (
                    filteredEmpCodes.map((i) => (
                      <div
                        key={i.emp_code}
                        onMouseDown={() => {
                          setSelectedEmpcode(i.emp_code);
                          setEmpSearchQuery(`${i.emp_code} - ${i.name}`);
                          setShowEmpDropdown(false);
                        }}
                        style={{
                          padding: "10px 14px",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: selectedEmpcode === i.emp_code ? "600" : "400",
                          color: selectedEmpcode === i.emp_code ? "white" : "#333333",
                          backgroundColor: selectedEmpcode === i.emp_code ? "#1e7aca" : "white",
                          transition: "background-color 0.15s ease",
                        }}
                        onMouseEnter={(e) => {
                          if (selectedEmpcode !== i.emp_code) {
                            e.currentTarget.style.backgroundColor = "#1e7aca";
                            e.currentTarget.style.color = "#ffffff";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedEmpcode !== i.emp_code) {
                            e.currentTarget.style.backgroundColor = "white";
                            e.currentTarget.style.color = "#333333";
                          }
                        }}
                      >
                        {i.emp_code} - {i.name}
                      </div>
                    ))
                  ) : (
                    <div style={{
                      padding: "10px 14px",
                      color: "#999",
                      fontSize: "14px"
                    }}>
                      No employees found
                    </div>
                  )}
                </div>
              )}

              <hr className="field-cont-hr" />
            </div> */}

            <div title="Employee Filter" className="field-cont-div">
              <>
                {buffer1 ? (
                  <div className="spinner-vsmall"></div>
                ) : (
                  <Employee />
                )}

                {/* Employee Options */}
                <Select
                  className="attendance-input-field width-20vw date-field"
                  options={[nullOption, ...options]}
                  value={
                    options.find(
                      (option) => option.value === selectedEmpcode,
                    ) || nullOption
                  }
                  placeholder="Search By Code Or Name"
                  onChange={handleChange}
                  isClearable
                  styles={CSSForDropdownFilter2}
                />
              </>

              <hr className="field-cont-hr" />
            </div>
          </div>
        </div>
      </div>

      {/* ── Table ── */}
      <div className="table-css-white-background">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500 font-size-heading">
            Employee Details
          </div>
        </div>
        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">Sr. No.</th>
              <th className="align-center">Month</th>
              <th className="align-center">Year</th>
              <th className="align-center">Total Pay Days</th>
              <th className="align-center">Net Pay</th>
              <th className="align-center">Salary Receipt</th>
            </tr>
          </thead>
          {buffer ? (
            <tbody>
              <tr>
                <td colSpan="6">
                  <div className="spinner"></div>
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {(employeeDetailed ?? [])
                .sort((a, b) => a.year - b.year || a.month - b.month)
                .map((item, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-tdd">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">
                        {getMonthName(item.month)}
                      </td>
                      <td className="align-center">{item.year}</td>
                      <td className="align-center">
                        {item.salary_data?.total_paid_days}
                      </td>
                      <td className="align-center">
                        {formatCurrencyIndian(
                          item.salary_data?.deduction_details.find(
                            (j) => j.final_salary === true,
                          )?.actual_amount || 0,
                        )}
                      </td>
                      <td className="align-center">
                        <button
                          className="allproject-dashboard"
                          title="View Salary Slip"
                          onClick={() =>
                            ViewSalarySlip(item, item.month, item.year)
                          }
                        >
                          <Eye />
                        </button>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
            </tbody>
          )}
        </table>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

const BankFormat = () => {
  const [designationname, setDesignationname] = useState([]);

  const [departmentname, setDepartmentname] = useState([]);
  const [selectedRemark, setRemark] = useState("");
  const [buffer, setBuffering] = useState(false); //buffering logic

  const getDesignation = async () => {
    // setBuffering(true); //buffering logic
    try {
      const des = await axios.get(`${BASE_URL}/wfm/designation/`);
      const dep = await axios.get(`${BASE_URL}/wfm/department/`);

      setDesignationname(des.data);
      setDepartmentname(dep.data);
    } catch (err) {
      //toast Logic
      // if (err.response) {
      //   const errorData = err.response.data;
      //   if (typeof errorData.error === 'string') {
      //     // Single error message
      //     toast.error(`Error: ${errorData.error}`);
      //   } else if (typeof errorData === 'object' && errorData !== null) {
      //     // Multiple error messages
      //     Object.entries(errorData).forEach(([field, messages]) => {
      //       messages.forEach(message => toast.error(`"${field}": ${message}`));
      //     });
      //   } else {
      //     toast.error('Error:- Failed to Process!');
      //   }
      // } else {
      //   toast.error('Error processing your request.');
      // }
    } finally {
      // setBuffering(false);// End Buffering
    }
  };

  useEffect(() => {
    getDesignation();
  }, []);

  const today = new Date();
  // today.setDate(today.getDate() - 1);
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
  var datearray = formattedDate.split("-");

  var newdate = datearray[0] + "-" + datearray[1] + "-" + datearray[2];
  console.log(newdate);

  // console.log(newdate)

  const [monthh, setMonthh] = useState(`${month}`);
  const monthName = monthNames[monthh - 1];

  const [yearr, setYearr] = useState(`${year}`);

  const [bankFormat, setbankFormat] = useState([]);
  const [bankFormatfilter, setbankFormatfilter] = useState([]);

  const [selectedName, setName] = useState("");
  const [selectedDep, setDep] = useState("");
  const [selectedDesi, setDesi] = useState("");
  const [selectedFromexp, setFromexp] = useState("");
  const [selectedToexp, setToexp] = useState("");
  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company")}`,
  );

  // const [searchQuery, setSearchQuery] = useState("");

  const getSalarylist = async () => {
    setBuffering(true); //buffering logic
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/bankformat/${yearr}/${monthh}/`,
      );
      setbankFormat(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };
  const [SubCompany, setSubCompany] = useState([]);

  const getSubCompany = async () => {
    // setBuffering(true); //buffering logic
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      //toast Logic
      // if (err.response) {
      //   const errorData = err.response.data;
      //   if (typeof errorData.error === 'string') {
      //     // Single error message
      //     toast.error(`Error: ${errorData.error}`);
      //   } else if (typeof errorData === 'object' && errorData !== null) {
      //     // Multiple error messages
      //     Object.entries(errorData).forEach(([field, messages]) => {
      //       messages.forEach(message => toast.error(`"${field}": ${message}`));
      //     });
      //   } else {
      //     toast.error('Error:- Failed to Process!');
      //   }
      // } else {
      //   toast.error('Error processing your request.');
      // }
    } finally {
      // setBuffering(false);// End Buffering
    }
  };

  const applyFilters = () => {
    let filteredData = bankFormat;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();
      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee.name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return nameMatch;
      });
    }

    if (selectedDep) {
      filteredData = filteredData.filter(
        (employee) => employee.department_name === selectedDep,
      );
    }

    // if (selectedFromexp) {
    //     const fromExpNumber = parseInt(selectedFromexp);
    //     filteredData = filteredData.filter(employee => parseInt(employee.yearofExp) >= fromExpNumber);
    // }

    // if (selectedToexp) {
    //     const toExpNumber = parseInt(selectedToexp);
    //     filteredData = filteredData.filter(employee => parseInt(employee.yearofExp) <= toExpNumber);
    // }

    if (selectedDesi) {
      const lowercaseSelectedName = selectedDesi.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const desiMatch = employee.position_name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return desiMatch;
      });
    }
    // if (selectedRemark) {
    //     const lowercaseSelectedRemark = selectedRemark.toLowerCase();

    //     filteredData = filteredData.filter(employee => {
    //         const matchRemark = employee.remarks?.toLowerCase().includes(lowercaseSelectedRemark);

    //         return matchRemark;
    //     });
    // }

    if (selectedDivision) {
      filteredData = filteredData.filter(
        (employee) => employee.employee?.division_name === selectedDivision,
      );
    }

    setbankFormatfilter(filteredData);
  };

  useEffect(() => {
    getSubCompany();
    getSalarylist();
  }, [monthh, yearr]);

  useEffect(() => {
    applyFilters();
  }, [
    bankFormat,
    bankFormatfilter,
    selectedName,
    selectedDep,
    selectedDesi,
    selectedFromexp,
    selectedToexp,
    selectedRemark,
    selectedDivision,
  ]);

  // ?  ************** Put Request Start **************  ! //
  const tableRef = useRef(null);
  const handleDownloadBankSheet = () => {
    downloadAsExcel(
      tableRef,
      "users",
      selectedDivision === ""
        ? `BankFormatSheet-${monthh}-${yearr}`
        : `${selectedDivision}-BankFormatSheet-${monthh}-${yearr}`,
    );
  };
  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500    font-size-heading"></div>

        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <input
                type="number"
                maxLength={4}
                value={yearr}
                onChange={(e) => setYearr(e.target.value)}
                className="attendance-input-field width-5vw   date-field"
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Calender />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={monthh}
                onChange={(e) => setMonthh(e.target.value)}
              >
                {/* <option value="">All</option> */}
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Office />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDivision}
                onChange={(e) => setDivision(e.target.value)}
              >
                <option value="">All Sub Companies</option>
                {/* {emp_code.sort((a, b) => a.emp_code - b.emp_code).map((i, index) => (<option value={i.emp_code}>{i.emp_code} - {i.name}</option>))}; */}
                {SubCompany.sort((a, b) => a.title - b.title).map(
                  (i, index) => (
                    <option value={i.title}>{i.title}</option>
                  ),
                )}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-15vw  "
                placeholder="Name"
                type="text"
                value={selectedName}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
          {/* <DownloadTableExcel
            filename={
              selectedDivision === ""
                ? `BankFormatSheet-${monthh}-${yearr}`
                : `${selectedDivision}-BankFormatSheet-${monthh}-${yearr}`
            }
            // filename={`BankFormatSheet-${monthh}-${yearr}`}
            sheet="users"
            currentTableRef={tableRef.current}
          >
            <button className=" model-button-print">
              <DownloadIcon />
            </button>
          </DownloadTableExcel> */}
          <button
            className=" model-button-print"
            onClick={handleDownloadBankSheet}
          >
            <DownloadIcon />
          </button>
        </div>
      </div>
      <div className="table-css-white-background">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500    font-size-heading">
            Bank Format
            {/* <p className='career-para font-size-subheading">Based your performance</p>          */}
          </div>
        </div>
        <table ref={tableRef} className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">S.No.</th>
              <th className="align-center">Emp Code</th>
              <th className="align-center">Name</th>
              <th className="align-center">Bank</th>
              <th className="align-center">Account No.</th>
              <th className="align-center">IFSC</th>
              <th className="align-right ">Basic Salary</th>
              {/* <th className="align-center">View</th> */}
              {/* <th className="align-center">Action</th> */}
            </tr>
          </thead>
          <tbody>
            {bankFormatfilter
              // .filter((e) =>
              //   e.name.toLowerCase().includes(searchQuery.toLowerCase())
              // )
              // .sort((a, b) => Date(a.date) - Date(b.date))
              .map((i, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-tdd">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">{i.bank_details?.user}</td>
                      <td className="align-center">{i.name}</td>
                      <td className="align-center">
                        {i.bank_details?.bank_name}-
                        {i.bank_details?.branch_address}
                      </td>
                      <td className="align-center">
                        {i.bank_details?.account_number}
                      </td>
                      <td className="align-center">
                        {i.bank_details?.ifsc_code}
                      </td>
                      <td className="align-center">{i.salarypay}</td>
                    </tr>
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

const PrintFormat = () => {
  const [designationname, setDesignationname] = useState([]);
  const [departmentname, setDepartmentname] = useState([]);
  const [buffer, setBuffering] = useState(false); //buffering logic
  const tableRef = useRef(null);

  const getDesignation = async () => {
    // setBuffering(true); //buffering logic

    try {
      const des = await axios.get(`${BASE_URL}/wfm/designation/`);
      const dep = await axios.get(`${BASE_URL}/wfm/department/`);

      setDesignationname(des.data);
      setDepartmentname(dep.data);
    } catch (err) {
    } finally {
    }
  };

  useEffect(() => {
    getDesignation();
  }, []);

  const today = new Date();
  // today.setDate(today.getDate() - 1);
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
  var datearray = formattedDate.split("-");

  var newdate = datearray[0] + "-" + datearray[1] + "-" + datearray[2];
  console.log(newdate);

  const [monthh, setMonthh] = useState(`${month}`);
  const monthName = monthNames[monthh - 1];

  const [yearr, setYearr] = useState(`${year}`);
  const [monthlylist, setMonthlylist] = useState([]);
  const [monthlylistfilter, setMonthlylistfilter] = useState([]);

  const [toggleState, setToggleState] = useState("pending/");
  // const [searchQuery, setSearchQuery] = useState("");

  const getSalarylist = async () => {
    setBuffering(true); //buffering logic

    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/salaryslipall/${yearr}/${monthh}`,
      );
      setMonthlylist(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };
  const [SubCompany, setSubCompany] = useState([]);

  const getSubCompany = async () => {
    // setBuffering(true); //buffering logic
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      //toast Logic
      // if (err.response) {
      //   const errorData = err.response.data;
      //   if (typeof errorData.error === 'string') {
      //     // Single error message
      //     toast.error(`Error: ${errorData.error}`);
      //   } else if (typeof errorData === 'object' && errorData !== null) {
      //     // Multiple error messages
      //     Object.entries(errorData).forEach(([field, messages]) => {
      //       messages.forEach(message => toast.error(`"${field}": ${message}`));
      //     });
      //   } else {
      //     toast.error('Error:- Failed to Process!');
      //   }
      // } else {
      //   toast.error('Error processing your request.');
      // }
    } finally {
      // setBuffering(false);// End Buffering
    }
  };

  const [selectedName, setName] = useState("");
  const [selectedDep, setDep] = useState("");
  const [selectedDesi, setDesi] = useState("");
  // const [selectedRH, setRh] = useState('');
  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company")}`,
  );

  const applyFilters = () => {
    let filteredData = monthlylist;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();
      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee.user_details.name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return nameMatch;
      });
    }

    if (selectedDep) {
      filteredData = filteredData.filter(
        (employee) => employee.user_details.department_name === selectedDep,
      );
    }

    if (selectedDesi) {
      const lowercaseSelectedName = selectedDesi.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const desiMatch = employee.user_details.designation_name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return desiMatch;
      });
    }

    // if (selectedRH) {

    //     filteredData = filteredData.filter(employee => employee.rh_assigned === selectedRH);
    // }

    if (selectedDivision) {
      filteredData = filteredData.filter(
        (employee) => employee.user_details?.division_name === selectedDivision,
      );
    }

    setMonthlylistfilter(filteredData);
  };

  useEffect(() => {
    getSalarylist();
    getSubCompany();
  }, [monthh, yearr]);

  useEffect(() => {
    applyFilters();
  }, [selectedName, selectedDep, selectedDesi, monthlylist, selectedDivision]);

  // ?  ************** Put Request Start **************  ! //

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const baseUrl = "/" + urlParts[3] + `/salarySlip`;
  const salarySlip = (emp_code, month, year) => {
    navigate(baseUrl + `/${year}` + `/${month}` + `/${emp_code}/`);
  };

  const OneSalarySlip = (i, monthh, yearr) => {
    navigate(baseUrl, { state: { i, monthh, yearr } });
  };

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500    font-size-heading"></div>

        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <input
                type="number"
                maxLength={4}
                value={yearr}
                onChange={(e) => setYearr(e.target.value)}
                className="attendance-input-field width-10vw   date-field"
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 14 14"
                fill="none"
              >
                <g clip-path="url(#clip0_650_3324)">
                  <path
                    d="M2.625 10.2083H1.16667C0.857247 10.2083 0.560501 10.3312 0.341709 10.55C0.122916 10.7688 0 11.0655 0 11.3749L0 12.8333C0 13.1427 0.122916 13.4394 0.341709 13.6582C0.560501 13.877 0.857247 13.9999 1.16667 13.9999H2.625C2.93442 13.9999 3.23117 13.877 3.44996 13.6582C3.66875 13.4394 3.79167 13.1427 3.79167 12.8333V11.3749C3.79167 11.0655 3.66875 10.7688 3.44996 10.55C3.23117 10.3312 2.93442 10.2083 2.625 10.2083ZM2.625 12.8333H1.16667V11.3749H2.625V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 10.2083H11.3749C11.0655 10.2083 10.7688 10.3312 10.55 10.55C10.3312 10.7688 10.2083 11.0655 10.2083 11.3749V12.8333C10.2083 13.1427 10.3312 13.4394 10.55 13.6582C10.7688 13.877 11.0655 13.9999 11.3749 13.9999H12.8333C13.1427 13.9999 13.4394 13.877 13.6582 13.6582C13.877 13.4394 13.9999 13.1427 13.9999 12.8333V11.3749C13.9999 11.0655 13.877 10.7688 13.6582 10.55C13.4394 10.3312 13.1427 10.2083 12.8333 10.2083ZM12.8333 12.8333H11.3749V11.3749H12.8333V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 5.10425H1.16667C0.857247 5.10425 0.560501 5.22716 0.341709 5.44596C0.122916 5.66475 0 5.9615 0 6.27091L0 7.72925C0 8.03867 0.122916 8.33541 0.341709 8.55421C0.560501 8.773 0.857247 8.89592 1.16667 8.89592H2.625C2.93442 8.89592 3.23117 8.773 3.44996 8.55421C3.66875 8.33541 3.79167 8.03867 3.79167 7.72925V6.27091C3.79167 5.9615 3.66875 5.66475 3.44996 5.44596C3.23117 5.22716 2.93442 5.10425 2.625 5.10425ZM2.625 7.72925H1.16667V6.27091H2.625V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 5.10425H11.3749C11.0655 5.10425 10.7688 5.22716 10.55 5.44596C10.3312 5.66475 10.2083 5.9615 10.2083 6.27091V7.72925C10.2083 8.03867 10.3312 8.33541 10.55 8.55421C10.7688 8.773 11.0655 8.89592 11.3749 8.89592H12.8333C13.1427 8.89592 13.4394 8.773 13.6582 8.55421C13.877 8.33541 13.9999 8.03867 13.9999 7.72925V6.27091C13.9999 5.9615 13.877 5.66475 13.6582 5.44596C13.4394 5.22716 13.1427 5.10425 12.8333 5.10425ZM12.8333 7.72925H11.3749V6.27091H12.8333V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 0H1.16667C0.857247 0 0.560501 0.122916 0.341709 0.341709C0.122916 0.560501 0 0.857247 0 1.16667L0 2.625C0 2.93442 0.122916 3.23117 0.341709 3.44996C0.560501 3.66875 0.857247 3.79167 1.16667 3.79167H2.625C2.93442 3.79167 3.23117 3.66875 3.44996 3.44996C3.66875 3.23117 3.79167 2.93442 3.79167 2.625V1.16667C3.79167 0.857247 3.66875 0.560501 3.44996 0.341709C3.23117 0.122916 2.93442 0 2.625 0ZM2.625 2.625H1.16667V1.16667H2.625V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 10.2083H6.27091C5.9615 10.2083 5.66475 10.3312 5.44596 10.55C5.22716 10.7688 5.10425 11.0655 5.10425 11.3749V12.8333C5.10425 13.1427 5.22716 13.4394 5.44596 13.6582C5.66475 13.877 5.9615 13.9999 6.27091 13.9999H7.72925C8.03867 13.9999 8.33541 13.877 8.55421 13.6582C8.773 13.4394 8.89592 13.1427 8.89592 12.8333V11.3749C8.89592 11.0655 8.773 10.7688 8.55421 10.55C8.33541 10.3312 8.03867 10.2083 7.72925 10.2083ZM7.72925 12.8333H6.27091V11.3749H7.72925V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 5.10425H6.27091C5.9615 5.10425 5.66475 5.22716 5.44596 5.44596C5.22716 5.66475 5.10425 5.9615 5.10425 6.27091V7.72925C5.10425 8.03867 5.22716 8.33541 5.44596 8.55421C5.66475 8.773 5.9615 8.89592 6.27091 8.89592H7.72925C8.03867 8.89592 8.33541 8.773 8.55421 8.55421C8.773 8.33541 8.89592 8.03867 8.89592 7.72925V6.27091C8.89592 5.9615 8.773 5.66475 8.55421 5.44596C8.33541 5.22716 8.03867 5.10425 7.72925 5.10425ZM7.72925 7.72925H6.27091V6.27091H7.72925V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 0H6.27091C5.9615 0 5.66475 0.122916 5.44596 0.341709C5.22716 0.560501 5.10425 0.857247 5.10425 1.16667V2.625C5.10425 2.93442 5.22716 3.23117 5.44596 3.44996C5.66475 3.66875 5.9615 3.79167 6.27091 3.79167H7.72925C8.03867 3.79167 8.33541 3.66875 8.55421 3.44996C8.773 3.23117 8.89592 2.93442 8.89592 2.625V1.16667C8.89592 0.857247 8.773 0.560501 8.55421 0.341709C8.33541 0.122916 8.03867 0 7.72925 0ZM7.72925 2.625H6.27091V1.16667H7.72925V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 0H11.3749C11.0655 0 10.7688 0.122916 10.55 0.341709C10.3312 0.560501 10.2083 0.857247 10.2083 1.16667V2.625C10.2083 2.93442 10.3312 3.23117 10.55 3.44996C10.7688 3.66875 11.0655 3.79167 11.3749 3.79167H12.8333C13.1427 3.79167 13.4394 3.66875 13.6582 3.44996C13.877 3.23117 13.9999 2.93442 13.9999 2.625V1.16667C13.9999 0.857247 13.877 0.560501 13.6582 0.341709C13.4394 0.122916 13.1427 0 12.8333 0ZM12.8333 2.625H11.3749V1.16667H12.8333V2.625Z"
                    fill="#707070"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_650_3324">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={monthh}
                onChange={(e) => setMonthh(e.target.value)}
              >
                {/* <option value="">All</option> */}
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 14 14"
                fill="none"
              >
                <g clip-path="url(#clip0_650_3324)">
                  <path
                    d="M2.625 10.2083H1.16667C0.857247 10.2083 0.560501 10.3312 0.341709 10.55C0.122916 10.7688 0 11.0655 0 11.3749L0 12.8333C0 13.1427 0.122916 13.4394 0.341709 13.6582C0.560501 13.877 0.857247 13.9999 1.16667 13.9999H2.625C2.93442 13.9999 3.23117 13.877 3.44996 13.6582C3.66875 13.4394 3.79167 13.1427 3.79167 12.8333V11.3749C3.79167 11.0655 3.66875 10.7688 3.44996 10.55C3.23117 10.3312 2.93442 10.2083 2.625 10.2083ZM2.625 12.8333H1.16667V11.3749H2.625V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 10.2083H11.3749C11.0655 10.2083 10.7688 10.3312 10.55 10.55C10.3312 10.7688 10.2083 11.0655 10.2083 11.3749V12.8333C10.2083 13.1427 10.3312 13.4394 10.55 13.6582C10.7688 13.877 11.0655 13.9999 11.3749 13.9999H12.8333C13.1427 13.9999 13.4394 13.877 13.6582 13.6582C13.877 13.4394 13.9999 13.1427 13.9999 12.8333V11.3749C13.9999 11.0655 13.877 10.7688 13.6582 10.55C13.4394 10.3312 13.1427 10.2083 12.8333 10.2083ZM12.8333 12.8333H11.3749V11.3749H12.8333V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 5.10425H1.16667C0.857247 5.10425 0.560501 5.22716 0.341709 5.44596C0.122916 5.66475 0 5.9615 0 6.27091L0 7.72925C0 8.03867 0.122916 8.33541 0.341709 8.55421C0.560501 8.773 0.857247 8.89592 1.16667 8.89592H2.625C2.93442 8.89592 3.23117 8.773 3.44996 8.55421C3.66875 8.33541 3.79167 8.03867 3.79167 7.72925V6.27091C3.79167 5.9615 3.66875 5.66475 3.44996 5.44596C3.23117 5.22716 2.93442 5.10425 2.625 5.10425ZM2.625 7.72925H1.16667V6.27091H2.625V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 5.10425H11.3749C11.0655 5.10425 10.7688 5.22716 10.55 5.44596C10.3312 5.66475 10.2083 5.9615 10.2083 6.27091V7.72925C10.2083 8.03867 10.3312 8.33541 10.55 8.55421C10.7688 8.773 11.0655 8.89592 11.3749 8.89592H12.8333C13.1427 8.89592 13.4394 8.773 13.6582 8.55421C13.877 8.33541 13.9999 8.03867 13.9999 7.72925V6.27091C13.9999 5.9615 13.877 5.66475 13.6582 5.44596C13.4394 5.22716 13.1427 5.10425 12.8333 5.10425ZM12.8333 7.72925H11.3749V6.27091H12.8333V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 0H1.16667C0.857247 0 0.560501 0.122916 0.341709 0.341709C0.122916 0.560501 0 0.857247 0 1.16667L0 2.625C0 2.93442 0.122916 3.23117 0.341709 3.44996C0.560501 3.66875 0.857247 3.79167 1.16667 3.79167H2.625C2.93442 3.79167 3.23117 3.66875 3.44996 3.44996C3.66875 3.23117 3.79167 2.93442 3.79167 2.625V1.16667C3.79167 0.857247 3.66875 0.560501 3.44996 0.341709C3.23117 0.122916 2.93442 0 2.625 0ZM2.625 2.625H1.16667V1.16667H2.625V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 10.2083H6.27091C5.9615 10.2083 5.66475 10.3312 5.44596 10.55C5.22716 10.7688 5.10425 11.0655 5.10425 11.3749V12.8333C5.10425 13.1427 5.22716 13.4394 5.44596 13.6582C5.66475 13.877 5.9615 13.9999 6.27091 13.9999H7.72925C8.03867 13.9999 8.33541 13.877 8.55421 13.6582C8.773 13.4394 8.89592 13.1427 8.89592 12.8333V11.3749C8.89592 11.0655 8.773 10.7688 8.55421 10.55C8.33541 10.3312 8.03867 10.2083 7.72925 10.2083ZM7.72925 12.8333H6.27091V11.3749H7.72925V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 5.10425H6.27091C5.9615 5.10425 5.66475 5.22716 5.44596 5.44596C5.22716 5.66475 5.10425 5.9615 5.10425 6.27091V7.72925C5.10425 8.03867 5.22716 8.33541 5.44596 8.55421C5.66475 8.773 5.9615 8.89592 6.27091 8.89592H7.72925C8.03867 8.89592 8.33541 8.773 8.55421 8.55421C8.773 8.33541 8.89592 8.03867 8.89592 7.72925V6.27091C8.89592 5.9615 8.773 5.66475 8.55421 5.44596C8.33541 5.22716 8.03867 5.10425 7.72925 5.10425ZM7.72925 7.72925H6.27091V6.27091H7.72925V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 0H6.27091C5.9615 0 5.66475 0.122916 5.44596 0.341709C5.22716 0.560501 5.10425 0.857247 5.10425 1.16667V2.625C5.10425 2.93442 5.22716 3.23117 5.44596 3.44996C5.66475 3.66875 5.9615 3.79167 6.27091 3.79167H7.72925C8.03867 3.79167 8.33541 3.66875 8.55421 3.44996C8.773 3.23117 8.89592 2.93442 8.89592 2.625V1.16667C8.89592 0.857247 8.773 0.560501 8.55421 0.341709C8.33541 0.122916 8.03867 0 7.72925 0ZM7.72925 2.625H6.27091V1.16667H7.72925V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 0H11.3749C11.0655 0 10.7688 0.122916 10.55 0.341709C10.3312 0.560501 10.2083 0.857247 10.2083 1.16667V2.625C10.2083 2.93442 10.3312 3.23117 10.55 3.44996C10.7688 3.66875 11.0655 3.79167 11.3749 3.79167H12.8333C13.1427 3.79167 13.4394 3.66875 13.6582 3.44996C13.877 3.23117 13.9999 2.93442 13.9999 2.625V1.16667C13.9999 0.857247 13.877 0.560501 13.6582 0.341709C13.4394 0.122916 13.1427 0 12.8333 0ZM12.8333 2.625H11.3749V1.16667H12.8333V2.625Z"
                    fill="#707070"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_650_3324">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDep}
                onChange={(e) => setDep(e.target.value)}
              >
                <option value=""> All Department</option>
                {/* {emp_code.sort((a, b) => a.emp_code - b.emp_code).map((i, index) => (<option value={i.emp_code}>{i.emp_code} - {i.name}</option>))}; */}
                {departmentname
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.title}>{i.title}</option>
                  ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 14 14"
                fill="none"
              >
                <g clip-path="url(#clip0_650_3324)">
                  <path
                    d="M2.625 10.2083H1.16667C0.857247 10.2083 0.560501 10.3312 0.341709 10.55C0.122916 10.7688 0 11.0655 0 11.3749L0 12.8333C0 13.1427 0.122916 13.4394 0.341709 13.6582C0.560501 13.877 0.857247 13.9999 1.16667 13.9999H2.625C2.93442 13.9999 3.23117 13.877 3.44996 13.6582C3.66875 13.4394 3.79167 13.1427 3.79167 12.8333V11.3749C3.79167 11.0655 3.66875 10.7688 3.44996 10.55C3.23117 10.3312 2.93442 10.2083 2.625 10.2083ZM2.625 12.8333H1.16667V11.3749H2.625V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 10.2083H11.3749C11.0655 10.2083 10.7688 10.3312 10.55 10.55C10.3312 10.7688 10.2083 11.0655 10.2083 11.3749V12.8333C10.2083 13.1427 10.3312 13.4394 10.55 13.6582C10.7688 13.877 11.0655 13.9999 11.3749 13.9999H12.8333C13.1427 13.9999 13.4394 13.877 13.6582 13.6582C13.877 13.4394 13.9999 13.1427 13.9999 12.8333V11.3749C13.9999 11.0655 13.877 10.7688 13.6582 10.55C13.4394 10.3312 13.1427 10.2083 12.8333 10.2083ZM12.8333 12.8333H11.3749V11.3749H12.8333V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 5.10425H1.16667C0.857247 5.10425 0.560501 5.22716 0.341709 5.44596C0.122916 5.66475 0 5.9615 0 6.27091L0 7.72925C0 8.03867 0.122916 8.33541 0.341709 8.55421C0.560501 8.773 0.857247 8.89592 1.16667 8.89592H2.625C2.93442 8.89592 3.23117 8.773 3.44996 8.55421C3.66875 8.33541 3.79167 8.03867 3.79167 7.72925V6.27091C3.79167 5.9615 3.66875 5.66475 3.44996 5.44596C3.23117 5.22716 2.93442 5.10425 2.625 5.10425ZM2.625 7.72925H1.16667V6.27091H2.625V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 5.10425H11.3749C11.0655 5.10425 10.7688 5.22716 10.55 5.44596C10.3312 5.66475 10.2083 5.9615 10.2083 6.27091V7.72925C10.2083 8.03867 10.3312 8.33541 10.55 8.55421C10.7688 8.773 11.0655 8.89592 11.3749 8.89592H12.8333C13.1427 8.89592 13.4394 8.773 13.6582 8.55421C13.877 8.33541 13.9999 8.03867 13.9999 7.72925V6.27091C13.9999 5.9615 13.877 5.66475 13.6582 5.44596C13.4394 5.22716 13.1427 5.10425 12.8333 5.10425ZM12.8333 7.72925H11.3749V6.27091H12.8333V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 0H1.16667C0.857247 0 0.560501 0.122916 0.341709 0.341709C0.122916 0.560501 0 0.857247 0 1.16667L0 2.625C0 2.93442 0.122916 3.23117 0.341709 3.44996C0.560501 3.66875 0.857247 3.79167 1.16667 3.79167H2.625C2.93442 3.79167 3.23117 3.66875 3.44996 3.44996C3.66875 3.23117 3.79167 2.93442 3.79167 2.625V1.16667C3.79167 0.857247 3.66875 0.560501 3.44996 0.341709C3.23117 0.122916 2.93442 0 2.625 0ZM2.625 2.625H1.16667V1.16667H2.625V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 10.2083H6.27091C5.9615 10.2083 5.66475 10.3312 5.44596 10.55C5.22716 10.7688 5.10425 11.0655 5.10425 11.3749V12.8333C5.10425 13.1427 5.22716 13.4394 5.44596 13.6582C5.66475 13.877 5.9615 13.9999 6.27091 13.9999H7.72925C8.03867 13.9999 8.33541 13.877 8.55421 13.6582C8.773 13.4394 8.89592 13.1427 8.89592 12.8333V11.3749C8.89592 11.0655 8.773 10.7688 8.55421 10.55C8.33541 10.3312 8.03867 10.2083 7.72925 10.2083ZM7.72925 12.8333H6.27091V11.3749H7.72925V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 5.10425H6.27091C5.9615 5.10425 5.66475 5.22716 5.44596 5.44596C5.22716 5.66475 5.10425 5.9615 5.10425 6.27091V7.72925C5.10425 8.03867 5.22716 8.33541 5.44596 8.55421C5.66475 8.773 5.9615 8.89592 6.27091 8.89592H7.72925C8.03867 8.89592 8.33541 8.773 8.55421 8.55421C8.773 8.33541 8.89592 8.03867 8.89592 7.72925V6.27091C8.89592 5.9615 8.773 5.66475 8.55421 5.44596C8.33541 5.22716 8.03867 5.10425 7.72925 5.10425ZM7.72925 7.72925H6.27091V6.27091H7.72925V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 0H6.27091C5.9615 0 5.66475 0.122916 5.44596 0.341709C5.22716 0.560501 5.10425 0.857247 5.10425 1.16667V2.625C5.10425 2.93442 5.22716 3.23117 5.44596 3.44996C5.66475 3.66875 5.9615 3.79167 6.27091 3.79167H7.72925C8.03867 3.79167 8.33541 3.66875 8.55421 3.44996C8.773 3.23117 8.89592 2.93442 8.89592 2.625V1.16667C8.89592 0.857247 8.773 0.560501 8.55421 0.341709C8.33541 0.122916 8.03867 0 7.72925 0ZM7.72925 2.625H6.27091V1.16667H7.72925V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 0H11.3749C11.0655 0 10.7688 0.122916 10.55 0.341709C10.3312 0.560501 10.2083 0.857247 10.2083 1.16667V2.625C10.2083 2.93442 10.3312 3.23117 10.55 3.44996C10.7688 3.66875 11.0655 3.79167 11.3749 3.79167H12.8333C13.1427 3.79167 13.4394 3.66875 13.6582 3.44996C13.877 3.23117 13.9999 2.93442 13.9999 2.625V1.16667C13.9999 0.857247 13.877 0.560501 13.6582 0.341709C13.4394 0.122916 13.1427 0 12.8333 0ZM12.8333 2.625H11.3749V1.16667H12.8333V2.625Z"
                    fill="#707070"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_650_3324">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Designation"
                type="text"
                value={selectedDesi}
                onChange={(e) => setDesi(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 11 12"
                fill="none"
              >
                <circle
                  cx="5"
                  cy="5"
                  r="4.3"
                  stroke="#707070"
                  stroke-width="1.4"
                />
                <line
                  x1="10.0101"
                  y1="11"
                  x2="8"
                  y2="8.98995"
                  stroke="#707070 "
                  stroke-width="1.4"
                  stroke-linecap="round"
                />
              </svg>
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Name"
                type="text"
                value={selectedName}
                onChange={(e) => setName(e.target.value)}
              />

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 14 14"
                fill="none"
              >
                <g clip-path="url(#clip0_650_3324)">
                  <path
                    d="M2.625 10.2083H1.16667C0.857247 10.2083 0.560501 10.3312 0.341709 10.55C0.122916 10.7688 0 11.0655 0 11.3749L0 12.8333C0 13.1427 0.122916 13.4394 0.341709 13.6582C0.560501 13.877 0.857247 13.9999 1.16667 13.9999H2.625C2.93442 13.9999 3.23117 13.877 3.44996 13.6582C3.66875 13.4394 3.79167 13.1427 3.79167 12.8333V11.3749C3.79167 11.0655 3.66875 10.7688 3.44996 10.55C3.23117 10.3312 2.93442 10.2083 2.625 10.2083ZM2.625 12.8333H1.16667V11.3749H2.625V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 10.2083H11.3749C11.0655 10.2083 10.7688 10.3312 10.55 10.55C10.3312 10.7688 10.2083 11.0655 10.2083 11.3749V12.8333C10.2083 13.1427 10.3312 13.4394 10.55 13.6582C10.7688 13.877 11.0655 13.9999 11.3749 13.9999H12.8333C13.1427 13.9999 13.4394 13.877 13.6582 13.6582C13.877 13.4394 13.9999 13.1427 13.9999 12.8333V11.3749C13.9999 11.0655 13.877 10.7688 13.6582 10.55C13.4394 10.3312 13.1427 10.2083 12.8333 10.2083ZM12.8333 12.8333H11.3749V11.3749H12.8333V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 5.10425H1.16667C0.857247 5.10425 0.560501 5.22716 0.341709 5.44596C0.122916 5.66475 0 5.9615 0 6.27091L0 7.72925C0 8.03867 0.122916 8.33541 0.341709 8.55421C0.560501 8.773 0.857247 8.89592 1.16667 8.89592H2.625C2.93442 8.89592 3.23117 8.773 3.44996 8.55421C3.66875 8.33541 3.79167 8.03867 3.79167 7.72925V6.27091C3.79167 5.9615 3.66875 5.66475 3.44996 5.44596C3.23117 5.22716 2.93442 5.10425 2.625 5.10425ZM2.625 7.72925H1.16667V6.27091H2.625V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 5.10425H11.3749C11.0655 5.10425 10.7688 5.22716 10.55 5.44596C10.3312 5.66475 10.2083 5.9615 10.2083 6.27091V7.72925C10.2083 8.03867 10.3312 8.33541 10.55 8.55421C10.7688 8.773 11.0655 8.89592 11.3749 8.89592H12.8333C13.1427 8.89592 13.4394 8.773 13.6582 8.55421C13.877 8.33541 13.9999 8.03867 13.9999 7.72925V6.27091C13.9999 5.9615 13.877 5.66475 13.6582 5.44596C13.4394 5.22716 13.1427 5.10425 12.8333 5.10425ZM12.8333 7.72925H11.3749V6.27091H12.8333V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 0H1.16667C0.857247 0 0.560501 0.122916 0.341709 0.341709C0.122916 0.560501 0 0.857247 0 1.16667L0 2.625C0 2.93442 0.122916 3.23117 0.341709 3.44996C0.560501 3.66875 0.857247 3.79167 1.16667 3.79167H2.625C2.93442 3.79167 3.23117 3.66875 3.44996 3.44996C3.66875 3.23117 3.79167 2.93442 3.79167 2.625V1.16667C3.79167 0.857247 3.66875 0.560501 3.44996 0.341709C3.23117 0.122916 2.93442 0 2.625 0ZM2.625 2.625H1.16667V1.16667H2.625V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 10.2083H6.27091C5.9615 10.2083 5.66475 10.3312 5.44596 10.55C5.22716 10.7688 5.10425 11.0655 5.10425 11.3749V12.8333C5.10425 13.1427 5.22716 13.4394 5.44596 13.6582C5.66475 13.877 5.9615 13.9999 6.27091 13.9999H7.72925C8.03867 13.9999 8.33541 13.877 8.55421 13.6582C8.773 13.4394 8.89592 13.1427 8.89592 12.8333V11.3749C8.89592 11.0655 8.773 10.7688 8.55421 10.55C8.33541 10.3312 8.03867 10.2083 7.72925 10.2083ZM7.72925 12.8333H6.27091V11.3749H7.72925V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 5.10425H6.27091C5.9615 5.10425 5.66475 5.22716 5.44596 5.44596C5.22716 5.66475 5.10425 5.9615 5.10425 6.27091V7.72925C5.10425 8.03867 5.22716 8.33541 5.44596 8.55421C5.66475 8.773 5.9615 8.89592 6.27091 8.89592H7.72925C8.03867 8.89592 8.33541 8.773 8.55421 8.55421C8.773 8.33541 8.89592 8.03867 8.89592 7.72925V6.27091C8.89592 5.9615 8.773 5.66475 8.55421 5.44596C8.33541 5.22716 8.03867 5.10425 7.72925 5.10425ZM7.72925 7.72925H6.27091V6.27091H7.72925V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 0H6.27091C5.9615 0 5.66475 0.122916 5.44596 0.341709C5.22716 0.560501 5.10425 0.857247 5.10425 1.16667V2.625C5.10425 2.93442 5.22716 3.23117 5.44596 3.44996C5.66475 3.66875 5.9615 3.79167 6.27091 3.79167H7.72925C8.03867 3.79167 8.33541 3.66875 8.55421 3.44996C8.773 3.23117 8.89592 2.93442 8.89592 2.625V1.16667C8.89592 0.857247 8.773 0.560501 8.55421 0.341709C8.33541 0.122916 8.03867 0 7.72925 0ZM7.72925 2.625H6.27091V1.16667H7.72925V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 0H11.3749C11.0655 0 10.7688 0.122916 10.55 0.341709C10.3312 0.560501 10.2083 0.857247 10.2083 1.16667V2.625C10.2083 2.93442 10.3312 3.23117 10.55 3.44996C10.7688 3.66875 11.0655 3.79167 11.3749 3.79167H12.8333C13.1427 3.79167 13.4394 3.66875 13.6582 3.44996C13.877 3.23117 13.9999 2.93442 13.9999 2.625V1.16667C13.9999 0.857247 13.877 0.560501 13.6582 0.341709C13.4394 0.122916 13.1427 0 12.8333 0ZM12.8333 2.625H11.3749V1.16667H12.8333V2.625Z"
                    fill="#707070"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_650_3324">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDivision}
                onChange={(e) => setDivision(e.target.value)}
              >
                <option value="">All Sub Companies</option>
                {/* {emp_code.sort((a, b) => a.emp_code - b.emp_code).map((i, index) => (<option value={i.emp_code}>{i.emp_code} - {i.name}</option>))}; */}
                {SubCompany.sort((a, b) => a.title - b.title).map(
                  (i, index) => (
                    <option value={i.title}>{i.title}</option>
                  ),
                )}
                ;
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="table-css-white-background">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500    font-size-heading">
            Salary Sheet
            {/* <p className='career-para font-size-subheading">Based your performance</p>*/}
          </div>
          <DownloadTableExcel
            filename={
              selectedDivision === ""
                ? `BankFormatSheet-${monthh}-${yearr}`
                : `${selectedDivision}-BankFormatSheet-${monthh}-${yearr}`
            }
            // filename={`BankFormatSheet-${monthh}-${yearr}`}
            sheet="users"
            currentTableRef={tableRef.current}
          >
            <button className=" model-button-print">
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30" height="30"
                viewBox="0 0 24 24"
                fill='#fff'
                id="print">
                <path fill="none" d="M0 0h24v24H0V0z"></path>
                <path d="M19 8H5c-1.66 0-3 1.34-3 3v4c0 1.1.9 2 2 2h2v2c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2h2c1.1 0 2-.9 2-2v-4c0-1.66-1.34-3-3-3zm-4 11H9c-.55 0-1-.45-1-1v-4h8v4c0 .55-.45 1-1 1zm4-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2-9H7c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"></path>
              </svg> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                id="download"
                fill="#fff"
              >
                <g
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                </g>
              </svg>
              {/* Download as Excel */}
            </button>
          </DownloadTableExcel>
        </div>
        <table ref={tableRef} className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">S.No.</th>
              <th className="align-center">Emp Code</th>
              <th className="align-center">Name</th>
              <th className="align-center">Department</th>
              <th className="align-center">Position</th>
              <th className="align-center">Total Days</th>
              <th className="align-center">Total Salary</th>
              <th className="align-center">View</th>
              {/* <th className="align-center">Action</th> */}
            </tr>
          </thead>

          {buffer ? (
            <div className="spinner"></div> //buffering logic
          ) : (
            <tbody>
              {monthlylistfilter
                // .filter((e) =>
                //   e.name.toLowerCase().includes(searchQuery.toLowerCase())
                // )
                // .sort((a, b) => Date(a.date) - Date(b.date))
                .map((i, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr className="tr-border-bottom">
                        <td colSpan="6"></td>
                      </tr>
                      <tr className="custom-table-head-tdd">
                        <td className="align-left">{index + 1}</td>
                        <td className="align-center">{i.emp_code}</td>
                        <td className="align-center">{i.user_details.name}</td>
                        <td className="align-center">
                          {i.user_details.department_name}
                        </td>
                        <td className="align-center">
                          {i.user_details.designation_name}
                        </td>
                        <td className="align-center">{i.calculation}</td>
                        <td className="align-center">{i.salarypay}</td>
                        <td className="align-center">
                          <button
                            className="allproject-dashboard"
                            title="View using Navigate"
                            onClick={(e) => OneSalarySlip(i, monthh, yearr)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="40"
                              height="40"
                              viewBox="0 0 30 30"
                              fill="none"
                            >
                              <circle cx="15" cy="15" r="15" fill="#F6F7F9" />
                              <path
                                d="M23.8913 14.5437C22.1966 11.2372 18.8416 9 15 9C11.1584 9 7.80249 11.2388 6.10873 14.5441C6.03725 14.6855 6 14.8417 6 15.0002C6 15.1586 6.03725 15.3148 6.10873 15.4563C7.80342 18.7628 11.1584 21 15 21C18.8416 21 22.1975 18.7612 23.8913 15.4559C23.9628 15.3145 24 15.1583 24 14.9998C24 14.8414 23.9628 14.6852 23.8913 14.5437ZM15 19.5C14.11 19.5 13.24 19.2361 12.4999 18.7416C11.7599 18.2471 11.1831 17.5443 10.8425 16.7221C10.5019 15.8998 10.4128 14.995 10.5865 14.1221C10.7601 13.2492 11.1887 12.4474 11.818 11.818C12.4474 11.1887 13.2492 10.7601 14.1221 10.5865C14.995 10.4128 15.8998 10.5019 16.7221 10.8425C17.5443 11.1831 18.2472 11.7599 18.7416 12.4999C19.2361 13.24 19.5 14.11 19.5 15C19.5003 15.591 19.3841 16.1763 19.1581 16.7224C18.932 17.2685 18.6005 17.7647 18.1826 18.1826C17.7647 18.6005 17.2685 18.932 16.7224 19.158C16.1763 19.3841 15.591 19.5003 15 19.5ZM15 12C14.7322 12.0037 14.4662 12.0436 14.2091 12.1184C14.421 12.4065 14.5227 12.7609 14.4957 13.1175C14.4688 13.4741 14.3149 13.8092 14.062 14.062C13.8092 14.3149 13.4741 14.4688 13.1175 14.4957C12.7609 14.5227 12.4065 14.421 12.1184 14.2091C11.9544 14.8133 11.984 15.4538 12.2031 16.0403C12.4221 16.6269 12.8196 17.1299 13.3396 17.4787C13.8595 17.8275 14.4758 18.0045 15.1016 17.9847C15.7274 17.965 16.3312 17.7495 16.8281 17.3685C17.325 16.9876 17.6899 16.4604 17.8715 15.8612C18.0531 15.2621 18.0422 14.621 17.8404 14.0283C17.6386 13.4356 17.256 12.9211 16.7465 12.5573C16.2369 12.1934 15.6261 11.9985 15 12Z"
                                fill="#2576BC"
                              />
                            </svg>
                          </button>
                        </td>
                        {/* <td className="align-center">
                                                Action
                                            </td> */}
                      </tr>
                    </React.Fragment>
                  );
                })}
            </tbody>
          )}
        </table>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

const BankSubmitFormat = () => {
  const [selectedRemark, setRemark] = useState("");
  const [buffer, setBuffering] = useState(false); //buffering logic

  const location = useLocation();

  const today = new Date();
  // today.setDate(today.getDate() - 1);
  const day = today.getDate();
  const currentMonth = (today.getMonth() + 1).toString();
  const currentYear = today.getFullYear().toString();

  const [startMonth, setStartMonth] = useState(currentMonth);
  const [startYear, setStartYear] = useState(currentYear);

  const [endMonth, setEndMonth] = useState(currentMonth);
  const [endYear, setEndYear] = useState(currentYear);

  const startDateValue = `${startYear}-${startMonth.padStart(2, "0")}`;
  const endDateValue = `${endYear}-${endMonth.padStart(2, "0")}`;

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const monthShortNames = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const formattedDate = `${currentYear}-${currentMonth.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
  var datearray = formattedDate.split("-");

  var newdate = datearray[0] + "-" + datearray[1] + "-" + datearray[2];

  const [bankFormat, setbankFormat] = useState([]);
  const [bankFormatfilter, setbankFormatfilter] = useState([]);

  const [selectedName, setName] = useState("");
  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company_id")}`,
  );

  // const [searchQuery, setSearchQuery] = useState("");

  const getSalarylist = async () => {
    setBuffering(true); //buffering logic
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/getsalaryslipmain/${startMonth}/${startYear}/${selectedDivision}/`,
        // `${BASE_URL}/wfm/bankformat/${yearr}/${monthh}/`
      );
      // setbankFormat(res.data);
      setbankFormat(res.data.salary_data);
    } catch (err) {
      handleAllError(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };
  const [SubCompany, setSubCompany] = useState([]);

  const getSubCompany = async () => {
    // setBuffering(true); //buffering logic
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {}
  };

  const applyFilters = () => {
    let filteredData = bankFormat;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();
      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee.name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return nameMatch;
      });
    }
    setbankFormatfilter(filteredData);
  };

  useEffect(() => {
    getSubCompany();
    getSalarylist();
  }, [startMonth, startYear]);

  useEffect(() => {
    applyFilters();
  }, [
    bankFormat,
    // bankFormatfilter,
    selectedName,
    selectedRemark,
  ]);

  // ?  ************** Put Request Start **************  ! //
  const tableRef = useRef(null);

  // Helper to format date as DDMM
  const getFormattedDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Adjust for 0-based month
    return `${day}${month}`;
  };

  const customformattedDate = getFormattedDate();

  const handleDownloadBankSheet = () => {
    // downloadAsExcel(tableRef, "users", selectedDivision === "" ? `BankFormatSheet-${monthh}-${yearr}` : `${selectedDivision}-BankFormatSheet-${monthh}-${yearr}`);
    downloadAsExcel(
      tableRef,
      "Sheet1",
      `4051RBI${customformattedDate}.entrycount.xls`,
    );
  };

  const mockData = [
    // Transaction Type 'R' (Salary > 200000)
    {
      name: "Alice Johnson",
      salarypay: 300000,
      bank_details: {
        bank: "ICICI",
        account_number: "123456789012",
        ifsc_code: "ICIC0001234",
      },
      department_name: "Engineering",
      position_name: "Lead Engineer",
      transaction_date: "2024-09-01",
      email: "alice.johnson@example.com",
    },
    {
      name: "Bob Smith",
      salarypay: 250000,
      bank_details: {
        bank: "SBI",
        account_number: "123987654321",
        ifsc_code: "SBI0002345",
      },
      department_name: "Marketing",
      position_name: "Marketing Manager",
      transaction_date: "2024-09-02",
      email: "bob.smith@example.com",
    },

    // Transaction Type 'I' (Bank is HDFC)
    {
      name: "Chris Evans",
      salarypay: 150000,
      bank_details: {
        bank: "HDFC",
        account_number: "345678901234",
        ifsc_code: "HDFC0003456",
      },
      department_name: "Sales",
      position_name: "Sales Executive",
      transaction_date: "2024-09-03",
      email: "chris.evans@example.com",
    },
    {
      name: "Diana Prince",
      salarypay: 180000,
      bank_details: {
        bank: "HDFC",
        account_number: "456789012345",
        ifsc_code: "HDFC0004567",
      },
      department_name: "Finance",
      position_name: "Finance Specialist",
      transaction_date: "2024-09-04",
      email: "diana.prince@example.com",
    },

    // Transaction Type 'N' (Other Banks and Salary <= 200000)
    {
      name: "Eve Adams",
      salarypay: 120000,
      bank_details: {
        bank: "Axis Bank",
        account_number: "567890123456",
        ifsc_code: "UTIB0005678",
      },
      department_name: "HR",
      position_name: "HR Coordinator",
      transaction_date: "2024-09-05",
      email: "eve.adams@example.com",
    },
    {
      name: "Frank Lee",
      salarypay: 90000,
      bank_details: {
        bank: "Canara Bank",
        account_number: "678901234567",
        ifsc_code: "CNRB0006789",
      },
      department_name: "IT",
      position_name: "IT Support",
      transaction_date: "2024-09-06",
      email: "frank.lee@example.com",
    },
  ];

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500    font-size-heading"></div>

        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <input
                type="month"
                className="attendance-input-field calender-input width-10vw"
                value={startDateValue}
                max={endDateValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    const [year, month] = value.split("-");
                    setStartYear(year);
                    setStartMonth(month.replace(/^0+/, ""));
                  }
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-15vw  "
                placeholder="Name"
                type="text"
                value={selectedName}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>

          <button
            className=" model-button-print"
            onClick={handleDownloadBankSheet}
          >
            <DownloadIcon />
          </button>
        </div>
      </div>
      <div className="table-css-white-background">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500    font-size-heading">
            Bank Format
            {/* <p className='career-para font-size-subheading">Based your performance</p>          */}
          </div>
        </div>
        <table ref={tableRef} className="nested-table-modern">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">
                Transaction Type (N – NFET, R – RTGS & I - Fund Transfer in HDFC
                Bank account)
              </th>
              <th className="align-left">
                Beneficiary Code (Mandatory In case of Fund Transfer only)
              </th>
              <th className="align-left">Beneficiary Account Number</th>
              <th className="align-left">Instrument Amount</th>
              <th className="align-left">
                Beneficiary Name (Upto 40 character without any special
                character)
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Drawee Location
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Print Location
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Bene Address 1
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Bene Address 2
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Bene Address 3
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Bene Address 4
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Bene Address 5
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Instruction Reference Number
              </th>
              <th className="align-left">
                Customer Reference Number(Which needs to be reflected in
                statement upto character upto 20)
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Payment details 1
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Payment details 2
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Payment details 3
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Payment details 4
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Payment details 5
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Payment details 6
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Payment details 7
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Cheque Number
              </th>
              <th className="align-left">Chq / Trn Date (DD/MM/YYYY)</th>
              <th className="align-left" style={{ display: "none" }}>
                MICR Number
              </th>
              <th className="align-left">IFSC Code</th>
              <th className="align-left" style={{ display: "none" }}>
                Bene Bank Name
              </th>
              <th className="align-left" style={{ display: "none" }}>
                Bene Bank Branch Name
              </th>
              <th className="align-left">Beneficiary email id</th>
            </tr>
          </thead>
          {buffer ? (
            <div className="spinner"></div>
          ) : (
            <tbody>
              {bankFormatfilter?.map((i, index) => {
                // const transaction_type = (i?.salary_data?.deduction_details.find((j) => j.final_salary === true)?.actual_amount) > 200000 ? 'R' : (i.bank_details?.bank_name?.toLowerCase().includes('hdfc')) ? 'I' : 'N';
                const transaction_type =
                  i?.salary_data?.deduction_details.find(
                    (j) => j.final_salary === true,
                  )?.actual_amount > 200000
                    ? "R"
                    : !i.bank_details?.bank_name
                      ? "error"
                      : i.bank_details?.bank_name
                            ?.toLowerCase()
                            .includes("hdfc")
                        ? "I"
                        : "N";

                const salarypay = i?.salary_data?.deduction_details.find(
                  (j) => j.final_salary === true,
                )?.actual_amount;

                return (
                  <React.Fragment key={index}>
                    <tr className="custom-table-row">
                      <td
                        className="align-left"
                        title={`${i.bank_details?.bank_name}`}
                      >
                        {transaction_type === "error" ? (
                          <p className="error-message font-size-text">
                            Incomplete Bank Details
                          </p>
                        ) : (
                          transaction_type
                        )}
                      </td>
                      {/* I === Bank = HDFC */}
                      {/* N === Bank = Other Banks */}
                      {/* R === Bank = i.salarypay > 2Lakh*/}
                      <td className="align-left">
                        {transaction_type === "error" ? (
                          <p className="error-message font-size-text">
                            Incomplete Bank Details
                          </p>
                        ) : transaction_type === "I" ? (
                          i.bank_details?.account_number ? (
                            i.bank_details?.account_number
                          ) : (
                            <p className="error-message font-size-text">
                              Incomplete Bank Details
                            </p>
                          )
                        ) : null}
                      </td>
                      <td className="align-left">
                        {i.bank_details?.account_number ? (
                          i.bank_details?.account_number
                        ) : (
                          <p className="error-message font-size-text">
                            Incomplete Bank Details
                          </p>
                        )}
                      </td>
                      <td className="align-left">{salarypay}</td>
                      <td className="align-left">{i.emp_data?.name}</td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Drawee Location */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Print Location */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Bene Address 1 */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Bene Address 2 */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Bene Address 3 */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Bene Address 4 */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Bene Address 5 */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Instruction Reference Number */}
                      </td>
                      <td className="align-left">
                        {i.remarks ||
                          `Salary ${monthShortNames[startMonth - 1]} ${startYear}`}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Payment details 1 */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Payment details 2 */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Payment details 3 */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Payment details 4 */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Payment details 5 */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Payment details 6 */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Payment details 7 */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Cheque Number */}
                      </td>
                      <td className="align-left">
                        {formatDateDDMMYYYY(formattedDate)}
                      </td>
                      {/* <td className="align-left">{i.transaction_date ? formatDateDDMMYYYY(i.transaction_date) : null}</td> */}
                      <td className="align-left" style={{ display: "none" }}>
                        {/* MICR Number */}
                      </td>
                      <td className="align-left">
                        {transaction_type === "error" ? (
                          <p className="error-message font-size-text">
                            Incomplete Bank Details
                          </p>
                        ) : transaction_type === "N" ? (
                          i.bank_details?.ifsc_code ? (
                            i.bank_details?.ifsc_code
                          ) : (
                            <p className="error-message font-size-text">
                              Incomplete Bank Details
                            </p>
                          )
                        ) : null}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Bene Bank Name */}
                      </td>
                      <td className="align-left" style={{ display: "none" }}>
                        {/* Bene Bank Branch Name */}
                      </td>
                      <td className="align-left">{i.emp_data?.user_detail}</td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          )}
        </table>
      </div>
    </>
  );
};

const IncrementsDetails = () => {
  const [emp_codes, setEmp_codes] = useState([]);

  const location = useLocation();

  let filters_subCompany =
    location.state?.filter_subCompany !== null
      ? location.state?.filter_subCompany
      : `${sessionStorage.getItem("company_id")}`;
  let filters_empstatus =
    location.state?.filter_empstatus !== null
      ? location.state?.filter_empstatus
      : "active";
  let filters_employee =
    location.state?.filter_employee !== null
      ? location.state?.filter_employee
      : "null";
  let filters_start_date =
    location.state?.filter_start_date !== null
      ? location.state?.filter_start_date
      : "null";
  let filters_end_date =
    location.state?.filter_end_date !== null
      ? location.state?.filter_end_date
      : "null";
  let filters_date_sorting =
    location.state?.filter_date_sorting !== null
      ? location.state?.filter_date_sorting
      : "desc_wef";

  // const [designationname, setDesignationList] = useState([]);
  // const [departmentname, setDepartmentList] = useState([]);

  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

  const [buffer1, setBuffering1] = useState(false);
  const [buffer, setBuffering] = useState(false);
  const [monthlylist, setMonthlylist] = useState([]);
  const [filteredDataList, setfilteredDataList] = useState([]);

  const [toggleSubCompany, setToggleSubCompany] = useState(
    filters_subCompany || sessionStorage.getItem("company_id"),
  );
  const [active, setActive] = useState(filters_empstatus || "active");

  const [selectedEmpcode, setSelectedEmpcode] = useState(
    filters_employee || `null`,
  );
  const [dateSorting, setDateSorting] = useState(
    filters_date_sorting || "desc_wef",
  );
  const [startDate, setStartDate] = useState(filters_start_date || "null");
  const [endDate, setEndDate] = useState(filters_end_date || "null");
  const [selectedName, setName] = useState("");
  const [selectedDep, setDep] = useState("null");
  const [selectedDesi, setDesi] = useState("");
  const [selectedCompanyName, setSelectedCompanyName] = useState(
    sessionStorage.getItem("company"),
  );

  const getFilterData = async () => {
    setBuffering1(true);
    try {
      // const des = await axios.get(`${BASE_URL}/wfm/designationfilterbysubcompanycount/${toggleSubCompany}/${active}/`);
      // const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${toggleSubCompany}/${active}/`);
      const emp = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${toggleSubCompany}/`,
      );
      // setDesignationList(des.data);
      // setDepartmentList(dep.data);
      const sortedList = customSortByKey(emp.data, "emp_code");
      setEmp_codes(sortedList);
    } catch (err) {
      console.error("Error fetching designations/departments/employees", err);
    } finally {
      setBuffering1(false);
    }
  };

  const getIncrementslist = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/incrementfilter/${toggleSubCompany}/${active}/${selectedDep}/${selectedEmpcode}/${startDate}/${endDate}/`,
      );
      const sortedList = customSortByKey(res.data, "empcode");

      let filteredData = sortedList;

      switch (dateSorting) {
        case "asc_wef":
          filteredData = filteredData.sort(
            (a, b) => new Date(a.wefdate) - new Date(b.wefdate),
          );
          break;
        case "desc_wef":
          filteredData = filteredData.sort(
            (a, b) => new Date(b.wefdate) - new Date(a.wefdate),
          );
          break;
        // case "asc_update":
        //   filteredData = filteredData.sort((a, b) => new Date(a.upload_datetime) - new Date(b.upload_datetime));
        //   break;
        // case "desc_update":
        //   filteredData = filteredData.sort((a, b) => new Date(b.upload_datetime) - new Date(a.upload_datetime));
        //   break;
        case "asc_update":
          filteredData = filteredData.sort((a, b) => {
            if (a.upload_datetime && b.upload_datetime) {
              return new Date(a.upload_datetime) - new Date(b.upload_datetime);
            }
            if (!a.upload_datetime && b.upload_datetime) {
              return -1;
            }
            if (a.upload_datetime && !b.upload_datetime) {
              return 1;
            }
            return new Date(a.wefdate) - new Date(b.wefdate);
          });
          break;
        case "desc_update":
          filteredData = filteredData.sort((a, b) => {
            if (a.upload_datetime && b.upload_datetime) {
              return new Date(b.upload_datetime) - new Date(a.upload_datetime);
            }
            if (a.upload_datetime && !b.upload_datetime) {
              return -1;
            }
            if (!a.upload_datetime && b.upload_datetime) {
              return 1;
            }
            return new Date(b.wefdate) - new Date(a.wefdate);
          });
          break;

        default:
          filteredData = filteredData;
          break;
      }
      setMonthlylist(filteredData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  const applyFilters = () => {
    let filteredData = monthlylist;

    // if (selectedEmpcode !== 'null') {
    //   const lowercaseSelectedName = selectedEmpcode?.toLowerCase();
    //   filteredData = filteredData.filter((employee) => {
    //     const codeMatch = employee.empcode?.toLowerCase() === lowercaseSelectedName;
    //     return codeMatch;
    //   });
    // }

    // if (selectedDep) {
    //   filteredData = filteredData.filter(
    //     (employee) => employee.department === selectedDep
    //   );
    // }

    setfilteredDataList(filteredData);
  };

  useEffect(() => {
    getIncrementslist();
  }, [
    toggleSubCompany,
    active,
    selectedEmpcode,
    startDate,
    endDate,
    dateSorting,
    selectedDep,
  ]);

  useEffect(() => {
    getFilterData();
  }, [toggleSubCompany, active]);

  useEffect(() => {
    applyFilters();
  }, [monthlylist]);

  const options = emp_codes
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOption = { value: "null", label: "Select Employee Code" };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      // Set selected employee code(s)
      setSelectedEmpcode(selectedOption.value);
    } else {
      setSelectedEmpcode(null); // Clear selection
    }
  };

  const handleDateSortChange = (e) => setDateSorting(e.target.value);

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const baseUrl = "/" + urlParts[3] + "/letterhead";

  const opener = "payroll";

  let filter_subCompany = toggleSubCompany;
  let filter_empstatus = active;
  let filter_employee = selectedEmpcode;
  let filter_start_date = startDate;
  let filter_end_date = endDate;
  let filter_date_sorting = dateSorting;

  const ViewIncrementLetter = (
    emp_code,
    lettertype,
    index,
    letterid,
    opener,
  ) => {
    navigate(baseUrl, {
      state: {
        emp_code,
        lettertype,
        index,
        letterid,
        opener,
        filter_subCompany,
        filter_empstatus,
        filter_employee,
        filter_start_date,
        filter_end_date,
        filter_date_sorting,
      },
    });
  };

  const tableRef = useRef(null);
  const handleDownloadIncrementsSheet = () => {
    downloadAsExcel(
      tableRef,
      "users",
      toggleSubCompany === "null"
        ? `Increments Details`
        : `${SUB_COMPANIES.find((company) => company.id === toggleSubCompany).title} - Increments Details`,
    );
  };

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500    font-size-heading"></div>
        <div className="attendance-subcont">
          <div className="field-cont">
            {SUPER_ADMIN ? (
              <div className="field-cont-div">
                <Office />
                <select
                  // onChange={(e) => setToggleSubCompany(e.target.value)}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    setToggleSubCompany(selectedId);

                    const selectedCompany = SUB_COMPANIES.find(
                      (company) => company.id === selectedId,
                    );

                    if (selectedCompany) {
                      setSelectedCompanyName(selectedCompany.title);
                    } else {
                      setSelectedCompanyName(""); // or null based on your logic
                    }
                  }}
                  value={toggleSubCompany}
                  className="attendance-input-field width-10vw  "
                >
                  <option value="null">Select Sub Company</option>
                  {SUB_COMPANIES.map((company) => (
                    <option value={company.id}>{company.title}</option>
                  ))}
                  ;
                </select>

                <hr className="field-cont-hr" />
              </div>
            ) : null}

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-15vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All Employees</option>
                <option value="active">Active Employees</option>
                <option value="inactive">Inactive Employees</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            {/* <div className="field-cont-div">
              <CircularGrid />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDep}
                onChange={(e) => setDep(e.target.value)}
              >
                <option value=""> All Department</option>
                {departmentname
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.title}>{i.title}</option>
                  ))}
              </select>
              <hr className="field-cont-hr" />
            </div>  */}

            <div title="Employee Filter" className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall" /> : <Employee />}
              <Select
                className="attendance-input-field width-20vw"
                width="200px"
                options={[nullOption, ...options]} // Include "null" option at the beginning
                value={
                  options.find((option) => option.value === selectedEmpcode) ||
                  nullOption
                } // Ensure the correct option is selected
                placeholder="Select Employee Code"
                onChange={handleChange}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>

            <div title=" Date Range" className="field-cont-div ">
              <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                placeHolder1="From Date"
                placeHolder2="To Date"
                onChange={(start, end) => {
                  setStartDate(start ?? "null");
                  setEndDate(end ?? "null");
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            <div title="Sort Filter" className="field-cont-div">
              <Sort />
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={dateSorting}
                onChange={handleDateSortChange}
              >
                <option value="null">No Date Filter</option>
                <option value="asc_wef">Oldest WEF Date</option>
                <option value="desc_wef">Latest WEF Date</option>
                <option value="asc_update">Oldest Uploaded Date</option>
                <option value="desc_update">Latest Uploaded Date</option>
              </select>
              <hr className="field-cont-hr" />
            </div>
          </div>
          <div className="btn-cont">
            <UploadIncrementDataBulk getDatalist={getIncrementslist} />
            <button
              className=" model-button-print"
              title="Download in Excel Format"
              onClick={handleDownloadIncrementsSheet}
            >
              <DownloadIcon />
            </button>
          </div>
        </div>
      </div>

      <div className="custom-table-width">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500    font-size-heading">
            Employee Increments
          </div>
        </div>
        {/* <div className="global-whitebg-table"> */}
        <div className="scrollfix-wrapper">
          <table ref={tableRef} className="scrollfix-table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Emp Code</th>
                <th className="align-center">Name</th>
                <th className="align-center">Department</th>
                <th className="align-center">WEF Date</th>
                <th className="align-center">Letter Type</th>
                <th className="align-center">Existing CTC</th>
                <th className="align-center">Increment Percentage</th>
                <th className="align-center">Increment Amount</th>
                <th className="align-center">Revised CTC</th>
                {/* <th className="align-center">Old Designation</th>
                <th className="align-center">New Designation</th> */}
                <th className="align-center">Designation Change</th>
                {/* <th className="align-center">Old Grade</th>
                <th className="align-center">New Grade</th> */}
                <th className="align-center">Grade Change</th>
                <th className="align-center">Edit</th>
                <th className="align-center">View Letter</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {filteredDataList
                  // .sort((a, b) => new Date(b.wefdate) - new Date(a.wefdate))
                  .map((employee, index) => {
                    return (
                      <tr key={index}>
                        <td className="align-left">{employee.empcode}</td>
                        <td className="align-center">
                          {employee.emp_name || "-"}
                        </td>
                        <td className="align-center">
                          {employee.department_name || "-"}
                        </td>
                        <td className="align-center">
                          {formattedDateLong(employee.wefdate) || "-"}
                        </td>
                        <td className="align-center">
                          {employee.letter_type || "-"}
                        </td>
                        <td className="align-center">
                          {formatCurrencyIndian(employee.existing_ctc) || "-"}
                        </td>
                        <td className="align-center">
                          {`${employee.increment_percentage}%` || "-"}
                        </td>
                        <td className="align-center">
                          {formatCurrencyIndian(employee.increment_amount) ||
                            "-"}
                        </td>
                        <td className="align-center">
                          {formatCurrencyIndian(employee.revised_ctc) || "-"}
                        </td>
                        {/* <td className="align-center">{employee.old_designation || '-'}</td>
                        <td className="align-center">{employee.updated_designation || '-'}</td> */}
                        <td className="align-center">
                          {employee.old_designation || "-"}
                          {employee.updated_designation &&
                            employee.updated_designation !==
                              employee.old_designation && (
                              <>
                                <br />
                                <b>{"->"}</b>
                                <br />
                                {employee.updated_designation}
                              </>
                            )}
                        </td>
                        {/* <td className="align-center">{employee.previous_grade || '-'}</td>
                        <td className="align-center">{employee.update_grade || '-'}</td> */}
                        <td className="align-center">
                          {employee.previous_grade || "-"}
                          {employee.update_grade &&
                            employee.update_grade !==
                              employee.previous_grade && (
                              <>
                                {"->"}
                                {employee.update_grade}
                              </>
                            )}
                        </td>
                        <td className="align-center">
                          <EditIncrementData
                            i={employee}
                            subCompany={toggleSubCompany}
                            subCompanyName={selectedCompanyName}
                            getIncrementslist={getIncrementslist}
                          />
                        </td>
                        <td className="align-center">
                          <button
                            className="allproject-dashboard"
                            title="View Upcoming Slip"
                            onClick={(e) =>
                              ViewIncrementLetter(
                                employee.empcode,
                                employee.letter_type,
                                employee.empcode,
                                employee.id,
                                opener,
                              )
                            }
                          >
                            <Eye />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            )}
          </table>
        </div>
        {/* </div> */}
      </div>
      <ToastContainer
        position="top-center"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export {
  PayRollTable,
  TaxCalculationTable,
  EmployeeDetails,
  BankFormat,
  PrintFormat,
  BankSubmitFormat,
  IncrementsDetails,
};
